var Pd = Object.defineProperty;
var Bd = (n, e, t) => e in n ? Pd(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var nn = (n, e, t) => Bd(n, typeof e != "symbol" ? e + "" : e, t);
import { QueryClient as Od, setupBankExtension as Ci, setupStakingExtension as Ui, setupDistributionExtension as Hi, createProtobufRpcClient as xd, AminoTypes as Rd } from "@cosmjs/stargate";
import { Tendermint34Client as Ed } from "@cosmjs/tendermint-rpc";
import { Registry as Jd } from "@cosmjs/proto-signing";
function Id() {
  let n = 0, e = 0;
  for (let o = 0; o < 28; o += 7) {
    let r = this.buf[this.pos++];
    if (n |= (r & 127) << o, (r & 128) == 0)
      return this.assertBounds(), [n, e];
  }
  let t = this.buf[this.pos++];
  if (n |= (t & 15) << 28, e = (t & 112) >> 4, (t & 128) == 0)
    return this.assertBounds(), [n, e];
  for (let o = 3; o <= 31; o += 7) {
    let r = this.buf[this.pos++];
    if (e |= (r & 127) << o, (r & 128) == 0)
      return this.assertBounds(), [n, e];
  }
  throw new Error("invalid varint");
}
function Ve(n, e, t) {
  for (let i = 0; i < 28; i = i + 7) {
    const h = n >>> i, p = !(!(h >>> 7) && e == 0), b = (p ? h | 128 : h) & 255;
    if (t.push(b), !p)
      return;
  }
  const o = n >>> 28 & 15 | (e & 7) << 4, r = e >> 3 != 0;
  if (t.push((r ? o | 128 : o) & 255), !!r) {
    for (let i = 3; i < 31; i = i + 7) {
      const h = e >>> i, p = !!(h >>> 7), b = (p ? h | 128 : h) & 255;
      if (t.push(b), !p)
        return;
    }
    t.push(e >>> 31 & 1);
  }
}
const Oe = 4294967296;
function _i(n) {
  const e = n[0] === "-";
  e && (n = n.slice(1));
  const t = 1e6;
  let o = 0, r = 0;
  function i(h, p) {
    const b = Number(n.slice(h, p));
    r *= t, o = o * t + b, o >= Oe && (r = r + (o / Oe | 0), o = o % Oe);
  }
  return i(-24, -18), i(-18, -12), i(-12, -6), i(-6), e ? ys(o, r) : Ke(o, r);
}
function Cd(n, e) {
  let t = Ke(n, e);
  const o = t.hi & 2147483648;
  o && (t = ys(t.lo, t.hi));
  const r = Ts(t.lo, t.hi);
  return o ? "-" + r : r;
}
function Ts(n, e) {
  if ({ lo: n, hi: e } = Ud(n, e), e <= 2097151)
    return String(Oe * e + n);
  const t = n & 16777215, o = (n >>> 24 | e << 8) & 16777215, r = e >> 16 & 65535;
  let i = t + o * 6777216 + r * 6710656, h = o + r * 8147497, p = r * 2;
  const b = 1e7;
  return i >= b && (h += Math.floor(i / b), i %= b), h >= b && (p += Math.floor(h / b), h %= b), p.toString() + Mi(h) + Mi(i);
}
function Ud(n, e) {
  return { lo: n >>> 0, hi: e >>> 0 };
}
function Ke(n, e) {
  return { lo: n | 0, hi: e | 0 };
}
function ys(n, e) {
  return e = ~e, n ? n = ~n + 1 : e += 1, Ke(n, e);
}
const Mi = (n) => {
  const e = String(n);
  return "0000000".slice(e.length) + e;
};
function Di(n, e) {
  if (n >= 0) {
    for (; n > 127; )
      e.push(n & 127 | 128), n = n >>> 7;
    e.push(n);
  } else {
    for (let t = 0; t < 9; t++)
      e.push(n & 127 | 128), n = n >> 7;
    e.push(1);
  }
}
function Hd() {
  let n = this.buf[this.pos++], e = n & 127;
  if ((n & 128) == 0)
    return this.assertBounds(), e;
  if (n = this.buf[this.pos++], e |= (n & 127) << 7, (n & 128) == 0)
    return this.assertBounds(), e;
  if (n = this.buf[this.pos++], e |= (n & 127) << 14, (n & 128) == 0)
    return this.assertBounds(), e;
  if (n = this.buf[this.pos++], e |= (n & 127) << 21, (n & 128) == 0)
    return this.assertBounds(), e;
  n = this.buf[this.pos++], e |= (n & 15) << 28;
  for (let t = 5; (n & 128) !== 0 && t < 10; t++)
    n = this.buf[this.pos++];
  if ((n & 128) != 0)
    throw new Error("invalid varint");
  return this.assertBounds(), e >>> 0;
}
const Tn = /* @__PURE__ */ _d();
function _d() {
  const n = new DataView(new ArrayBuffer(8));
  if (typeof BigInt == "function" && typeof n.getBigInt64 == "function" && typeof n.getBigUint64 == "function" && typeof n.setBigInt64 == "function" && typeof n.setBigUint64 == "function" && (typeof process != "object" || typeof process.env != "object" || process.env.BUF_BIGINT_DISABLE !== "1")) {
    const t = BigInt("-9223372036854775808"), o = BigInt("9223372036854775807"), r = BigInt("0"), i = BigInt("18446744073709551615");
    return {
      zero: BigInt(0),
      supported: !0,
      parse(h) {
        const p = typeof h == "bigint" ? h : BigInt(h);
        if (p > o || p < t)
          throw new Error(`invalid int64: ${h}`);
        return p;
      },
      uParse(h) {
        const p = typeof h == "bigint" ? h : BigInt(h);
        if (p > i || p < r)
          throw new Error(`invalid uint64: ${h}`);
        return p;
      },
      enc(h) {
        return n.setBigInt64(0, this.parse(h), !0), {
          lo: n.getInt32(0, !0),
          hi: n.getInt32(4, !0)
        };
      },
      uEnc(h) {
        return n.setBigInt64(0, this.uParse(h), !0), {
          lo: n.getInt32(0, !0),
          hi: n.getInt32(4, !0)
        };
      },
      dec(h, p) {
        return n.setInt32(0, h, !0), n.setInt32(4, p, !0), n.getBigInt64(0, !0);
      },
      uDec(h, p) {
        return n.setInt32(0, h, !0), n.setInt32(4, p, !0), n.getBigUint64(0, !0);
      }
    };
  }
  return {
    zero: "0",
    supported: !1,
    parse(t) {
      return typeof t != "string" && (t = t.toString()), Vi(t), t;
    },
    uParse(t) {
      return typeof t != "string" && (t = t.toString()), Fi(t), t;
    },
    enc(t) {
      return typeof t != "string" && (t = t.toString()), Vi(t), _i(t);
    },
    uEnc(t) {
      return typeof t != "string" && (t = t.toString()), Fi(t), _i(t);
    },
    dec(t, o) {
      return Cd(t, o);
    },
    uDec(t, o) {
      return Ts(t, o);
    }
  };
}
function Vi(n) {
  if (!/^-?[0-9]+$/.test(n))
    throw new Error("invalid int64: " + n);
}
function Fi(n) {
  if (!/^[0-9]+$/.test(n))
    throw new Error("invalid uint64: " + n);
}
const Fe = Symbol.for("@bufbuild/protobuf/text-encoding");
function ws() {
  if (globalThis[Fe] == null) {
    const n = new globalThis.TextEncoder(), e = new globalThis.TextDecoder();
    globalThis[Fe] = {
      encodeUtf8(t) {
        return n.encode(t);
      },
      decodeUtf8(t) {
        return e.decode(t);
      },
      checkUtf8(t) {
        try {
          return encodeURIComponent(t), !0;
        } catch {
          return !1;
        }
      }
    };
  }
  return globalThis[Fe];
}
var xn;
(function(n) {
  n[n.Varint = 0] = "Varint", n[n.Bit64 = 1] = "Bit64", n[n.LengthDelimited = 2] = "LengthDelimited", n[n.StartGroup = 3] = "StartGroup", n[n.EndGroup = 4] = "EndGroup", n[n.Bit32 = 5] = "Bit32";
})(xn || (xn = {}));
const Md = 34028234663852886e22, Dd = -34028234663852886e22, Vd = 4294967295, Fd = 2147483647, Ld = -2147483648;
class g {
  constructor(e = ws().encodeUtf8) {
    this.encodeUtf8 = e, this.stack = [], this.chunks = [], this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */
  finish() {
    this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []);
    let e = 0;
    for (let r = 0; r < this.chunks.length; r++)
      e += this.chunks[r].length;
    let t = new Uint8Array(e), o = 0;
    for (let r = 0; r < this.chunks.length; r++)
      t.set(this.chunks[r], o), o += this.chunks[r].length;
    return this.chunks = [], t;
  }
  /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */
  fork() {
    return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
  }
  /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */
  join() {
    let e = this.finish(), t = this.stack.pop();
    if (!t)
      throw new Error("invalid state, fork stack empty");
    return this.chunks = t.chunks, this.buf = t.buf, this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */
  tag(e, t) {
    return this.uint32((e << 3 | t) >>> 0);
  }
  /**
   * Write a chunk of raw bytes.
   */
  raw(e) {
    return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(e), this;
  }
  /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */
  uint32(e) {
    for (Li(e); e > 127; )
      this.buf.push(e & 127 | 128), e = e >>> 7;
    return this.buf.push(e), this;
  }
  /**
   * Write a `int32` value, a signed 32 bit varint.
   */
  int32(e) {
    return Le(e), Di(e, this.buf), this;
  }
  /**
   * Write a `bool` value, a variant.
   */
  bool(e) {
    return this.buf.push(e ? 1 : 0), this;
  }
  /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */
  bytes(e) {
    return this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */
  string(e) {
    let t = this.encodeUtf8(e);
    return this.uint32(t.byteLength), this.raw(t);
  }
  /**
   * Write a `float` value, 32-bit floating point number.
   */
  float(e) {
    Gd(e);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setFloat32(0, e, !0), this.raw(t);
  }
  /**
   * Write a `double` value, a 64-bit floating point number.
   */
  double(e) {
    let t = new Uint8Array(8);
    return new DataView(t.buffer).setFloat64(0, e, !0), this.raw(t);
  }
  /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */
  fixed32(e) {
    Li(e);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setUint32(0, e, !0), this.raw(t);
  }
  /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */
  sfixed32(e) {
    Le(e);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setInt32(0, e, !0), this.raw(t);
  }
  /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */
  sint32(e) {
    return Le(e), e = (e << 1 ^ e >> 31) >>> 0, Di(e, this.buf), this;
  }
  /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */
  sfixed64(e) {
    let t = new Uint8Array(8), o = new DataView(t.buffer), r = Tn.enc(e);
    return o.setInt32(0, r.lo, !0), o.setInt32(4, r.hi, !0), this.raw(t);
  }
  /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */
  fixed64(e) {
    let t = new Uint8Array(8), o = new DataView(t.buffer), r = Tn.uEnc(e);
    return o.setInt32(0, r.lo, !0), o.setInt32(4, r.hi, !0), this.raw(t);
  }
  /**
   * Write a `int64` value, a signed 64-bit varint.
   */
  int64(e) {
    let t = Tn.enc(e);
    return Ve(t.lo, t.hi, this.buf), this;
  }
  /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64(e) {
    let t = Tn.enc(e), o = t.hi >> 31, r = t.lo << 1 ^ o, i = (t.hi << 1 | t.lo >>> 31) ^ o;
    return Ve(r, i, this.buf), this;
  }
  /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */
  uint64(e) {
    let t = Tn.uEnc(e);
    return Ve(t.lo, t.hi, this.buf), this;
  }
}
class a {
  constructor(e, t = ws().decodeUtf8) {
    this.decodeUtf8 = t, this.varint64 = Id, this.uint32 = Hd, this.buf = e, this.len = e.length, this.pos = 0, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Reads a tag - field number and wire type.
   */
  tag() {
    let e = this.uint32(), t = e >>> 3, o = e & 7;
    if (t <= 0 || o < 0 || o > 5)
      throw new Error("illegal tag: field no " + t + " wire type " + o);
    return [t, o];
  }
  /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */
  skip(e, t) {
    let o = this.pos;
    switch (e) {
      case xn.Varint:
        for (; this.buf[this.pos++] & 128; )
          ;
        break;
      // eslint-disable-next-line
      // @ts-expect-error TS7029: Fallthrough case in switch
      case xn.Bit64:
        this.pos += 4;
      // eslint-disable-next-line no-fallthrough
      case xn.Bit32:
        this.pos += 4;
        break;
      case xn.LengthDelimited:
        let r = this.uint32();
        this.pos += r;
        break;
      case xn.StartGroup:
        for (; ; ) {
          const [i, h] = this.tag();
          if (h === xn.EndGroup) {
            if (t !== void 0 && i !== t)
              throw new Error("invalid end group tag");
            break;
          }
          this.skip(h, i);
        }
        break;
      default:
        throw new Error("cant skip wire type " + e);
    }
    return this.assertBounds(), this.buf.subarray(o, this.pos);
  }
  /**
   * Throws error if position in byte array is out of range.
   */
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  /**
   * Read a `int32` field, a signed 32 bit varint.
   */
  int32() {
    return this.uint32() | 0;
  }
  /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */
  sint32() {
    let e = this.uint32();
    return e >>> 1 ^ -(e & 1);
  }
  /**
   * Read a `int64` field, a signed 64-bit varint.
   */
  int64() {
    return Tn.dec(...this.varint64());
  }
  /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */
  uint64() {
    return Tn.uDec(...this.varint64());
  }
  /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64() {
    let [e, t] = this.varint64(), o = -(e & 1);
    return e = (e >>> 1 | (t & 1) << 31) ^ o, t = t >>> 1 ^ o, Tn.dec(e, t);
  }
  /**
   * Read a `bool` field, a variant.
   */
  bool() {
    let [e, t] = this.varint64();
    return e !== 0 || t !== 0;
  }
  /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */
  fixed64() {
    return Tn.uDec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */
  sfixed64() {
    return Tn.dec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `float` field, 32-bit floating point number.
   */
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `double` field, a 64-bit floating point number.
   */
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, !0);
  }
  /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */
  bytes() {
    let e = this.uint32(), t = this.pos;
    return this.pos += e, this.assertBounds(), this.buf.subarray(t, t + e);
  }
  /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */
  string() {
    return this.decodeUtf8(this.bytes());
  }
}
function Le(n) {
  if (typeof n == "string")
    n = Number(n);
  else if (typeof n != "number")
    throw new Error("invalid int32: " + typeof n);
  if (!Number.isInteger(n) || n > Fd || n < Ld)
    throw new Error("invalid int32: " + n);
}
function Li(n) {
  if (typeof n == "string")
    n = Number(n);
  else if (typeof n != "number")
    throw new Error("invalid uint32: " + typeof n);
  if (!Number.isInteger(n) || n > Vd || n < 0)
    throw new Error("invalid uint32: " + n);
}
function Gd(n) {
  if (typeof n == "string") {
    const e = n;
    if (n = Number(n), isNaN(n) && e !== "NaN")
      throw new Error("invalid float32: " + e);
  } else if (typeof n != "number")
    throw new Error("invalid float32: " + typeof n);
  if (Number.isFinite(n) && (n > Md || n < Dd))
    throw new Error("invalid float32: " + n);
}
const Wd = "babylon.btccheckpoint.v1";
var As = /* @__PURE__ */ ((n) => (n[n.EPOCH_STATUS_SUBMITTED = 0] = "EPOCH_STATUS_SUBMITTED", n[n.EPOCH_STATUS_CONFIRMED = 1] = "EPOCH_STATUS_CONFIRMED", n[n.EPOCH_STATUS_FINALIZED = 2] = "EPOCH_STATUS_FINALIZED", n[n.UNRECOGNIZED = -1] = "UNRECOGNIZED", n))(As || {});
function Ns(n) {
  switch (n) {
    case 0:
    case "EPOCH_STATUS_SUBMITTED":
      return 0;
    case 1:
    case "EPOCH_STATUS_CONFIRMED":
      return 1;
    case 2:
    case "EPOCH_STATUS_FINALIZED":
      return 2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function Ps(n) {
  switch (n) {
    case 0:
      return "EPOCH_STATUS_SUBMITTED";
    case 1:
      return "EPOCH_STATUS_CONFIRMED";
    case 2:
      return "EPOCH_STATUS_FINALIZED";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function Gi() {
  return {
    btcTransaction: new Uint8Array(0),
    btcTransactionIndex: 0,
    merkleNodes: new Uint8Array(0),
    confirmingBtcHeader: new Uint8Array(0)
  };
}
const Bs = {
  encode(n, e = new g()) {
    return n.btcTransaction.length !== 0 && e.uint32(10).bytes(n.btcTransaction), n.btcTransactionIndex !== 0 && e.uint32(16).uint32(n.btcTransactionIndex), n.merkleNodes.length !== 0 && e.uint32(26).bytes(n.merkleNodes), n.confirmingBtcHeader.length !== 0 && e.uint32(34).bytes(n.confirmingBtcHeader), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Gi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.btcTransaction = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.btcTransactionIndex = t.uint32();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.merkleNodes = t.bytes();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.confirmingBtcHeader = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      btcTransaction: K(n.btcTransaction) ? Bn(n.btcTransaction) : new Uint8Array(0),
      btcTransactionIndex: K(n.btcTransactionIndex) ? globalThis.Number(n.btcTransactionIndex) : 0,
      merkleNodes: K(n.merkleNodes) ? Bn(n.merkleNodes) : new Uint8Array(0),
      confirmingBtcHeader: K(n.confirmingBtcHeader) ? Bn(n.confirmingBtcHeader) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.btcTransaction.length !== 0 && (e.btcTransaction = On(n.btcTransaction)), n.btcTransactionIndex !== 0 && (e.btcTransactionIndex = Math.round(n.btcTransactionIndex)), n.merkleNodes.length !== 0 && (e.merkleNodes = On(n.merkleNodes)), n.confirmingBtcHeader.length !== 0 && (e.confirmingBtcHeader = On(n.confirmingBtcHeader)), e;
  },
  create(n) {
    return Bs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Gi();
    return e.btcTransaction = n.btcTransaction ?? new Uint8Array(0), e.btcTransactionIndex = n.btcTransactionIndex ?? 0, e.merkleNodes = n.merkleNodes ?? new Uint8Array(0), e.confirmingBtcHeader = n.confirmingBtcHeader ?? new Uint8Array(0), e;
  }
};
function Wi() {
  return { index: 0, hash: new Uint8Array(0) };
}
const Q = {
  encode(n, e = new g()) {
    return n.index !== 0 && e.uint32(8).uint32(n.index), n.hash.length !== 0 && e.uint32(18).bytes(n.hash), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Wi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.index = t.uint32();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.hash = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      index: K(n.index) ? globalThis.Number(n.index) : 0,
      hash: K(n.hash) ? Bn(n.hash) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.index !== 0 && (e.index = Math.round(n.index)), n.hash.length !== 0 && (e.hash = On(n.hash)), e;
  },
  create(n) {
    return Q.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Wi();
    return e.index = n.index ?? 0, e.hash = n.hash ?? new Uint8Array(0), e;
  }
};
function $i() {
  return { key: [] };
}
const Dn = {
  encode(n, e = new g()) {
    for (const t of n.key)
      Q.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = $i();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.key.push(Q.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { key: globalThis.Array.isArray(n == null ? void 0 : n.key) ? n.key.map((e) => Q.fromJSON(e)) : [] };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.key) != null && t.length && (e.key = n.key.map((o) => Q.toJSON(o))), e;
  },
  create(n) {
    return Dn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = $i();
    return e.key = ((t = n.key) == null ? void 0 : t.map((o) => Q.fromPartial(o))) || [], e;
  }
};
function Qi() {
  return { key: void 0, transaction: new Uint8Array(0), proof: new Uint8Array(0) };
}
const sn = {
  encode(n, e = new g()) {
    return n.key !== void 0 && Q.encode(n.key, e.uint32(10).fork()).join(), n.transaction.length !== 0 && e.uint32(18).bytes(n.transaction), n.proof.length !== 0 && e.uint32(26).bytes(n.proof), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Qi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.key = Q.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.transaction = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.proof = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      key: K(n.key) ? Q.fromJSON(n.key) : void 0,
      transaction: K(n.transaction) ? Bn(n.transaction) : new Uint8Array(0),
      proof: K(n.proof) ? Bn(n.proof) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.key !== void 0 && (e.key = Q.toJSON(n.key)), n.transaction.length !== 0 && (e.transaction = On(n.transaction)), n.proof.length !== 0 && (e.proof = On(n.proof)), e;
  },
  create(n) {
    return sn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Qi();
    return e.key = n.key !== void 0 && n.key !== null ? Q.fromPartial(n.key) : void 0, e.transaction = n.transaction ?? new Uint8Array(0), e.proof = n.proof ?? new Uint8Array(0), e;
  }
};
function qi() {
  return { vigilanteAddresses: void 0, txsInfo: [], epoch: 0 };
}
const Os = {
  encode(n, e = new g()) {
    n.vigilanteAddresses !== void 0 && dn.encode(n.vigilanteAddresses, e.uint32(10).fork()).join();
    for (const t of n.txsInfo)
      sn.encode(t, e.uint32(18).fork()).join();
    return n.epoch !== 0 && e.uint32(24).uint64(n.epoch), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = qi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.vigilanteAddresses = dn.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.txsInfo.push(sn.decode(t, t.uint32()));
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.epoch = Es(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      vigilanteAddresses: K(n.vigilanteAddresses) ? dn.fromJSON(n.vigilanteAddresses) : void 0,
      txsInfo: globalThis.Array.isArray(n == null ? void 0 : n.txsInfo) ? n.txsInfo.map((e) => sn.fromJSON(e)) : [],
      epoch: K(n.epoch) ? globalThis.Number(n.epoch) : 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.vigilanteAddresses !== void 0 && (e.vigilanteAddresses = dn.toJSON(n.vigilanteAddresses)), (t = n.txsInfo) != null && t.length && (e.txsInfo = n.txsInfo.map((o) => sn.toJSON(o))), n.epoch !== 0 && (e.epoch = Math.round(n.epoch)), e;
  },
  create(n) {
    return Os.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = qi();
    return e.vigilanteAddresses = n.vigilanteAddresses !== void 0 && n.vigilanteAddresses !== null ? dn.fromPartial(n.vigilanteAddresses) : void 0, e.txsInfo = ((t = n.txsInfo) == null ? void 0 : t.map((o) => sn.fromPartial(o))) || [], e.epoch = n.epoch ?? 0, e;
  }
};
function Xi() {
  return { keys: [], status: 0 };
}
const xs = {
  encode(n, e = new g()) {
    for (const t of n.keys)
      Dn.encode(t, e.uint32(10).fork()).join();
    return n.status !== 0 && e.uint32(16).int32(n.status), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Xi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.keys.push(Dn.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.status = t.int32();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      keys: globalThis.Array.isArray(n == null ? void 0 : n.keys) ? n.keys.map((e) => Dn.fromJSON(e)) : [],
      status: K(n.status) ? Ns(n.status) : 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.keys) != null && t.length && (e.keys = n.keys.map((o) => Dn.toJSON(o))), n.status !== 0 && (e.status = Ps(n.status)), e;
  },
  create(n) {
    return xs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Xi();
    return e.keys = ((t = n.keys) == null ? void 0 : t.map((o) => Dn.fromPartial(o))) || [], e.status = n.status ?? 0, e;
  }
};
function Ki() {
  return { submitter: new Uint8Array(0), reporter: new Uint8Array(0) };
}
const dn = {
  encode(n, e = new g()) {
    return n.submitter.length !== 0 && e.uint32(10).bytes(n.submitter), n.reporter.length !== 0 && e.uint32(18).bytes(n.reporter), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ki();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.submitter = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.reporter = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      submitter: K(n.submitter) ? Bn(n.submitter) : new Uint8Array(0),
      reporter: K(n.reporter) ? Bn(n.reporter) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.submitter.length !== 0 && (e.submitter = On(n.submitter)), n.reporter.length !== 0 && (e.reporter = On(n.reporter)), e;
  },
  create(n) {
    return dn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ki();
    return e.submitter = n.submitter ?? new Uint8Array(0), e.reporter = n.reporter ?? new Uint8Array(0), e;
  }
};
function Zi() {
  return {
    epochNumber: 0,
    bestSubmissionBtcBlockHeight: 0,
    bestSubmissionBtcBlockHash: new Uint8Array(0),
    bestSubmissionTransactions: [],
    bestSubmissionVigilanteAddressList: []
  };
}
const Rs = {
  encode(n, e = new g()) {
    n.epochNumber !== 0 && e.uint32(8).uint64(n.epochNumber), n.bestSubmissionBtcBlockHeight !== 0 && e.uint32(16).uint32(n.bestSubmissionBtcBlockHeight), n.bestSubmissionBtcBlockHash.length !== 0 && e.uint32(26).bytes(n.bestSubmissionBtcBlockHash);
    for (const t of n.bestSubmissionTransactions)
      sn.encode(t, e.uint32(34).fork()).join();
    for (const t of n.bestSubmissionVigilanteAddressList)
      dn.encode(t, e.uint32(42).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Zi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochNumber = Es(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.bestSubmissionBtcBlockHeight = t.uint32();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.bestSubmissionBtcBlockHash = t.bytes();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.bestSubmissionTransactions.push(sn.decode(t, t.uint32()));
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.bestSubmissionVigilanteAddressList.push(dn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      epochNumber: K(n.epochNumber) ? globalThis.Number(n.epochNumber) : 0,
      bestSubmissionBtcBlockHeight: K(n.bestSubmissionBtcBlockHeight) ? globalThis.Number(n.bestSubmissionBtcBlockHeight) : 0,
      bestSubmissionBtcBlockHash: K(n.bestSubmissionBtcBlockHash) ? Bn(n.bestSubmissionBtcBlockHash) : new Uint8Array(0),
      bestSubmissionTransactions: globalThis.Array.isArray(n == null ? void 0 : n.bestSubmissionTransactions) ? n.bestSubmissionTransactions.map((e) => sn.fromJSON(e)) : [],
      bestSubmissionVigilanteAddressList: globalThis.Array.isArray(n == null ? void 0 : n.bestSubmissionVigilanteAddressList) ? n.bestSubmissionVigilanteAddressList.map((e) => dn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t, o;
    const e = {};
    return n.epochNumber !== 0 && (e.epochNumber = Math.round(n.epochNumber)), n.bestSubmissionBtcBlockHeight !== 0 && (e.bestSubmissionBtcBlockHeight = Math.round(n.bestSubmissionBtcBlockHeight)), n.bestSubmissionBtcBlockHash.length !== 0 && (e.bestSubmissionBtcBlockHash = On(n.bestSubmissionBtcBlockHash)), (t = n.bestSubmissionTransactions) != null && t.length && (e.bestSubmissionTransactions = n.bestSubmissionTransactions.map((r) => sn.toJSON(r))), (o = n.bestSubmissionVigilanteAddressList) != null && o.length && (e.bestSubmissionVigilanteAddressList = n.bestSubmissionVigilanteAddressList.map(
      (r) => dn.toJSON(r)
    )), e;
  },
  create(n) {
    return Rs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t, o;
    const e = Zi();
    return e.epochNumber = n.epochNumber ?? 0, e.bestSubmissionBtcBlockHeight = n.bestSubmissionBtcBlockHeight ?? 0, e.bestSubmissionBtcBlockHash = n.bestSubmissionBtcBlockHash ?? new Uint8Array(0), e.bestSubmissionTransactions = ((t = n.bestSubmissionTransactions) == null ? void 0 : t.map((r) => sn.fromPartial(r))) || [], e.bestSubmissionVigilanteAddressList = ((o = n.bestSubmissionVigilanteAddressList) == null ? void 0 : o.map((r) => dn.fromPartial(r))) || [], e;
  }
};
function Bn(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function On(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function Es(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function K(n) {
  return n != null;
}
const Sc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCCheckpointInfo: Rs,
  BTCSpvProof: Bs,
  BtcStatus: As,
  CheckpointAddresses: dn,
  EpochData: xs,
  SubmissionData: Os,
  SubmissionKey: Dn,
  TransactionInfo: sn,
  TransactionKey: Q,
  btcStatusFromJSON: Ns,
  btcStatusToJSON: Ps,
  protobufPackage: Wd
}, Symbol.toStringTag, { value: "Module" })), $d = "babylon.btclightclient.v1";
function zi() {
  return { header: new Uint8Array(0), hash: new Uint8Array(0), height: 0, work: new Uint8Array(0) };
}
const an = {
  encode(n, e = new g()) {
    return n.header.length !== 0 && e.uint32(10).bytes(n.header), n.hash.length !== 0 && e.uint32(18).bytes(n.hash), n.height !== 0 && e.uint32(24).uint32(n.height), n.work.length !== 0 && e.uint32(34).bytes(n.work), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = zi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.header = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.hash = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.height = t.uint32();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.work = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      header: Be(n.header) ? Ge(n.header) : new Uint8Array(0),
      hash: Be(n.hash) ? Ge(n.hash) : new Uint8Array(0),
      height: Be(n.height) ? globalThis.Number(n.height) : 0,
      work: Be(n.work) ? Ge(n.work) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.header.length !== 0 && (e.header = We(n.header)), n.hash.length !== 0 && (e.hash = We(n.hash)), n.height !== 0 && (e.height = Math.round(n.height)), n.work.length !== 0 && (e.work = We(n.work)), e;
  },
  create(n) {
    return an.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = zi();
    return e.header = n.header ?? new Uint8Array(0), e.hash = n.hash ?? new Uint8Array(0), e.height = n.height ?? 0, e.work = n.work ?? new Uint8Array(0), e;
  }
};
function Ge(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function We(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function Be(n) {
  return n != null;
}
const bc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCHeaderInfo: an,
  protobufPackage: $d
}, Symbol.toStringTag, { value: "Module" }));
function Yi() {
  return { key: new Uint8Array(0), offset: 0, limit: 0, countTotal: !1, reverse: !1 };
}
const I = {
  encode(n, e = new g()) {
    return n.key.length !== 0 && e.uint32(10).bytes(n.key), n.offset !== 0 && e.uint32(16).uint64(n.offset), n.limit !== 0 && e.uint32(24).uint64(n.limit), n.countTotal !== !1 && e.uint32(32).bool(n.countTotal), n.reverse !== !1 && e.uint32(40).bool(n.reverse), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Yi();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.key = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.offset = qe(t.uint64());
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.limit = qe(t.uint64());
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.countTotal = t.bool();
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.reverse = t.bool();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      key: Vn(n.key) ? Js(n.key) : new Uint8Array(0),
      offset: Vn(n.offset) ? globalThis.Number(n.offset) : 0,
      limit: Vn(n.limit) ? globalThis.Number(n.limit) : 0,
      countTotal: Vn(n.countTotal) ? globalThis.Boolean(n.countTotal) : !1,
      reverse: Vn(n.reverse) ? globalThis.Boolean(n.reverse) : !1
    };
  },
  toJSON(n) {
    const e = {};
    return n.key.length !== 0 && (e.key = Is(n.key)), n.offset !== 0 && (e.offset = Math.round(n.offset)), n.limit !== 0 && (e.limit = Math.round(n.limit)), n.countTotal !== !1 && (e.countTotal = n.countTotal), n.reverse !== !1 && (e.reverse = n.reverse), e;
  },
  create(n) {
    return I.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Yi();
    return e.key = n.key ?? new Uint8Array(0), e.offset = n.offset ?? 0, e.limit = n.limit ?? 0, e.countTotal = n.countTotal ?? !1, e.reverse = n.reverse ?? !1, e;
  }
};
function ji() {
  return { nextKey: new Uint8Array(0), total: 0 };
}
const C = {
  encode(n, e = new g()) {
    return n.nextKey.length !== 0 && e.uint32(10).bytes(n.nextKey), n.total !== 0 && e.uint32(16).uint64(n.total), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ji();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.nextKey = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.total = qe(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      nextKey: Vn(n.nextKey) ? Js(n.nextKey) : new Uint8Array(0),
      total: Vn(n.total) ? globalThis.Number(n.total) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.nextKey.length !== 0 && (e.nextKey = Is(n.nextKey)), n.total !== 0 && (e.total = Math.round(n.total)), e;
  },
  create(n) {
    return C.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ji();
    return e.nextKey = n.nextKey ?? new Uint8Array(0), e.total = n.total ?? 0, e;
  }
};
function Js(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function Is(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function qe(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function Vn(n) {
  return n != null;
}
function nr() {
  return { insertHeadersAllowList: [] };
}
const se = {
  encode(n, e = new g()) {
    for (const t of n.insertHeadersAllowList)
      e.uint32(10).string(t);
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = nr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.insertHeadersAllowList.push(t.string());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      insertHeadersAllowList: globalThis.Array.isArray(n == null ? void 0 : n.insertHeadersAllowList) ? n.insertHeadersAllowList.map((e) => globalThis.String(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.insertHeadersAllowList) != null && t.length && (e.insertHeadersAllowList = n.insertHeadersAllowList), e;
  },
  create(n) {
    return se.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = nr();
    return e.insertHeadersAllowList = ((t = n.insertHeadersAllowList) == null ? void 0 : t.map((o) => o)) || [], e;
  }
}, Qd = "babylon.btclightclient.v1";
function er() {
  return {};
}
const Ze = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = er();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Ze.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return er();
  }
};
function tr() {
  return { params: void 0 };
}
const ze = {
  encode(n, e = new g()) {
    return n.params !== void 0 && se.encode(n.params, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = tr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.params = se.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { params: Z(n.params) ? se.fromJSON(n.params) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.params !== void 0 && (e.params = se.toJSON(n.params)), e;
  },
  create(n) {
    return ze.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = tr();
    return e.params = n.params !== void 0 && n.params !== null ? se.fromPartial(n.params) : void 0, e;
  }
};
function ir() {
  return { pagination: void 0 };
}
const Ye = {
  encode(n, e = new g()) {
    return n.pagination !== void 0 && I.encode(n.pagination, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ir();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.pagination = I.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { pagination: Z(n.pagination) ? I.fromJSON(n.pagination) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.pagination !== void 0 && (e.pagination = I.toJSON(n.pagination)), e;
  },
  create(n) {
    return Ye.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ir();
    return e.pagination = n.pagination !== void 0 && n.pagination !== null ? I.fromPartial(n.pagination) : void 0, e;
  }
};
function rr() {
  return { hashes: [], pagination: void 0 };
}
const je = {
  encode(n, e = new g()) {
    for (const t of n.hashes)
      e.uint32(10).bytes(t);
    return n.pagination !== void 0 && C.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = rr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.hashes.push(t.bytes());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = C.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      hashes: globalThis.Array.isArray(n == null ? void 0 : n.hashes) ? n.hashes.map((e) => lt(e)) : [],
      pagination: Z(n.pagination) ? C.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.hashes) != null && t.length && (e.hashes = n.hashes.map((o) => ft(o))), n.pagination !== void 0 && (e.pagination = C.toJSON(n.pagination)), e;
  },
  create(n) {
    return je.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = rr();
    return e.hashes = ((t = n.hashes) == null ? void 0 : t.map((o) => o)) || [], e.pagination = n.pagination !== void 0 && n.pagination !== null ? C.fromPartial(n.pagination) : void 0, e;
  }
};
function or() {
  return { hash: new Uint8Array(0) };
}
const nt = {
  encode(n, e = new g()) {
    return n.hash.length !== 0 && e.uint32(10).bytes(n.hash), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = or();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.hash = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { hash: Z(n.hash) ? lt(n.hash) : new Uint8Array(0) };
  },
  toJSON(n) {
    const e = {};
    return n.hash.length !== 0 && (e.hash = ft(n.hash)), e;
  },
  create(n) {
    return nt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = or();
    return e.hash = n.hash ?? new Uint8Array(0), e;
  }
};
function ar() {
  return { contains: !1 };
}
const et = {
  encode(n, e = new g()) {
    return n.contains !== !1 && e.uint32(8).bool(n.contains), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ar();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.contains = t.bool();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { contains: Z(n.contains) ? globalThis.Boolean(n.contains) : !1 };
  },
  toJSON(n) {
    const e = {};
    return n.contains !== !1 && (e.contains = n.contains), e;
  },
  create(n) {
    return et.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ar();
    return e.contains = n.contains ?? !1, e;
  }
};
function sr() {
  return { hash: new Uint8Array(0) };
}
const tt = {
  encode(n, e = new g()) {
    return n.hash.length !== 0 && e.uint32(10).bytes(n.hash), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = sr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.hash = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { hash: Z(n.hash) ? lt(n.hash) : new Uint8Array(0) };
  },
  toJSON(n) {
    const e = {};
    return n.hash.length !== 0 && (e.hash = ft(n.hash)), e;
  },
  create(n) {
    return tt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = sr();
    return e.hash = n.hash ?? new Uint8Array(0), e;
  }
};
function dr() {
  return { contains: !1 };
}
const it = {
  encode(n, e = new g()) {
    return n.contains !== !1 && e.uint32(8).bool(n.contains), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = dr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.contains = t.bool();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { contains: Z(n.contains) ? globalThis.Boolean(n.contains) : !1 };
  },
  toJSON(n) {
    const e = {};
    return n.contains !== !1 && (e.contains = n.contains), e;
  },
  create(n) {
    return it.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = dr();
    return e.contains = n.contains ?? !1, e;
  }
};
function ur() {
  return { pagination: void 0 };
}
const rt = {
  encode(n, e = new g()) {
    return n.pagination !== void 0 && I.encode(n.pagination, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ur();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.pagination = I.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { pagination: Z(n.pagination) ? I.fromJSON(n.pagination) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.pagination !== void 0 && (e.pagination = I.toJSON(n.pagination)), e;
  },
  create(n) {
    return rt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ur();
    return e.pagination = n.pagination !== void 0 && n.pagination !== null ? I.fromPartial(n.pagination) : void 0, e;
  }
};
function cr() {
  return { headers: [], pagination: void 0 };
}
const ot = {
  encode(n, e = new g()) {
    for (const t of n.headers)
      q.encode(t, e.uint32(10).fork()).join();
    return n.pagination !== void 0 && C.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = cr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.headers.push(q.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = C.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      headers: globalThis.Array.isArray(n == null ? void 0 : n.headers) ? n.headers.map((e) => q.fromJSON(e)) : [],
      pagination: Z(n.pagination) ? C.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.headers) != null && t.length && (e.headers = n.headers.map((o) => q.toJSON(o))), n.pagination !== void 0 && (e.pagination = C.toJSON(n.pagination)), e;
  },
  create(n) {
    return ot.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = cr();
    return e.headers = ((t = n.headers) == null ? void 0 : t.map((o) => q.fromPartial(o))) || [], e.pagination = n.pagination !== void 0 && n.pagination !== null ? C.fromPartial(n.pagination) : void 0, e;
  }
};
function lr() {
  return {};
}
const Ce = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = lr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Ce.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return lr();
  }
};
function fr() {
  return { header: void 0 };
}
const at = {
  encode(n, e = new g()) {
    return n.header !== void 0 && q.encode(n.header, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = fr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.header = q.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { header: Z(n.header) ? q.fromJSON(n.header) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.header !== void 0 && (e.header = q.toJSON(n.header)), e;
  },
  create(n) {
    return at.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = fr();
    return e.header = n.header !== void 0 && n.header !== null ? q.fromPartial(n.header) : void 0, e;
  }
};
function hr() {
  return {};
}
const st = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = hr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return st.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return hr();
  }
};
function gr() {
  return { header: void 0 };
}
const dt = {
  encode(n, e = new g()) {
    return n.header !== void 0 && q.encode(n.header, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = gr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.header = q.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { header: Z(n.header) ? q.fromJSON(n.header) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.header !== void 0 && (e.header = q.toJSON(n.header)), e;
  },
  create(n) {
    return dt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = gr();
    return e.header = n.header !== void 0 && n.header !== null ? q.fromPartial(n.header) : void 0, e;
  }
};
function pr() {
  return { hash: "" };
}
const ut = {
  encode(n, e = new g()) {
    return n.hash !== "" && e.uint32(10).string(n.hash), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = pr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.hash = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { hash: Z(n.hash) ? globalThis.String(n.hash) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.hash !== "" && (e.hash = n.hash), e;
  },
  create(n) {
    return ut.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = pr();
    return e.hash = n.hash ?? "", e;
  }
};
function mr() {
  return { depth: 0 };
}
const ct = {
  encode(n, e = new g()) {
    return n.depth !== 0 && e.uint32(8).uint32(n.depth), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = mr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.depth = t.uint32();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { depth: Z(n.depth) ? globalThis.Number(n.depth) : 0 };
  },
  toJSON(n) {
    const e = {};
    return n.depth !== 0 && (e.depth = Math.round(n.depth)), e;
  },
  create(n) {
    return ct.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = mr();
    return e.depth = n.depth ?? 0, e;
  }
};
function kr() {
  return { headerHex: "", hashHex: "", height: 0, work: "" };
}
const q = {
  encode(n, e = new g()) {
    return n.headerHex !== "" && e.uint32(10).string(n.headerHex), n.hashHex !== "" && e.uint32(18).string(n.hashHex), n.height !== 0 && e.uint32(24).uint32(n.height), n.work !== "" && e.uint32(34).string(n.work), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = kr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.headerHex = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.hashHex = t.string();
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.height = t.uint32();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.work = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      headerHex: Z(n.headerHex) ? globalThis.String(n.headerHex) : "",
      hashHex: Z(n.hashHex) ? globalThis.String(n.hashHex) : "",
      height: Z(n.height) ? globalThis.Number(n.height) : 0,
      work: Z(n.work) ? globalThis.String(n.work) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.headerHex !== "" && (e.headerHex = n.headerHex), n.hashHex !== "" && (e.hashHex = n.hashHex), n.height !== 0 && (e.height = Math.round(n.height)), n.work !== "" && (e.work = n.work), e;
  },
  create(n) {
    return q.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = kr();
    return e.headerHex = n.headerHex ?? "", e.hashHex = n.hashHex ?? "", e.height = n.height ?? 0, e.work = n.work ?? "", e;
  }
}, Cs = "babylon.btclightclient.v1.Query";
let Us = class {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || Cs, this.rpc = e, this.Params = this.Params.bind(this), this.Hashes = this.Hashes.bind(this), this.Contains = this.Contains.bind(this), this.ContainsBytes = this.ContainsBytes.bind(this), this.MainChain = this.MainChain.bind(this), this.Tip = this.Tip.bind(this), this.BaseHeader = this.BaseHeader.bind(this), this.HeaderDepth = this.HeaderDepth.bind(this);
  }
  Params(e) {
    const t = Ze.encode(e).finish();
    return this.rpc.request(this.service, "Params", t).then((r) => ze.decode(new a(r)));
  }
  Hashes(e) {
    const t = Ye.encode(e).finish();
    return this.rpc.request(this.service, "Hashes", t).then((r) => je.decode(new a(r)));
  }
  Contains(e) {
    const t = nt.encode(e).finish();
    return this.rpc.request(this.service, "Contains", t).then((r) => et.decode(new a(r)));
  }
  ContainsBytes(e) {
    const t = tt.encode(e).finish();
    return this.rpc.request(this.service, "ContainsBytes", t).then((r) => it.decode(new a(r)));
  }
  MainChain(e) {
    const t = rt.encode(e).finish();
    return this.rpc.request(this.service, "MainChain", t).then((r) => ot.decode(new a(r)));
  }
  Tip(e) {
    const t = Ce.encode(e).finish();
    return this.rpc.request(this.service, "Tip", t).then((r) => at.decode(new a(r)));
  }
  BaseHeader(e) {
    const t = st.encode(e).finish();
    return this.rpc.request(this.service, "BaseHeader", t).then((r) => dt.decode(new a(r)));
  }
  HeaderDepth(e) {
    const t = ut.encode(e).finish();
    return this.rpc.request(this.service, "HeaderDepth", t).then((r) => ct.decode(new a(r)));
  }
};
function lt(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function ft(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function Z(n) {
  return n != null;
}
const Tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCHeaderInfoResponse: q,
  QueryBaseHeaderRequest: st,
  QueryBaseHeaderResponse: dt,
  QueryClientImpl: Us,
  QueryContainsBytesRequest: tt,
  QueryContainsBytesResponse: it,
  QueryContainsRequest: nt,
  QueryContainsResponse: et,
  QueryHashesRequest: Ye,
  QueryHashesResponse: je,
  QueryHeaderDepthRequest: ut,
  QueryHeaderDepthResponse: ct,
  QueryMainChainRequest: rt,
  QueryMainChainResponse: ot,
  QueryParamsRequest: Ze,
  QueryParamsResponse: ze,
  QueryServiceName: Cs,
  QueryTipRequest: Ce,
  QueryTipResponse: at,
  protobufPackage: Qd
}, Symbol.toStringTag, { value: "Module" })), qd = "google.protobuf";
function Sr() {
  return { typeUrl: "", value: new Uint8Array(0) };
}
const un = {
  encode(n, e = new g()) {
    return n.typeUrl !== "" && e.uint32(10).string(n.typeUrl), n.value.length !== 0 && e.uint32(18).bytes(n.value), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Sr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.typeUrl = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.value = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      typeUrl: br(n.typeUrl) ? globalThis.String(n.typeUrl) : "",
      value: br(n.value) ? Xd(n.value) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.typeUrl !== "" && (e.typeUrl = n.typeUrl), n.value.length !== 0 && (e.value = Kd(n.value)), e;
  },
  create(n) {
    return un.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Sr();
    return e.typeUrl = n.typeUrl ?? "", e.value = n.value ?? new Uint8Array(0), e;
  }
};
function Xd(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function Kd(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function br(n) {
  return n != null;
}
const yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: un,
  protobufPackage: qd
}, Symbol.toStringTag, { value: "Module" }));
function vr() {
  return { seconds: 0, nanos: 0 };
}
const de = {
  encode(n, e = new g()) {
    return n.seconds !== 0 && e.uint32(8).int64(n.seconds), n.nanos !== 0 && e.uint32(16).int32(n.nanos), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = vr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.seconds = Zd(t.int64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.nanos = t.int32();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      seconds: Tr(n.seconds) ? globalThis.Number(n.seconds) : 0,
      nanos: Tr(n.nanos) ? globalThis.Number(n.nanos) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.seconds !== 0 && (e.seconds = Math.round(n.seconds)), n.nanos !== 0 && (e.nanos = Math.round(n.nanos)), e;
  },
  create(n) {
    return de.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = vr();
    return e.seconds = n.seconds ?? 0, e.nanos = n.nanos ?? 0, e;
  }
};
function Zd(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function Tr(n) {
  return n != null;
}
function yr() {
  return { seconds: 0, nanos: 0 };
}
const U = {
  encode(n, e = new g()) {
    return n.seconds !== 0 && e.uint32(8).int64(n.seconds), n.nanos !== 0 && e.uint32(16).int32(n.nanos), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = yr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.seconds = zd(t.int64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.nanos = t.int32();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      seconds: wr(n.seconds) ? globalThis.Number(n.seconds) : 0,
      nanos: wr(n.nanos) ? globalThis.Number(n.nanos) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.seconds !== 0 && (e.seconds = Math.round(n.seconds)), n.nanos !== 0 && (e.nanos = Math.round(n.nanos)), e;
  },
  create(n) {
    return U.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = yr();
    return e.seconds = n.seconds ?? 0, e.nanos = n.nanos ?? 0, e;
  }
};
function zd(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function wr(n) {
  return n != null;
}
function Ar() {
  return { ed25519: void 0, secp256k1: void 0 };
}
const ue = {
  encode(n, e = new g()) {
    return n.ed25519 !== void 0 && e.uint32(10).bytes(n.ed25519), n.secp256k1 !== void 0 && e.uint32(18).bytes(n.secp256k1), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ar();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.ed25519 = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.secp256k1 = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      ed25519: Br(n.ed25519) ? Nr(n.ed25519) : void 0,
      secp256k1: Br(n.secp256k1) ? Nr(n.secp256k1) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.ed25519 !== void 0 && (e.ed25519 = Pr(n.ed25519)), n.secp256k1 !== void 0 && (e.secp256k1 = Pr(n.secp256k1)), e;
  },
  create(n) {
    return ue.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ar();
    return e.ed25519 = n.ed25519 ?? void 0, e.secp256k1 = n.secp256k1 ?? void 0, e;
  }
};
function Nr(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function Pr(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function Br(n) {
  return n != null;
}
function Or() {
  return { pubKey: void 0, power: 0 };
}
const ce = {
  encode(n, e = new g()) {
    return n.pubKey !== void 0 && ue.encode(n.pubKey, e.uint32(10).fork()).join(), n.power !== 0 && e.uint32(16).int64(n.power), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Or();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.pubKey = ue.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.power = Yd(t.int64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      pubKey: xr(n.pubKey) ? ue.fromJSON(n.pubKey) : void 0,
      power: xr(n.power) ? globalThis.Number(n.power) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.pubKey !== void 0 && (e.pubKey = ue.toJSON(n.pubKey)), n.power !== 0 && (e.power = Math.round(n.power)), e;
  },
  create(n) {
    return ce.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Or();
    return e.pubKey = n.pubKey !== void 0 && n.pubKey !== null ? ue.fromPartial(n.pubKey) : void 0, e.power = n.power ?? 0, e;
  }
};
function Yd(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function xr(n) {
  return n != null;
}
function Rr() {
  return { block: 0, app: 0 };
}
const le = {
  encode(n, e = new g()) {
    return n.block !== 0 && e.uint32(8).uint64(n.block), n.app !== 0 && e.uint32(16).uint64(n.app), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Rr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.block = Er(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.app = Er(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      block: Jr(n.block) ? globalThis.Number(n.block) : 0,
      app: Jr(n.app) ? globalThis.Number(n.app) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.block !== 0 && (e.block = Math.round(n.block)), n.app !== 0 && (e.app = Math.round(n.app)), e;
  },
  create(n) {
    return le.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Rr();
    return e.block = n.block ?? 0, e.app = n.app ?? 0, e;
  }
};
function Er(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function Jr(n) {
  return n != null;
}
function Ir() {
  return { total: 0, hash: new Uint8Array(0) };
}
const fe = {
  encode(n, e = new g()) {
    return n.total !== 0 && e.uint32(8).uint32(n.total), n.hash.length !== 0 && e.uint32(18).bytes(n.hash), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ir();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.total = t.uint32();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.hash = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      total: $(n.total) ? globalThis.Number(n.total) : 0,
      hash: $(n.hash) ? mn(n.hash) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.total !== 0 && (e.total = Math.round(n.total)), n.hash.length !== 0 && (e.hash = kn(n.hash)), e;
  },
  create(n) {
    return fe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ir();
    return e.total = n.total ?? 0, e.hash = n.hash ?? new Uint8Array(0), e;
  }
};
function Cr() {
  return { hash: new Uint8Array(0), partSetHeader: void 0 };
}
const he = {
  encode(n, e = new g()) {
    return n.hash.length !== 0 && e.uint32(10).bytes(n.hash), n.partSetHeader !== void 0 && fe.encode(n.partSetHeader, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Cr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.hash = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.partSetHeader = fe.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      hash: $(n.hash) ? mn(n.hash) : new Uint8Array(0),
      partSetHeader: $(n.partSetHeader) ? fe.fromJSON(n.partSetHeader) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.hash.length !== 0 && (e.hash = kn(n.hash)), n.partSetHeader !== void 0 && (e.partSetHeader = fe.toJSON(n.partSetHeader)), e;
  },
  create(n) {
    return he.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Cr();
    return e.hash = n.hash ?? new Uint8Array(0), e.partSetHeader = n.partSetHeader !== void 0 && n.partSetHeader !== null ? fe.fromPartial(n.partSetHeader) : void 0, e;
  }
};
function Ur() {
  return {
    version: void 0,
    chainId: "",
    height: 0,
    time: void 0,
    lastBlockId: void 0,
    lastCommitHash: new Uint8Array(0),
    dataHash: new Uint8Array(0),
    validatorsHash: new Uint8Array(0),
    nextValidatorsHash: new Uint8Array(0),
    consensusHash: new Uint8Array(0),
    appHash: new Uint8Array(0),
    lastResultsHash: new Uint8Array(0),
    evidenceHash: new Uint8Array(0),
    proposerAddress: new Uint8Array(0)
  };
}
const ge = {
  encode(n, e = new g()) {
    return n.version !== void 0 && le.encode(n.version, e.uint32(10).fork()).join(), n.chainId !== "" && e.uint32(18).string(n.chainId), n.height !== 0 && e.uint32(24).int64(n.height), n.time !== void 0 && U.encode(jd(n.time), e.uint32(34).fork()).join(), n.lastBlockId !== void 0 && he.encode(n.lastBlockId, e.uint32(42).fork()).join(), n.lastCommitHash.length !== 0 && e.uint32(50).bytes(n.lastCommitHash), n.dataHash.length !== 0 && e.uint32(58).bytes(n.dataHash), n.validatorsHash.length !== 0 && e.uint32(66).bytes(n.validatorsHash), n.nextValidatorsHash.length !== 0 && e.uint32(74).bytes(n.nextValidatorsHash), n.consensusHash.length !== 0 && e.uint32(82).bytes(n.consensusHash), n.appHash.length !== 0 && e.uint32(90).bytes(n.appHash), n.lastResultsHash.length !== 0 && e.uint32(98).bytes(n.lastResultsHash), n.evidenceHash.length !== 0 && e.uint32(106).bytes(n.evidenceHash), n.proposerAddress.length !== 0 && e.uint32(114).bytes(n.proposerAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ur();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.version = le.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.chainId = t.string();
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.height = eu(t.int64());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.time = Hs(U.decode(t, t.uint32()));
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.lastBlockId = he.decode(t, t.uint32());
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.lastCommitHash = t.bytes();
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.dataHash = t.bytes();
          continue;
        }
        case 8: {
          if (i !== 66)
            break;
          r.validatorsHash = t.bytes();
          continue;
        }
        case 9: {
          if (i !== 74)
            break;
          r.nextValidatorsHash = t.bytes();
          continue;
        }
        case 10: {
          if (i !== 82)
            break;
          r.consensusHash = t.bytes();
          continue;
        }
        case 11: {
          if (i !== 90)
            break;
          r.appHash = t.bytes();
          continue;
        }
        case 12: {
          if (i !== 98)
            break;
          r.lastResultsHash = t.bytes();
          continue;
        }
        case 13: {
          if (i !== 106)
            break;
          r.evidenceHash = t.bytes();
          continue;
        }
        case 14: {
          if (i !== 114)
            break;
          r.proposerAddress = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      version: $(n.version) ? le.fromJSON(n.version) : void 0,
      chainId: $(n.chainId) ? globalThis.String(n.chainId) : "",
      height: $(n.height) ? globalThis.Number(n.height) : 0,
      time: $(n.time) ? nu(n.time) : void 0,
      lastBlockId: $(n.lastBlockId) ? he.fromJSON(n.lastBlockId) : void 0,
      lastCommitHash: $(n.lastCommitHash) ? mn(n.lastCommitHash) : new Uint8Array(0),
      dataHash: $(n.dataHash) ? mn(n.dataHash) : new Uint8Array(0),
      validatorsHash: $(n.validatorsHash) ? mn(n.validatorsHash) : new Uint8Array(0),
      nextValidatorsHash: $(n.nextValidatorsHash) ? mn(n.nextValidatorsHash) : new Uint8Array(0),
      consensusHash: $(n.consensusHash) ? mn(n.consensusHash) : new Uint8Array(0),
      appHash: $(n.appHash) ? mn(n.appHash) : new Uint8Array(0),
      lastResultsHash: $(n.lastResultsHash) ? mn(n.lastResultsHash) : new Uint8Array(0),
      evidenceHash: $(n.evidenceHash) ? mn(n.evidenceHash) : new Uint8Array(0),
      proposerAddress: $(n.proposerAddress) ? mn(n.proposerAddress) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.version !== void 0 && (e.version = le.toJSON(n.version)), n.chainId !== "" && (e.chainId = n.chainId), n.height !== 0 && (e.height = Math.round(n.height)), n.time !== void 0 && (e.time = n.time.toISOString()), n.lastBlockId !== void 0 && (e.lastBlockId = he.toJSON(n.lastBlockId)), n.lastCommitHash.length !== 0 && (e.lastCommitHash = kn(n.lastCommitHash)), n.dataHash.length !== 0 && (e.dataHash = kn(n.dataHash)), n.validatorsHash.length !== 0 && (e.validatorsHash = kn(n.validatorsHash)), n.nextValidatorsHash.length !== 0 && (e.nextValidatorsHash = kn(n.nextValidatorsHash)), n.consensusHash.length !== 0 && (e.consensusHash = kn(n.consensusHash)), n.appHash.length !== 0 && (e.appHash = kn(n.appHash)), n.lastResultsHash.length !== 0 && (e.lastResultsHash = kn(n.lastResultsHash)), n.evidenceHash.length !== 0 && (e.evidenceHash = kn(n.evidenceHash)), n.proposerAddress.length !== 0 && (e.proposerAddress = kn(n.proposerAddress)), e;
  },
  create(n) {
    return ge.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ur();
    return e.version = n.version !== void 0 && n.version !== null ? le.fromPartial(n.version) : void 0, e.chainId = n.chainId ?? "", e.height = n.height ?? 0, e.time = n.time ?? void 0, e.lastBlockId = n.lastBlockId !== void 0 && n.lastBlockId !== null ? he.fromPartial(n.lastBlockId) : void 0, e.lastCommitHash = n.lastCommitHash ?? new Uint8Array(0), e.dataHash = n.dataHash ?? new Uint8Array(0), e.validatorsHash = n.validatorsHash ?? new Uint8Array(0), e.nextValidatorsHash = n.nextValidatorsHash ?? new Uint8Array(0), e.consensusHash = n.consensusHash ?? new Uint8Array(0), e.appHash = n.appHash ?? new Uint8Array(0), e.lastResultsHash = n.lastResultsHash ?? new Uint8Array(0), e.evidenceHash = n.evidenceHash ?? new Uint8Array(0), e.proposerAddress = n.proposerAddress ?? new Uint8Array(0), e;
  }
};
function mn(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function kn(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function jd(n) {
  const e = Math.trunc(n.getTime() / 1e3), t = n.getTime() % 1e3 * 1e6;
  return { seconds: e, nanos: t };
}
function Hs(n) {
  let e = (n.seconds || 0) * 1e3;
  return e += (n.nanos || 0) / 1e6, new globalThis.Date(e);
}
function nu(n) {
  return n instanceof globalThis.Date ? n : typeof n == "string" ? new globalThis.Date(n) : Hs(U.fromJSON(n));
}
function eu(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function $(n) {
  return n != null;
}
function Hr() {
  return { denom: "", amount: "" };
}
const y = {
  encode(n, e = new g()) {
    return n.denom !== "" && e.uint32(10).string(n.denom), n.amount !== "" && e.uint32(18).string(n.amount), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Hr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.denom = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.amount = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      denom: _r(n.denom) ? globalThis.String(n.denom) : "",
      amount: _r(n.amount) ? globalThis.String(n.amount) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.denom !== "" && (e.denom = n.denom), n.amount !== "" && (e.amount = n.amount), e;
  },
  create(n) {
    return y.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Hr();
    return e.denom = n.denom ?? "", e.amount = n.amount ?? "", e;
  }
};
function _r(n) {
  return n != null;
}
const tu = "cosmos.staking.v1beta1";
var _s = /* @__PURE__ */ ((n) => (n[n.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", n[n.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", n[n.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", n[n.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", n[n.UNRECOGNIZED = -1] = "UNRECOGNIZED", n))(_s || {});
function Ms(n) {
  switch (n) {
    case 0:
    case "BOND_STATUS_UNSPECIFIED":
      return 0;
    case 1:
    case "BOND_STATUS_UNBONDED":
      return 1;
    case 2:
    case "BOND_STATUS_UNBONDING":
      return 2;
    case 3:
    case "BOND_STATUS_BONDED":
      return 3;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function Ds(n) {
  switch (n) {
    case 0:
      return "BOND_STATUS_UNSPECIFIED";
    case 1:
      return "BOND_STATUS_UNBONDED";
    case 2:
      return "BOND_STATUS_UNBONDING";
    case 3:
      return "BOND_STATUS_BONDED";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
var Vs = /* @__PURE__ */ ((n) => (n[n.INFRACTION_UNSPECIFIED = 0] = "INFRACTION_UNSPECIFIED", n[n.INFRACTION_DOUBLE_SIGN = 1] = "INFRACTION_DOUBLE_SIGN", n[n.INFRACTION_DOWNTIME = 2] = "INFRACTION_DOWNTIME", n[n.UNRECOGNIZED = -1] = "UNRECOGNIZED", n))(Vs || {});
function iu(n) {
  switch (n) {
    case 0:
    case "INFRACTION_UNSPECIFIED":
      return 0;
    case 1:
    case "INFRACTION_DOUBLE_SIGN":
      return 1;
    case 2:
    case "INFRACTION_DOWNTIME":
      return 2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function ru(n) {
  switch (n) {
    case 0:
      return "INFRACTION_UNSPECIFIED";
    case 1:
      return "INFRACTION_DOUBLE_SIGN";
    case 2:
      return "INFRACTION_DOWNTIME";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function Mr() {
  return { header: void 0, valset: [] };
}
const Fs = {
  encode(n, e = new g()) {
    n.header !== void 0 && ge.encode(n.header, e.uint32(10).fork()).join();
    for (const t of n.valset)
      Ln.encode(t, e.uint32(18).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Mr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.header = ge.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.valset.push(Ln.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      header: N(n.header) ? ge.fromJSON(n.header) : void 0,
      valset: globalThis.Array.isArray(n == null ? void 0 : n.valset) ? n.valset.map((e) => Ln.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.header !== void 0 && (e.header = ge.toJSON(n.header)), (t = n.valset) != null && t.length && (e.valset = n.valset.map((o) => Ln.toJSON(o))), e;
  },
  create(n) {
    return Fs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Mr();
    return e.header = n.header !== void 0 && n.header !== null ? ge.fromPartial(n.header) : void 0, e.valset = ((t = n.valset) == null ? void 0 : t.map((o) => Ln.fromPartial(o))) || [], e;
  }
};
function Dr() {
  return { rate: "", maxRate: "", maxChangeRate: "" };
}
const cn = {
  encode(n, e = new g()) {
    return n.rate !== "" && e.uint32(10).string(n.rate), n.maxRate !== "" && e.uint32(18).string(n.maxRate), n.maxChangeRate !== "" && e.uint32(26).string(n.maxChangeRate), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Dr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.rate = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.maxRate = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.maxChangeRate = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      rate: N(n.rate) ? globalThis.String(n.rate) : "",
      maxRate: N(n.maxRate) ? globalThis.String(n.maxRate) : "",
      maxChangeRate: N(n.maxChangeRate) ? globalThis.String(n.maxChangeRate) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.rate !== "" && (e.rate = n.rate), n.maxRate !== "" && (e.maxRate = n.maxRate), n.maxChangeRate !== "" && (e.maxChangeRate = n.maxChangeRate), e;
  },
  create(n) {
    return cn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Dr();
    return e.rate = n.rate ?? "", e.maxRate = n.maxRate ?? "", e.maxChangeRate = n.maxChangeRate ?? "", e;
  }
};
function Vr() {
  return { commissionRates: void 0, updateTime: void 0 };
}
const Fn = {
  encode(n, e = new g()) {
    return n.commissionRates !== void 0 && cn.encode(n.commissionRates, e.uint32(10).fork()).join(), n.updateTime !== void 0 && U.encode(Ue(n.updateTime), e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Vr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.commissionRates = cn.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.updateTime = ye(U.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      commissionRates: N(n.commissionRates) ? cn.fromJSON(n.commissionRates) : void 0,
      updateTime: N(n.updateTime) ? He(n.updateTime) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.commissionRates !== void 0 && (e.commissionRates = cn.toJSON(n.commissionRates)), n.updateTime !== void 0 && (e.updateTime = n.updateTime.toISOString()), e;
  },
  create(n) {
    return Fn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Vr();
    return e.commissionRates = n.commissionRates !== void 0 && n.commissionRates !== null ? cn.fromPartial(n.commissionRates) : void 0, e.updateTime = n.updateTime ?? void 0, e;
  }
};
function Fr() {
  return { moniker: "", identity: "", website: "", securityContact: "", details: "" };
}
const J = {
  encode(n, e = new g()) {
    return n.moniker !== "" && e.uint32(10).string(n.moniker), n.identity !== "" && e.uint32(18).string(n.identity), n.website !== "" && e.uint32(26).string(n.website), n.securityContact !== "" && e.uint32(34).string(n.securityContact), n.details !== "" && e.uint32(42).string(n.details), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Fr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.moniker = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.identity = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.website = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.securityContact = t.string();
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.details = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      moniker: N(n.moniker) ? globalThis.String(n.moniker) : "",
      identity: N(n.identity) ? globalThis.String(n.identity) : "",
      website: N(n.website) ? globalThis.String(n.website) : "",
      securityContact: N(n.securityContact) ? globalThis.String(n.securityContact) : "",
      details: N(n.details) ? globalThis.String(n.details) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.moniker !== "" && (e.moniker = n.moniker), n.identity !== "" && (e.identity = n.identity), n.website !== "" && (e.website = n.website), n.securityContact !== "" && (e.securityContact = n.securityContact), n.details !== "" && (e.details = n.details), e;
  },
  create(n) {
    return J.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Fr();
    return e.moniker = n.moniker ?? "", e.identity = n.identity ?? "", e.website = n.website ?? "", e.securityContact = n.securityContact ?? "", e.details = n.details ?? "", e;
  }
};
function Lr() {
  return {
    operatorAddress: "",
    consensusPubkey: void 0,
    jailed: !1,
    status: 0,
    tokens: "",
    delegatorShares: "",
    description: void 0,
    unbondingHeight: 0,
    unbondingTime: void 0,
    commission: void 0,
    minSelfDelegation: "",
    unbondingOnHoldRefCount: 0,
    unbondingIds: []
  };
}
const Ln = {
  encode(n, e = new g()) {
    n.operatorAddress !== "" && e.uint32(10).string(n.operatorAddress), n.consensusPubkey !== void 0 && un.encode(n.consensusPubkey, e.uint32(18).fork()).join(), n.jailed !== !1 && e.uint32(24).bool(n.jailed), n.status !== 0 && e.uint32(32).int32(n.status), n.tokens !== "" && e.uint32(42).string(n.tokens), n.delegatorShares !== "" && e.uint32(50).string(n.delegatorShares), n.description !== void 0 && J.encode(n.description, e.uint32(58).fork()).join(), n.unbondingHeight !== 0 && e.uint32(64).int64(n.unbondingHeight), n.unbondingTime !== void 0 && U.encode(Ue(n.unbondingTime), e.uint32(74).fork()).join(), n.commission !== void 0 && Fn.encode(n.commission, e.uint32(82).fork()).join(), n.minSelfDelegation !== "" && e.uint32(90).string(n.minSelfDelegation), n.unbondingOnHoldRefCount !== 0 && e.uint32(96).int64(n.unbondingOnHoldRefCount), e.uint32(106).fork();
    for (const t of n.unbondingIds)
      e.uint64(t);
    return e.join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Lr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.operatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.consensusPubkey = un.decode(t, t.uint32());
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.jailed = t.bool();
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.status = t.int32();
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.tokens = t.string();
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.delegatorShares = t.string();
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.description = J.decode(t, t.uint32());
          continue;
        }
        case 8: {
          if (i !== 64)
            break;
          r.unbondingHeight = wn(t.int64());
          continue;
        }
        case 9: {
          if (i !== 74)
            break;
          r.unbondingTime = ye(U.decode(t, t.uint32()));
          continue;
        }
        case 10: {
          if (i !== 82)
            break;
          r.commission = Fn.decode(t, t.uint32());
          continue;
        }
        case 11: {
          if (i !== 90)
            break;
          r.minSelfDelegation = t.string();
          continue;
        }
        case 12: {
          if (i !== 96)
            break;
          r.unbondingOnHoldRefCount = wn(t.int64());
          continue;
        }
        case 13: {
          if (i === 104) {
            r.unbondingIds.push(wn(t.uint64()));
            continue;
          }
          if (i === 106) {
            const h = t.uint32() + t.pos;
            for (; t.pos < h; )
              r.unbondingIds.push(wn(t.uint64()));
            continue;
          }
          break;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      operatorAddress: N(n.operatorAddress) ? globalThis.String(n.operatorAddress) : "",
      consensusPubkey: N(n.consensusPubkey) ? un.fromJSON(n.consensusPubkey) : void 0,
      jailed: N(n.jailed) ? globalThis.Boolean(n.jailed) : !1,
      status: N(n.status) ? Ms(n.status) : 0,
      tokens: N(n.tokens) ? globalThis.String(n.tokens) : "",
      delegatorShares: N(n.delegatorShares) ? globalThis.String(n.delegatorShares) : "",
      description: N(n.description) ? J.fromJSON(n.description) : void 0,
      unbondingHeight: N(n.unbondingHeight) ? globalThis.Number(n.unbondingHeight) : 0,
      unbondingTime: N(n.unbondingTime) ? He(n.unbondingTime) : void 0,
      commission: N(n.commission) ? Fn.fromJSON(n.commission) : void 0,
      minSelfDelegation: N(n.minSelfDelegation) ? globalThis.String(n.minSelfDelegation) : "",
      unbondingOnHoldRefCount: N(n.unbondingOnHoldRefCount) ? globalThis.Number(n.unbondingOnHoldRefCount) : 0,
      unbondingIds: globalThis.Array.isArray(n == null ? void 0 : n.unbondingIds) ? n.unbondingIds.map((e) => globalThis.Number(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.operatorAddress !== "" && (e.operatorAddress = n.operatorAddress), n.consensusPubkey !== void 0 && (e.consensusPubkey = un.toJSON(n.consensusPubkey)), n.jailed !== !1 && (e.jailed = n.jailed), n.status !== 0 && (e.status = Ds(n.status)), n.tokens !== "" && (e.tokens = n.tokens), n.delegatorShares !== "" && (e.delegatorShares = n.delegatorShares), n.description !== void 0 && (e.description = J.toJSON(n.description)), n.unbondingHeight !== 0 && (e.unbondingHeight = Math.round(n.unbondingHeight)), n.unbondingTime !== void 0 && (e.unbondingTime = n.unbondingTime.toISOString()), n.commission !== void 0 && (e.commission = Fn.toJSON(n.commission)), n.minSelfDelegation !== "" && (e.minSelfDelegation = n.minSelfDelegation), n.unbondingOnHoldRefCount !== 0 && (e.unbondingOnHoldRefCount = Math.round(n.unbondingOnHoldRefCount)), (t = n.unbondingIds) != null && t.length && (e.unbondingIds = n.unbondingIds.map((o) => Math.round(o))), e;
  },
  create(n) {
    return Ln.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Lr();
    return e.operatorAddress = n.operatorAddress ?? "", e.consensusPubkey = n.consensusPubkey !== void 0 && n.consensusPubkey !== null ? un.fromPartial(n.consensusPubkey) : void 0, e.jailed = n.jailed ?? !1, e.status = n.status ?? 0, e.tokens = n.tokens ?? "", e.delegatorShares = n.delegatorShares ?? "", e.description = n.description !== void 0 && n.description !== null ? J.fromPartial(n.description) : void 0, e.unbondingHeight = n.unbondingHeight ?? 0, e.unbondingTime = n.unbondingTime ?? void 0, e.commission = n.commission !== void 0 && n.commission !== null ? Fn.fromPartial(n.commission) : void 0, e.minSelfDelegation = n.minSelfDelegation ?? "", e.unbondingOnHoldRefCount = n.unbondingOnHoldRefCount ?? 0, e.unbondingIds = ((t = n.unbondingIds) == null ? void 0 : t.map((o) => o)) || [], e;
  }
};
function Gr() {
  return { addresses: [] };
}
const Ls = {
  encode(n, e = new g()) {
    for (const t of n.addresses)
      e.uint32(10).string(t);
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Gr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.addresses.push(t.string());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      addresses: globalThis.Array.isArray(n == null ? void 0 : n.addresses) ? n.addresses.map((e) => globalThis.String(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.addresses) != null && t.length && (e.addresses = n.addresses), e;
  },
  create(n) {
    return Ls.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Gr();
    return e.addresses = ((t = n.addresses) == null ? void 0 : t.map((o) => o)) || [], e;
  }
};
function Wr() {
  return { delegatorAddress: "", validatorAddress: "" };
}
const Gn = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Wr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: N(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: N(n.validatorAddress) ? globalThis.String(n.validatorAddress) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), e;
  },
  create(n) {
    return Gn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Wr();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e;
  }
};
function $r() {
  return { pairs: [] };
}
const Gs = {
  encode(n, e = new g()) {
    for (const t of n.pairs)
      Gn.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = $r();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.pairs.push(Gn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { pairs: globalThis.Array.isArray(n == null ? void 0 : n.pairs) ? n.pairs.map((e) => Gn.fromJSON(e)) : [] };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.pairs) != null && t.length && (e.pairs = n.pairs.map((o) => Gn.toJSON(o))), e;
  },
  create(n) {
    return Gs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = $r();
    return e.pairs = ((t = n.pairs) == null ? void 0 : t.map((o) => Gn.fromPartial(o))) || [], e;
  }
};
function Qr() {
  return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "" };
}
const Wn = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorSrcAddress !== "" && e.uint32(18).string(n.validatorSrcAddress), n.validatorDstAddress !== "" && e.uint32(26).string(n.validatorDstAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Qr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorSrcAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.validatorDstAddress = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: N(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorSrcAddress: N(n.validatorSrcAddress) ? globalThis.String(n.validatorSrcAddress) : "",
      validatorDstAddress: N(n.validatorDstAddress) ? globalThis.String(n.validatorDstAddress) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorSrcAddress !== "" && (e.validatorSrcAddress = n.validatorSrcAddress), n.validatorDstAddress !== "" && (e.validatorDstAddress = n.validatorDstAddress), e;
  },
  create(n) {
    return Wn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Qr();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorSrcAddress = n.validatorSrcAddress ?? "", e.validatorDstAddress = n.validatorDstAddress ?? "", e;
  }
};
function qr() {
  return { triplets: [] };
}
const Ws = {
  encode(n, e = new g()) {
    for (const t of n.triplets)
      Wn.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = qr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.triplets.push(Wn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      triplets: globalThis.Array.isArray(n == null ? void 0 : n.triplets) ? n.triplets.map((e) => Wn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.triplets) != null && t.length && (e.triplets = n.triplets.map((o) => Wn.toJSON(o))), e;
  },
  create(n) {
    return Ws.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = qr();
    return e.triplets = ((t = n.triplets) == null ? void 0 : t.map((o) => Wn.fromPartial(o))) || [], e;
  }
};
function Xr() {
  return { delegatorAddress: "", validatorAddress: "", shares: "" };
}
const $n = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress), n.shares !== "" && e.uint32(26).string(n.shares), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Xr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.shares = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: N(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: N(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      shares: N(n.shares) ? globalThis.String(n.shares) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), n.shares !== "" && (e.shares = n.shares), e;
  },
  create(n) {
    return $n.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Xr();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e.shares = n.shares ?? "", e;
  }
};
function Kr() {
  return { delegatorAddress: "", validatorAddress: "", entries: [] };
}
const $s = {
  encode(n, e = new g()) {
    n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress);
    for (const t of n.entries)
      Qn.encode(t, e.uint32(26).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Kr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.entries.push(Qn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: N(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: N(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      entries: globalThis.Array.isArray(n == null ? void 0 : n.entries) ? n.entries.map((e) => Qn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), (t = n.entries) != null && t.length && (e.entries = n.entries.map((o) => Qn.toJSON(o))), e;
  },
  create(n) {
    return $s.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Kr();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e.entries = ((t = n.entries) == null ? void 0 : t.map((o) => Qn.fromPartial(o))) || [], e;
  }
};
function Zr() {
  return {
    creationHeight: 0,
    completionTime: void 0,
    initialBalance: "",
    balance: "",
    unbondingId: 0,
    unbondingOnHoldRefCount: 0
  };
}
const Qn = {
  encode(n, e = new g()) {
    return n.creationHeight !== 0 && e.uint32(8).int64(n.creationHeight), n.completionTime !== void 0 && U.encode(Ue(n.completionTime), e.uint32(18).fork()).join(), n.initialBalance !== "" && e.uint32(26).string(n.initialBalance), n.balance !== "" && e.uint32(34).string(n.balance), n.unbondingId !== 0 && e.uint32(40).uint64(n.unbondingId), n.unbondingOnHoldRefCount !== 0 && e.uint32(48).int64(n.unbondingOnHoldRefCount), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Zr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.creationHeight = wn(t.int64());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.completionTime = ye(U.decode(t, t.uint32()));
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.initialBalance = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.balance = t.string();
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.unbondingId = wn(t.uint64());
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.unbondingOnHoldRefCount = wn(t.int64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      creationHeight: N(n.creationHeight) ? globalThis.Number(n.creationHeight) : 0,
      completionTime: N(n.completionTime) ? He(n.completionTime) : void 0,
      initialBalance: N(n.initialBalance) ? globalThis.String(n.initialBalance) : "",
      balance: N(n.balance) ? globalThis.String(n.balance) : "",
      unbondingId: N(n.unbondingId) ? globalThis.Number(n.unbondingId) : 0,
      unbondingOnHoldRefCount: N(n.unbondingOnHoldRefCount) ? globalThis.Number(n.unbondingOnHoldRefCount) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.creationHeight !== 0 && (e.creationHeight = Math.round(n.creationHeight)), n.completionTime !== void 0 && (e.completionTime = n.completionTime.toISOString()), n.initialBalance !== "" && (e.initialBalance = n.initialBalance), n.balance !== "" && (e.balance = n.balance), n.unbondingId !== 0 && (e.unbondingId = Math.round(n.unbondingId)), n.unbondingOnHoldRefCount !== 0 && (e.unbondingOnHoldRefCount = Math.round(n.unbondingOnHoldRefCount)), e;
  },
  create(n) {
    return Qn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Zr();
    return e.creationHeight = n.creationHeight ?? 0, e.completionTime = n.completionTime ?? void 0, e.initialBalance = n.initialBalance ?? "", e.balance = n.balance ?? "", e.unbondingId = n.unbondingId ?? 0, e.unbondingOnHoldRefCount = n.unbondingOnHoldRefCount ?? 0, e;
  }
};
function zr() {
  return {
    creationHeight: 0,
    completionTime: void 0,
    initialBalance: "",
    sharesDst: "",
    unbondingId: 0,
    unbondingOnHoldRefCount: 0
  };
}
const ln = {
  encode(n, e = new g()) {
    return n.creationHeight !== 0 && e.uint32(8).int64(n.creationHeight), n.completionTime !== void 0 && U.encode(Ue(n.completionTime), e.uint32(18).fork()).join(), n.initialBalance !== "" && e.uint32(26).string(n.initialBalance), n.sharesDst !== "" && e.uint32(34).string(n.sharesDst), n.unbondingId !== 0 && e.uint32(40).uint64(n.unbondingId), n.unbondingOnHoldRefCount !== 0 && e.uint32(48).int64(n.unbondingOnHoldRefCount), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = zr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.creationHeight = wn(t.int64());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.completionTime = ye(U.decode(t, t.uint32()));
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.initialBalance = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.sharesDst = t.string();
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.unbondingId = wn(t.uint64());
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.unbondingOnHoldRefCount = wn(t.int64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      creationHeight: N(n.creationHeight) ? globalThis.Number(n.creationHeight) : 0,
      completionTime: N(n.completionTime) ? He(n.completionTime) : void 0,
      initialBalance: N(n.initialBalance) ? globalThis.String(n.initialBalance) : "",
      sharesDst: N(n.sharesDst) ? globalThis.String(n.sharesDst) : "",
      unbondingId: N(n.unbondingId) ? globalThis.Number(n.unbondingId) : 0,
      unbondingOnHoldRefCount: N(n.unbondingOnHoldRefCount) ? globalThis.Number(n.unbondingOnHoldRefCount) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.creationHeight !== 0 && (e.creationHeight = Math.round(n.creationHeight)), n.completionTime !== void 0 && (e.completionTime = n.completionTime.toISOString()), n.initialBalance !== "" && (e.initialBalance = n.initialBalance), n.sharesDst !== "" && (e.sharesDst = n.sharesDst), n.unbondingId !== 0 && (e.unbondingId = Math.round(n.unbondingId)), n.unbondingOnHoldRefCount !== 0 && (e.unbondingOnHoldRefCount = Math.round(n.unbondingOnHoldRefCount)), e;
  },
  create(n) {
    return ln.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = zr();
    return e.creationHeight = n.creationHeight ?? 0, e.completionTime = n.completionTime ?? void 0, e.initialBalance = n.initialBalance ?? "", e.sharesDst = n.sharesDst ?? "", e.unbondingId = n.unbondingId ?? 0, e.unbondingOnHoldRefCount = n.unbondingOnHoldRefCount ?? 0, e;
  }
};
function Yr() {
  return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "", entries: [] };
}
const qn = {
  encode(n, e = new g()) {
    n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorSrcAddress !== "" && e.uint32(18).string(n.validatorSrcAddress), n.validatorDstAddress !== "" && e.uint32(26).string(n.validatorDstAddress);
    for (const t of n.entries)
      ln.encode(t, e.uint32(34).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Yr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorSrcAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.validatorDstAddress = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.entries.push(ln.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: N(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorSrcAddress: N(n.validatorSrcAddress) ? globalThis.String(n.validatorSrcAddress) : "",
      validatorDstAddress: N(n.validatorDstAddress) ? globalThis.String(n.validatorDstAddress) : "",
      entries: globalThis.Array.isArray(n == null ? void 0 : n.entries) ? n.entries.map((e) => ln.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorSrcAddress !== "" && (e.validatorSrcAddress = n.validatorSrcAddress), n.validatorDstAddress !== "" && (e.validatorDstAddress = n.validatorDstAddress), (t = n.entries) != null && t.length && (e.entries = n.entries.map((o) => ln.toJSON(o))), e;
  },
  create(n) {
    return qn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Yr();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorSrcAddress = n.validatorSrcAddress ?? "", e.validatorDstAddress = n.validatorDstAddress ?? "", e.entries = ((t = n.entries) == null ? void 0 : t.map((o) => ln.fromPartial(o))) || [], e;
  }
};
function jr() {
  return {
    unbondingTime: void 0,
    maxValidators: 0,
    maxEntries: 0,
    historicalEntries: 0,
    bondDenom: "",
    minCommissionRate: ""
  };
}
const Xn = {
  encode(n, e = new g()) {
    return n.unbondingTime !== void 0 && de.encode(n.unbondingTime, e.uint32(10).fork()).join(), n.maxValidators !== 0 && e.uint32(16).uint32(n.maxValidators), n.maxEntries !== 0 && e.uint32(24).uint32(n.maxEntries), n.historicalEntries !== 0 && e.uint32(32).uint32(n.historicalEntries), n.bondDenom !== "" && e.uint32(42).string(n.bondDenom), n.minCommissionRate !== "" && e.uint32(50).string(n.minCommissionRate), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = jr();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.unbondingTime = de.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.maxValidators = t.uint32();
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.maxEntries = t.uint32();
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.historicalEntries = t.uint32();
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.bondDenom = t.string();
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.minCommissionRate = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      unbondingTime: N(n.unbondingTime) ? de.fromJSON(n.unbondingTime) : void 0,
      maxValidators: N(n.maxValidators) ? globalThis.Number(n.maxValidators) : 0,
      maxEntries: N(n.maxEntries) ? globalThis.Number(n.maxEntries) : 0,
      historicalEntries: N(n.historicalEntries) ? globalThis.Number(n.historicalEntries) : 0,
      bondDenom: N(n.bondDenom) ? globalThis.String(n.bondDenom) : "",
      minCommissionRate: N(n.minCommissionRate) ? globalThis.String(n.minCommissionRate) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.unbondingTime !== void 0 && (e.unbondingTime = de.toJSON(n.unbondingTime)), n.maxValidators !== 0 && (e.maxValidators = Math.round(n.maxValidators)), n.maxEntries !== 0 && (e.maxEntries = Math.round(n.maxEntries)), n.historicalEntries !== 0 && (e.historicalEntries = Math.round(n.historicalEntries)), n.bondDenom !== "" && (e.bondDenom = n.bondDenom), n.minCommissionRate !== "" && (e.minCommissionRate = n.minCommissionRate), e;
  },
  create(n) {
    return Xn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = jr();
    return e.unbondingTime = n.unbondingTime !== void 0 && n.unbondingTime !== null ? de.fromPartial(n.unbondingTime) : void 0, e.maxValidators = n.maxValidators ?? 0, e.maxEntries = n.maxEntries ?? 0, e.historicalEntries = n.historicalEntries ?? 0, e.bondDenom = n.bondDenom ?? "", e.minCommissionRate = n.minCommissionRate ?? "", e;
  }
};
function no() {
  return { delegation: void 0, balance: void 0 };
}
const Qs = {
  encode(n, e = new g()) {
    return n.delegation !== void 0 && $n.encode(n.delegation, e.uint32(10).fork()).join(), n.balance !== void 0 && y.encode(n.balance, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = no();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegation = $n.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.balance = y.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegation: N(n.delegation) ? $n.fromJSON(n.delegation) : void 0,
      balance: N(n.balance) ? y.fromJSON(n.balance) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegation !== void 0 && (e.delegation = $n.toJSON(n.delegation)), n.balance !== void 0 && (e.balance = y.toJSON(n.balance)), e;
  },
  create(n) {
    return Qs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = no();
    return e.delegation = n.delegation !== void 0 && n.delegation !== null ? $n.fromPartial(n.delegation) : void 0, e.balance = n.balance !== void 0 && n.balance !== null ? y.fromPartial(n.balance) : void 0, e;
  }
};
function eo() {
  return { redelegationEntry: void 0, balance: "" };
}
const Kn = {
  encode(n, e = new g()) {
    return n.redelegationEntry !== void 0 && ln.encode(n.redelegationEntry, e.uint32(10).fork()).join(), n.balance !== "" && e.uint32(34).string(n.balance), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = eo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.redelegationEntry = ln.decode(t, t.uint32());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.balance = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      redelegationEntry: N(n.redelegationEntry) ? ln.fromJSON(n.redelegationEntry) : void 0,
      balance: N(n.balance) ? globalThis.String(n.balance) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.redelegationEntry !== void 0 && (e.redelegationEntry = ln.toJSON(n.redelegationEntry)), n.balance !== "" && (e.balance = n.balance), e;
  },
  create(n) {
    return Kn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = eo();
    return e.redelegationEntry = n.redelegationEntry !== void 0 && n.redelegationEntry !== null ? ln.fromPartial(n.redelegationEntry) : void 0, e.balance = n.balance ?? "", e;
  }
};
function to() {
  return { redelegation: void 0, entries: [] };
}
const qs = {
  encode(n, e = new g()) {
    n.redelegation !== void 0 && qn.encode(n.redelegation, e.uint32(10).fork()).join();
    for (const t of n.entries)
      Kn.encode(t, e.uint32(18).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = to();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.redelegation = qn.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.entries.push(Kn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      redelegation: N(n.redelegation) ? qn.fromJSON(n.redelegation) : void 0,
      entries: globalThis.Array.isArray(n == null ? void 0 : n.entries) ? n.entries.map((e) => Kn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.redelegation !== void 0 && (e.redelegation = qn.toJSON(n.redelegation)), (t = n.entries) != null && t.length && (e.entries = n.entries.map((o) => Kn.toJSON(o))), e;
  },
  create(n) {
    return qs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = to();
    return e.redelegation = n.redelegation !== void 0 && n.redelegation !== null ? qn.fromPartial(n.redelegation) : void 0, e.entries = ((t = n.entries) == null ? void 0 : t.map((o) => Kn.fromPartial(o))) || [], e;
  }
};
function io() {
  return { notBondedTokens: "", bondedTokens: "" };
}
const Xs = {
  encode(n, e = new g()) {
    return n.notBondedTokens !== "" && e.uint32(10).string(n.notBondedTokens), n.bondedTokens !== "" && e.uint32(18).string(n.bondedTokens), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = io();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.notBondedTokens = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.bondedTokens = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      notBondedTokens: N(n.notBondedTokens) ? globalThis.String(n.notBondedTokens) : "",
      bondedTokens: N(n.bondedTokens) ? globalThis.String(n.bondedTokens) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.notBondedTokens !== "" && (e.notBondedTokens = n.notBondedTokens), n.bondedTokens !== "" && (e.bondedTokens = n.bondedTokens), e;
  },
  create(n) {
    return Xs.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = io();
    return e.notBondedTokens = n.notBondedTokens ?? "", e.bondedTokens = n.bondedTokens ?? "", e;
  }
};
function ro() {
  return { updates: [] };
}
const Ks = {
  encode(n, e = new g()) {
    for (const t of n.updates)
      ce.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ro();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.updates.push(ce.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      updates: globalThis.Array.isArray(n == null ? void 0 : n.updates) ? n.updates.map((e) => ce.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.updates) != null && t.length && (e.updates = n.updates.map((o) => ce.toJSON(o))), e;
  },
  create(n) {
    return Ks.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = ro();
    return e.updates = ((t = n.updates) == null ? void 0 : t.map((o) => ce.fromPartial(o))) || [], e;
  }
};
function Ue(n) {
  const e = Math.trunc(n.getTime() / 1e3), t = n.getTime() % 1e3 * 1e6;
  return { seconds: e, nanos: t };
}
function ye(n) {
  let e = (n.seconds || 0) * 1e3;
  return e += (n.nanos || 0) / 1e6, new globalThis.Date(e);
}
function He(n) {
  return n instanceof globalThis.Date ? n : typeof n == "string" ? new globalThis.Date(n) : ye(U.fromJSON(n));
}
function wn(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function N(n) {
  return n != null;
}
const wc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BondStatus: _s,
  Commission: Fn,
  CommissionRates: cn,
  DVPair: Gn,
  DVPairs: Gs,
  DVVTriplet: Wn,
  DVVTriplets: Ws,
  Delegation: $n,
  DelegationResponse: Qs,
  Description: J,
  HistoricalInfo: Fs,
  Infraction: Vs,
  Params: Xn,
  Pool: Xs,
  Redelegation: qn,
  RedelegationEntry: ln,
  RedelegationEntryResponse: Kn,
  RedelegationResponse: qs,
  UnbondingDelegation: $s,
  UnbondingDelegationEntry: Qn,
  ValAddresses: Ls,
  Validator: Ln,
  ValidatorUpdates: Ks,
  bondStatusFromJSON: Ms,
  bondStatusToJSON: Ds,
  infractionFromJSON: iu,
  infractionToJSON: ru,
  protobufPackage: tu
}, Symbol.toStringTag, { value: "Module" })), ou = "babylon.btcstaking.v1";
var Zs = /* @__PURE__ */ ((n) => (n[n.BIP340 = 0] = "BIP340", n[n.BIP322 = 1] = "BIP322", n[n.ECDSA = 2] = "ECDSA", n[n.UNRECOGNIZED = -1] = "UNRECOGNIZED", n))(Zs || {});
function zs(n) {
  switch (n) {
    case 0:
    case "BIP340":
      return 0;
    case 1:
    case "BIP322":
      return 1;
    case 2:
    case "ECDSA":
      return 2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function Ys(n) {
  switch (n) {
    case 0:
      return "BIP340";
    case 1:
      return "BIP322";
    case 2:
      return "ECDSA";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function oo() {
  return { btcSigType: 0, btcSig: new Uint8Array(0) };
}
const V = {
  encode(n, e = new g()) {
    return n.btcSigType !== 0 && e.uint32(8).int32(n.btcSigType), n.btcSig.length !== 0 && e.uint32(18).bytes(n.btcSig), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = oo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.btcSigType = t.int32();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.btcSig = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      btcSigType: xe(n.btcSigType) ? zs(n.btcSigType) : 0,
      btcSig: xe(n.btcSig) ? nd(n.btcSig) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.btcSigType !== 0 && (e.btcSigType = Ys(n.btcSigType)), n.btcSig.length !== 0 && (e.btcSig = ed(n.btcSig)), e;
  },
  create(n) {
    return V.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = oo();
    return e.btcSigType = n.btcSigType ?? 0, e.btcSig = n.btcSig ?? new Uint8Array(0), e;
  }
};
function ao() {
  return { address: "", sig: new Uint8Array(0) };
}
const js = {
  encode(n, e = new g()) {
    return n.address !== "" && e.uint32(10).string(n.address), n.sig.length !== 0 && e.uint32(18).bytes(n.sig), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ao();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.address = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.sig = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      address: xe(n.address) ? globalThis.String(n.address) : "",
      sig: xe(n.sig) ? nd(n.sig) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.address !== "" && (e.address = n.address), n.sig.length !== 0 && (e.sig = ed(n.sig)), e;
  },
  create(n) {
    return js.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ao();
    return e.address = n.address ?? "", e.sig = n.sig ?? new Uint8Array(0), e;
  }
};
function nd(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function ed(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function xe(n) {
  return n != null;
}
const Ac = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BIP322Sig: js,
  BTCSigType: Zs,
  ProofOfPossessionBTC: V,
  bTCSigTypeFromJSON: zs,
  bTCSigTypeToJSON: Ys,
  protobufPackage: ou
}, Symbol.toStringTag, { value: "Module" })), au = "babylon.btcstaking.v1";
var td = /* @__PURE__ */ ((n) => (n[n.PENDING = 0] = "PENDING", n[n.VERIFIED = 1] = "VERIFIED", n[n.ACTIVE = 2] = "ACTIVE", n[n.UNBONDED = 3] = "UNBONDED", n[n.EXPIRED = 4] = "EXPIRED", n[n.ANY = 5] = "ANY", n[n.UNRECOGNIZED = -1] = "UNRECOGNIZED", n))(td || {});
function su(n) {
  switch (n) {
    case 0:
    case "PENDING":
      return 0;
    case 1:
    case "VERIFIED":
      return 1;
    case 2:
    case "ACTIVE":
      return 2;
    case 3:
    case "UNBONDED":
      return 3;
    case 4:
    case "EXPIRED":
      return 4;
    case 5:
    case "ANY":
      return 5;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function du(n) {
  switch (n) {
    case 0:
      return "PENDING";
    case 1:
      return "VERIFIED";
    case 2:
      return "ACTIVE";
    case 3:
      return "UNBONDED";
    case 4:
      return "EXPIRED";
    case 5:
      return "ANY";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function so() {
  return {
    addr: "",
    description: void 0,
    commission: "",
    btcPk: new Uint8Array(0),
    pop: void 0,
    slashedBabylonHeight: 0,
    slashedBtcHeight: 0,
    jailed: !1,
    highestVotedHeight: 0,
    bsnId: "",
    commissionInfo: void 0
  };
}
const id = {
  encode(n, e = new g()) {
    return n.addr !== "" && e.uint32(10).string(n.addr), n.description !== void 0 && J.encode(n.description, e.uint32(18).fork()).join(), n.commission !== "" && e.uint32(26).string(n.commission), n.btcPk.length !== 0 && e.uint32(34).bytes(n.btcPk), n.pop !== void 0 && V.encode(n.pop, e.uint32(42).fork()).join(), n.slashedBabylonHeight !== 0 && e.uint32(48).uint64(n.slashedBabylonHeight), n.slashedBtcHeight !== 0 && e.uint32(56).uint32(n.slashedBtcHeight), n.jailed !== !1 && e.uint32(64).bool(n.jailed), n.highestVotedHeight !== 0 && e.uint32(72).uint32(n.highestVotedHeight), n.bsnId !== "" && e.uint32(82).string(n.bsnId), n.commissionInfo !== void 0 && Zn.encode(n.commissionInfo, e.uint32(90).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = so();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.addr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.description = J.decode(t, t.uint32());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.commission = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.pop = V.decode(t, t.uint32());
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.slashedBabylonHeight = Te(t.uint64());
          continue;
        }
        case 7: {
          if (i !== 56)
            break;
          r.slashedBtcHeight = t.uint32();
          continue;
        }
        case 8: {
          if (i !== 64)
            break;
          r.jailed = t.bool();
          continue;
        }
        case 9: {
          if (i !== 72)
            break;
          r.highestVotedHeight = t.uint32();
          continue;
        }
        case 10: {
          if (i !== 82)
            break;
          r.bsnId = t.string();
          continue;
        }
        case 11: {
          if (i !== 90)
            break;
          r.commissionInfo = Zn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      addr: P(n.addr) ? globalThis.String(n.addr) : "",
      description: P(n.description) ? J.fromJSON(n.description) : void 0,
      commission: P(n.commission) ? globalThis.String(n.commission) : "",
      btcPk: P(n.btcPk) ? L(n.btcPk) : new Uint8Array(0),
      pop: P(n.pop) ? V.fromJSON(n.pop) : void 0,
      slashedBabylonHeight: P(n.slashedBabylonHeight) ? globalThis.Number(n.slashedBabylonHeight) : 0,
      slashedBtcHeight: P(n.slashedBtcHeight) ? globalThis.Number(n.slashedBtcHeight) : 0,
      jailed: P(n.jailed) ? globalThis.Boolean(n.jailed) : !1,
      highestVotedHeight: P(n.highestVotedHeight) ? globalThis.Number(n.highestVotedHeight) : 0,
      bsnId: P(n.bsnId) ? globalThis.String(n.bsnId) : "",
      commissionInfo: P(n.commissionInfo) ? Zn.fromJSON(n.commissionInfo) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.addr !== "" && (e.addr = n.addr), n.description !== void 0 && (e.description = J.toJSON(n.description)), n.commission !== "" && (e.commission = n.commission), n.btcPk.length !== 0 && (e.btcPk = G(n.btcPk)), n.pop !== void 0 && (e.pop = V.toJSON(n.pop)), n.slashedBabylonHeight !== 0 && (e.slashedBabylonHeight = Math.round(n.slashedBabylonHeight)), n.slashedBtcHeight !== 0 && (e.slashedBtcHeight = Math.round(n.slashedBtcHeight)), n.jailed !== !1 && (e.jailed = n.jailed), n.highestVotedHeight !== 0 && (e.highestVotedHeight = Math.round(n.highestVotedHeight)), n.bsnId !== "" && (e.bsnId = n.bsnId), n.commissionInfo !== void 0 && (e.commissionInfo = Zn.toJSON(n.commissionInfo)), e;
  },
  create(n) {
    return id.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = so();
    return e.addr = n.addr ?? "", e.description = n.description !== void 0 && n.description !== null ? J.fromPartial(n.description) : void 0, e.commission = n.commission ?? "", e.btcPk = n.btcPk ?? new Uint8Array(0), e.pop = n.pop !== void 0 && n.pop !== null ? V.fromPartial(n.pop) : void 0, e.slashedBabylonHeight = n.slashedBabylonHeight ?? 0, e.slashedBtcHeight = n.slashedBtcHeight ?? 0, e.jailed = n.jailed ?? !1, e.highestVotedHeight = n.highestVotedHeight ?? 0, e.bsnId = n.bsnId ?? "", e.commissionInfo = n.commissionInfo !== void 0 && n.commissionInfo !== null ? Zn.fromPartial(n.commissionInfo) : void 0, e;
  }
};
function uo() {
  return { maxRate: "", maxChangeRate: "", updateTime: void 0 };
}
const Zn = {
  encode(n, e = new g()) {
    return n.maxRate !== "" && e.uint32(10).string(n.maxRate), n.maxChangeRate !== "" && e.uint32(18).string(n.maxChangeRate), n.updateTime !== void 0 && U.encode(uu(n.updateTime), e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = uo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.maxRate = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.maxChangeRate = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.updateTime = ud(U.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      maxRate: P(n.maxRate) ? globalThis.String(n.maxRate) : "",
      maxChangeRate: P(n.maxChangeRate) ? globalThis.String(n.maxChangeRate) : "",
      updateTime: P(n.updateTime) ? cu(n.updateTime) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.maxRate !== "" && (e.maxRate = n.maxRate), n.maxChangeRate !== "" && (e.maxChangeRate = n.maxChangeRate), n.updateTime !== void 0 && (e.updateTime = n.updateTime.toISOString()), e;
  },
  create(n) {
    return Zn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = uo();
    return e.maxRate = n.maxRate ?? "", e.maxChangeRate = n.maxChangeRate ?? "", e.updateTime = n.updateTime ?? void 0, e;
  }
};
function co() {
  return {
    btcPk: new Uint8Array(0),
    height: 0,
    votingPower: 0,
    slashedBabylonHeight: 0,
    slashedBtcHeight: 0,
    jailed: !1,
    highestVotedHeight: 0
  };
}
const rd = {
  encode(n, e = new g()) {
    return n.btcPk.length !== 0 && e.uint32(10).bytes(n.btcPk), n.height !== 0 && e.uint32(16).uint64(n.height), n.votingPower !== 0 && e.uint32(24).uint64(n.votingPower), n.slashedBabylonHeight !== 0 && e.uint32(32).uint64(n.slashedBabylonHeight), n.slashedBtcHeight !== 0 && e.uint32(40).uint32(n.slashedBtcHeight), n.jailed !== !1 && e.uint32(48).bool(n.jailed), n.highestVotedHeight !== 0 && e.uint32(56).uint32(n.highestVotedHeight), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = co();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.height = Te(t.uint64());
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.votingPower = Te(t.uint64());
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.slashedBabylonHeight = Te(t.uint64());
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.slashedBtcHeight = t.uint32();
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.jailed = t.bool();
          continue;
        }
        case 7: {
          if (i !== 56)
            break;
          r.highestVotedHeight = t.uint32();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      btcPk: P(n.btcPk) ? L(n.btcPk) : new Uint8Array(0),
      height: P(n.height) ? globalThis.Number(n.height) : 0,
      votingPower: P(n.votingPower) ? globalThis.Number(n.votingPower) : 0,
      slashedBabylonHeight: P(n.slashedBabylonHeight) ? globalThis.Number(n.slashedBabylonHeight) : 0,
      slashedBtcHeight: P(n.slashedBtcHeight) ? globalThis.Number(n.slashedBtcHeight) : 0,
      jailed: P(n.jailed) ? globalThis.Boolean(n.jailed) : !1,
      highestVotedHeight: P(n.highestVotedHeight) ? globalThis.Number(n.highestVotedHeight) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.btcPk.length !== 0 && (e.btcPk = G(n.btcPk)), n.height !== 0 && (e.height = Math.round(n.height)), n.votingPower !== 0 && (e.votingPower = Math.round(n.votingPower)), n.slashedBabylonHeight !== 0 && (e.slashedBabylonHeight = Math.round(n.slashedBabylonHeight)), n.slashedBtcHeight !== 0 && (e.slashedBtcHeight = Math.round(n.slashedBtcHeight)), n.jailed !== !1 && (e.jailed = n.jailed), n.highestVotedHeight !== 0 && (e.highestVotedHeight = Math.round(n.highestVotedHeight)), e;
  },
  create(n) {
    return rd.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = co();
    return e.btcPk = n.btcPk ?? new Uint8Array(0), e.height = n.height ?? 0, e.votingPower = n.votingPower ?? 0, e.slashedBabylonHeight = n.slashedBabylonHeight ?? 0, e.slashedBtcHeight = n.slashedBtcHeight ?? 0, e.jailed = n.jailed ?? !1, e.highestVotedHeight = n.highestVotedHeight ?? 0, e;
  }
};
function lo() {
  return {
    stakerAddr: "",
    btcPk: new Uint8Array(0),
    pop: void 0,
    fpBtcPkList: [],
    stakingTime: 0,
    startHeight: 0,
    endHeight: 0,
    totalSat: 0,
    stakingTx: new Uint8Array(0),
    stakingOutputIdx: 0,
    slashingTx: new Uint8Array(0),
    delegatorSig: new Uint8Array(0),
    covenantSigs: [],
    unbondingTime: 0,
    btcUndelegation: void 0,
    paramsVersion: 0,
    btcTipHeight: 0,
    stkExp: void 0
  };
}
const zn = {
  encode(n, e = new g()) {
    n.stakerAddr !== "" && e.uint32(10).string(n.stakerAddr), n.btcPk.length !== 0 && e.uint32(18).bytes(n.btcPk), n.pop !== void 0 && V.encode(n.pop, e.uint32(26).fork()).join();
    for (const t of n.fpBtcPkList)
      e.uint32(34).bytes(t);
    n.stakingTime !== 0 && e.uint32(40).uint32(n.stakingTime), n.startHeight !== 0 && e.uint32(48).uint32(n.startHeight), n.endHeight !== 0 && e.uint32(56).uint32(n.endHeight), n.totalSat !== 0 && e.uint32(64).uint64(n.totalSat), n.stakingTx.length !== 0 && e.uint32(74).bytes(n.stakingTx), n.stakingOutputIdx !== 0 && e.uint32(80).uint32(n.stakingOutputIdx), n.slashingTx.length !== 0 && e.uint32(90).bytes(n.slashingTx), n.delegatorSig.length !== 0 && e.uint32(98).bytes(n.delegatorSig);
    for (const t of n.covenantSigs)
      hn.encode(t, e.uint32(106).fork()).join();
    return n.unbondingTime !== 0 && e.uint32(112).uint32(n.unbondingTime), n.btcUndelegation !== void 0 && ne.encode(n.btcUndelegation, e.uint32(122).fork()).join(), n.paramsVersion !== 0 && e.uint32(128).uint32(n.paramsVersion), n.btcTipHeight !== 0 && e.uint32(136).uint32(n.btcTipHeight), n.stkExp !== void 0 && Yn.encode(n.stkExp, e.uint32(146).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = lo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.stakerAddr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.pop = V.decode(t, t.uint32());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.fpBtcPkList.push(t.bytes());
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.stakingTime = t.uint32();
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.startHeight = t.uint32();
          continue;
        }
        case 7: {
          if (i !== 56)
            break;
          r.endHeight = t.uint32();
          continue;
        }
        case 8: {
          if (i !== 64)
            break;
          r.totalSat = Te(t.uint64());
          continue;
        }
        case 9: {
          if (i !== 74)
            break;
          r.stakingTx = t.bytes();
          continue;
        }
        case 10: {
          if (i !== 80)
            break;
          r.stakingOutputIdx = t.uint32();
          continue;
        }
        case 11: {
          if (i !== 90)
            break;
          r.slashingTx = t.bytes();
          continue;
        }
        case 12: {
          if (i !== 98)
            break;
          r.delegatorSig = t.bytes();
          continue;
        }
        case 13: {
          if (i !== 106)
            break;
          r.covenantSigs.push(hn.decode(t, t.uint32()));
          continue;
        }
        case 14: {
          if (i !== 112)
            break;
          r.unbondingTime = t.uint32();
          continue;
        }
        case 15: {
          if (i !== 122)
            break;
          r.btcUndelegation = ne.decode(t, t.uint32());
          continue;
        }
        case 16: {
          if (i !== 128)
            break;
          r.paramsVersion = t.uint32();
          continue;
        }
        case 17: {
          if (i !== 136)
            break;
          r.btcTipHeight = t.uint32();
          continue;
        }
        case 18: {
          if (i !== 146)
            break;
          r.stkExp = Yn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      stakerAddr: P(n.stakerAddr) ? globalThis.String(n.stakerAddr) : "",
      btcPk: P(n.btcPk) ? L(n.btcPk) : new Uint8Array(0),
      pop: P(n.pop) ? V.fromJSON(n.pop) : void 0,
      fpBtcPkList: globalThis.Array.isArray(n == null ? void 0 : n.fpBtcPkList) ? n.fpBtcPkList.map((e) => L(e)) : [],
      stakingTime: P(n.stakingTime) ? globalThis.Number(n.stakingTime) : 0,
      startHeight: P(n.startHeight) ? globalThis.Number(n.startHeight) : 0,
      endHeight: P(n.endHeight) ? globalThis.Number(n.endHeight) : 0,
      totalSat: P(n.totalSat) ? globalThis.Number(n.totalSat) : 0,
      stakingTx: P(n.stakingTx) ? L(n.stakingTx) : new Uint8Array(0),
      stakingOutputIdx: P(n.stakingOutputIdx) ? globalThis.Number(n.stakingOutputIdx) : 0,
      slashingTx: P(n.slashingTx) ? L(n.slashingTx) : new Uint8Array(0),
      delegatorSig: P(n.delegatorSig) ? L(n.delegatorSig) : new Uint8Array(0),
      covenantSigs: globalThis.Array.isArray(n == null ? void 0 : n.covenantSigs) ? n.covenantSigs.map((e) => hn.fromJSON(e)) : [],
      unbondingTime: P(n.unbondingTime) ? globalThis.Number(n.unbondingTime) : 0,
      btcUndelegation: P(n.btcUndelegation) ? ne.fromJSON(n.btcUndelegation) : void 0,
      paramsVersion: P(n.paramsVersion) ? globalThis.Number(n.paramsVersion) : 0,
      btcTipHeight: P(n.btcTipHeight) ? globalThis.Number(n.btcTipHeight) : 0,
      stkExp: P(n.stkExp) ? Yn.fromJSON(n.stkExp) : void 0
    };
  },
  toJSON(n) {
    var t, o;
    const e = {};
    return n.stakerAddr !== "" && (e.stakerAddr = n.stakerAddr), n.btcPk.length !== 0 && (e.btcPk = G(n.btcPk)), n.pop !== void 0 && (e.pop = V.toJSON(n.pop)), (t = n.fpBtcPkList) != null && t.length && (e.fpBtcPkList = n.fpBtcPkList.map((r) => G(r))), n.stakingTime !== 0 && (e.stakingTime = Math.round(n.stakingTime)), n.startHeight !== 0 && (e.startHeight = Math.round(n.startHeight)), n.endHeight !== 0 && (e.endHeight = Math.round(n.endHeight)), n.totalSat !== 0 && (e.totalSat = Math.round(n.totalSat)), n.stakingTx.length !== 0 && (e.stakingTx = G(n.stakingTx)), n.stakingOutputIdx !== 0 && (e.stakingOutputIdx = Math.round(n.stakingOutputIdx)), n.slashingTx.length !== 0 && (e.slashingTx = G(n.slashingTx)), n.delegatorSig.length !== 0 && (e.delegatorSig = G(n.delegatorSig)), (o = n.covenantSigs) != null && o.length && (e.covenantSigs = n.covenantSigs.map((r) => hn.toJSON(r))), n.unbondingTime !== 0 && (e.unbondingTime = Math.round(n.unbondingTime)), n.btcUndelegation !== void 0 && (e.btcUndelegation = ne.toJSON(n.btcUndelegation)), n.paramsVersion !== 0 && (e.paramsVersion = Math.round(n.paramsVersion)), n.btcTipHeight !== 0 && (e.btcTipHeight = Math.round(n.btcTipHeight)), n.stkExp !== void 0 && (e.stkExp = Yn.toJSON(n.stkExp)), e;
  },
  create(n) {
    return zn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t, o;
    const e = lo();
    return e.stakerAddr = n.stakerAddr ?? "", e.btcPk = n.btcPk ?? new Uint8Array(0), e.pop = n.pop !== void 0 && n.pop !== null ? V.fromPartial(n.pop) : void 0, e.fpBtcPkList = ((t = n.fpBtcPkList) == null ? void 0 : t.map((r) => r)) || [], e.stakingTime = n.stakingTime ?? 0, e.startHeight = n.startHeight ?? 0, e.endHeight = n.endHeight ?? 0, e.totalSat = n.totalSat ?? 0, e.stakingTx = n.stakingTx ?? new Uint8Array(0), e.stakingOutputIdx = n.stakingOutputIdx ?? 0, e.slashingTx = n.slashingTx ?? new Uint8Array(0), e.delegatorSig = n.delegatorSig ?? new Uint8Array(0), e.covenantSigs = ((o = n.covenantSigs) == null ? void 0 : o.map((r) => hn.fromPartial(r))) || [], e.unbondingTime = n.unbondingTime ?? 0, e.btcUndelegation = n.btcUndelegation !== void 0 && n.btcUndelegation !== null ? ne.fromPartial(n.btcUndelegation) : void 0, e.paramsVersion = n.paramsVersion ?? 0, e.btcTipHeight = n.btcTipHeight ?? 0, e.stkExp = n.stkExp !== void 0 && n.stkExp !== null ? Yn.fromPartial(n.stkExp) : void 0, e;
  }
};
function fo() {
  return {
    previousStakingTxHash: new Uint8Array(0),
    otherFundingTxOut: new Uint8Array(0),
    previousStkCovenantSigs: []
  };
}
const Yn = {
  encode(n, e = new g()) {
    n.previousStakingTxHash.length !== 0 && e.uint32(10).bytes(n.previousStakingTxHash), n.otherFundingTxOut.length !== 0 && e.uint32(18).bytes(n.otherFundingTxOut);
    for (const t of n.previousStkCovenantSigs)
      fn.encode(t, e.uint32(26).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = fo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.previousStakingTxHash = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.otherFundingTxOut = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.previousStkCovenantSigs.push(fn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      previousStakingTxHash: P(n.previousStakingTxHash) ? L(n.previousStakingTxHash) : new Uint8Array(0),
      otherFundingTxOut: P(n.otherFundingTxOut) ? L(n.otherFundingTxOut) : new Uint8Array(0),
      previousStkCovenantSigs: globalThis.Array.isArray(n == null ? void 0 : n.previousStkCovenantSigs) ? n.previousStkCovenantSigs.map((e) => fn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.previousStakingTxHash.length !== 0 && (e.previousStakingTxHash = G(n.previousStakingTxHash)), n.otherFundingTxOut.length !== 0 && (e.otherFundingTxOut = G(n.otherFundingTxOut)), (t = n.previousStkCovenantSigs) != null && t.length && (e.previousStkCovenantSigs = n.previousStkCovenantSigs.map((o) => fn.toJSON(o))), e;
  },
  create(n) {
    return Yn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = fo();
    return e.previousStakingTxHash = n.previousStakingTxHash ?? new Uint8Array(0), e.otherFundingTxOut = n.otherFundingTxOut ?? new Uint8Array(0), e.previousStkCovenantSigs = ((t = n.previousStkCovenantSigs) == null ? void 0 : t.map((o) => fn.fromPartial(o))) || [], e;
  }
};
function ho() {
  return { spendStakeTx: new Uint8Array(0) };
}
const jn = {
  encode(n, e = new g()) {
    return n.spendStakeTx.length !== 0 && e.uint32(10).bytes(n.spendStakeTx), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ho();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.spendStakeTx = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { spendStakeTx: P(n.spendStakeTx) ? L(n.spendStakeTx) : new Uint8Array(0) };
  },
  toJSON(n) {
    const e = {};
    return n.spendStakeTx.length !== 0 && (e.spendStakeTx = G(n.spendStakeTx)), e;
  },
  create(n) {
    return jn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ho();
    return e.spendStakeTx = n.spendStakeTx ?? new Uint8Array(0), e;
  }
};
function go() {
  return {
    unbondingTx: new Uint8Array(0),
    slashingTx: new Uint8Array(0),
    delegatorSlashingSig: new Uint8Array(0),
    covenantSlashingSigs: [],
    covenantUnbondingSigList: [],
    delegatorUnbondingInfo: void 0
  };
}
const ne = {
  encode(n, e = new g()) {
    n.unbondingTx.length !== 0 && e.uint32(10).bytes(n.unbondingTx), n.slashingTx.length !== 0 && e.uint32(18).bytes(n.slashingTx), n.delegatorSlashingSig.length !== 0 && e.uint32(26).bytes(n.delegatorSlashingSig);
    for (const t of n.covenantSlashingSigs)
      hn.encode(t, e.uint32(34).fork()).join();
    for (const t of n.covenantUnbondingSigList)
      fn.encode(t, e.uint32(42).fork()).join();
    return n.delegatorUnbondingInfo !== void 0 && jn.encode(n.delegatorUnbondingInfo, e.uint32(50).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = go();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.unbondingTx = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.slashingTx = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.delegatorSlashingSig = t.bytes();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.covenantSlashingSigs.push(hn.decode(t, t.uint32()));
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.covenantUnbondingSigList.push(fn.decode(t, t.uint32()));
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.delegatorUnbondingInfo = jn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      unbondingTx: P(n.unbondingTx) ? L(n.unbondingTx) : new Uint8Array(0),
      slashingTx: P(n.slashingTx) ? L(n.slashingTx) : new Uint8Array(0),
      delegatorSlashingSig: P(n.delegatorSlashingSig) ? L(n.delegatorSlashingSig) : new Uint8Array(0),
      covenantSlashingSigs: globalThis.Array.isArray(n == null ? void 0 : n.covenantSlashingSigs) ? n.covenantSlashingSigs.map((e) => hn.fromJSON(e)) : [],
      covenantUnbondingSigList: globalThis.Array.isArray(n == null ? void 0 : n.covenantUnbondingSigList) ? n.covenantUnbondingSigList.map((e) => fn.fromJSON(e)) : [],
      delegatorUnbondingInfo: P(n.delegatorUnbondingInfo) ? jn.fromJSON(n.delegatorUnbondingInfo) : void 0
    };
  },
  toJSON(n) {
    var t, o;
    const e = {};
    return n.unbondingTx.length !== 0 && (e.unbondingTx = G(n.unbondingTx)), n.slashingTx.length !== 0 && (e.slashingTx = G(n.slashingTx)), n.delegatorSlashingSig.length !== 0 && (e.delegatorSlashingSig = G(n.delegatorSlashingSig)), (t = n.covenantSlashingSigs) != null && t.length && (e.covenantSlashingSigs = n.covenantSlashingSigs.map((r) => hn.toJSON(r))), (o = n.covenantUnbondingSigList) != null && o.length && (e.covenantUnbondingSigList = n.covenantUnbondingSigList.map((r) => fn.toJSON(r))), n.delegatorUnbondingInfo !== void 0 && (e.delegatorUnbondingInfo = jn.toJSON(n.delegatorUnbondingInfo)), e;
  },
  create(n) {
    return ne.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t, o;
    const e = go();
    return e.unbondingTx = n.unbondingTx ?? new Uint8Array(0), e.slashingTx = n.slashingTx ?? new Uint8Array(0), e.delegatorSlashingSig = n.delegatorSlashingSig ?? new Uint8Array(0), e.covenantSlashingSigs = ((t = n.covenantSlashingSigs) == null ? void 0 : t.map((r) => hn.fromPartial(r))) || [], e.covenantUnbondingSigList = ((o = n.covenantUnbondingSigList) == null ? void 0 : o.map((r) => fn.fromPartial(r))) || [], e.delegatorUnbondingInfo = n.delegatorUnbondingInfo !== void 0 && n.delegatorUnbondingInfo !== null ? jn.fromPartial(n.delegatorUnbondingInfo) : void 0, e;
  }
};
function po() {
  return { dels: [] };
}
const od = {
  encode(n, e = new g()) {
    for (const t of n.dels)
      zn.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = po();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.dels.push(zn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      dels: globalThis.Array.isArray(n == null ? void 0 : n.dels) ? n.dels.map((e) => zn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.dels) != null && t.length && (e.dels = n.dels.map((o) => zn.toJSON(o))), e;
  },
  create(n) {
    return od.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = po();
    return e.dels = ((t = n.dels) == null ? void 0 : t.map((o) => zn.fromPartial(o))) || [], e;
  }
};
function mo() {
  return { stakingTxHashList: [] };
}
const ad = {
  encode(n, e = new g()) {
    for (const t of n.stakingTxHashList)
      e.uint32(10).bytes(t);
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = mo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.stakingTxHashList.push(t.bytes());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      stakingTxHashList: globalThis.Array.isArray(n == null ? void 0 : n.stakingTxHashList) ? n.stakingTxHashList.map((e) => L(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.stakingTxHashList) != null && t.length && (e.stakingTxHashList = n.stakingTxHashList.map((o) => G(o))), e;
  },
  create(n) {
    return ad.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = mo();
    return e.stakingTxHashList = ((t = n.stakingTxHashList) == null ? void 0 : t.map((o) => o)) || [], e;
  }
};
function ko() {
  return { pk: new Uint8Array(0), sig: new Uint8Array(0) };
}
const fn = {
  encode(n, e = new g()) {
    return n.pk.length !== 0 && e.uint32(10).bytes(n.pk), n.sig.length !== 0 && e.uint32(18).bytes(n.sig), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ko();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.pk = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.sig = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      pk: P(n.pk) ? L(n.pk) : new Uint8Array(0),
      sig: P(n.sig) ? L(n.sig) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.pk.length !== 0 && (e.pk = G(n.pk)), n.sig.length !== 0 && (e.sig = G(n.sig)), e;
  },
  create(n) {
    return fn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ko();
    return e.pk = n.pk ?? new Uint8Array(0), e.sig = n.sig ?? new Uint8Array(0), e;
  }
};
function So() {
  return { covPk: new Uint8Array(0), adaptorSigs: [] };
}
const hn = {
  encode(n, e = new g()) {
    n.covPk.length !== 0 && e.uint32(10).bytes(n.covPk);
    for (const t of n.adaptorSigs)
      e.uint32(18).bytes(t);
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = So();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.covPk = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.adaptorSigs.push(t.bytes());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      covPk: P(n.covPk) ? L(n.covPk) : new Uint8Array(0),
      adaptorSigs: globalThis.Array.isArray(n == null ? void 0 : n.adaptorSigs) ? n.adaptorSigs.map((e) => L(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.covPk.length !== 0 && (e.covPk = G(n.covPk)), (t = n.adaptorSigs) != null && t.length && (e.adaptorSigs = n.adaptorSigs.map((o) => G(o))), e;
  },
  create(n) {
    return hn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = So();
    return e.covPk = n.covPk ?? new Uint8Array(0), e.adaptorSigs = ((t = n.adaptorSigs) == null ? void 0 : t.map((o) => o)) || [], e;
  }
};
function bo() {
  return { stakingTxHash: "", fpBtcPk: new Uint8Array(0), recoveredFpBtcSk: new Uint8Array(0) };
}
const sd = {
  encode(n, e = new g()) {
    return n.stakingTxHash !== "" && e.uint32(10).string(n.stakingTxHash), n.fpBtcPk.length !== 0 && e.uint32(18).bytes(n.fpBtcPk), n.recoveredFpBtcSk.length !== 0 && e.uint32(26).bytes(n.recoveredFpBtcSk), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = bo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.stakingTxHash = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.fpBtcPk = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.recoveredFpBtcSk = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      stakingTxHash: P(n.stakingTxHash) ? globalThis.String(n.stakingTxHash) : "",
      fpBtcPk: P(n.fpBtcPk) ? L(n.fpBtcPk) : new Uint8Array(0),
      recoveredFpBtcSk: P(n.recoveredFpBtcSk) ? L(n.recoveredFpBtcSk) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.stakingTxHash !== "" && (e.stakingTxHash = n.stakingTxHash), n.fpBtcPk.length !== 0 && (e.fpBtcPk = G(n.fpBtcPk)), n.recoveredFpBtcSk.length !== 0 && (e.recoveredFpBtcSk = G(n.recoveredFpBtcSk)), e;
  },
  create(n) {
    return sd.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = bo();
    return e.stakingTxHash = n.stakingTxHash ?? "", e.fpBtcPk = n.fpBtcPk ?? new Uint8Array(0), e.recoveredFpBtcSk = n.recoveredFpBtcSk ?? new Uint8Array(0), e;
  }
};
function vo() {
  return { key: void 0, proof: new Uint8Array(0) };
}
const X = {
  encode(n, e = new g()) {
    return n.key !== void 0 && Q.encode(n.key, e.uint32(10).fork()).join(), n.proof.length !== 0 && e.uint32(18).bytes(n.proof), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = vo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.key = Q.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.proof = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      key: P(n.key) ? Q.fromJSON(n.key) : void 0,
      proof: P(n.proof) ? L(n.proof) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.key !== void 0 && (e.key = Q.toJSON(n.key)), n.proof.length !== 0 && (e.proof = G(n.proof)), e;
  },
  create(n) {
    return X.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = vo();
    return e.key = n.key !== void 0 && n.key !== null ? Q.fromPartial(n.key) : void 0, e.proof = n.proof ?? new Uint8Array(0), e;
  }
};
function To() {
  return { blockDiff: 0, rollbackFrom: void 0, rollbackTo: void 0 };
}
const dd = {
  encode(n, e = new g()) {
    return n.blockDiff !== 0 && e.uint32(8).uint32(n.blockDiff), n.rollbackFrom !== void 0 && an.encode(n.rollbackFrom, e.uint32(18).fork()).join(), n.rollbackTo !== void 0 && an.encode(n.rollbackTo, e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = To();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.blockDiff = t.uint32();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.rollbackFrom = an.decode(t, t.uint32());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.rollbackTo = an.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      blockDiff: P(n.blockDiff) ? globalThis.Number(n.blockDiff) : 0,
      rollbackFrom: P(n.rollbackFrom) ? an.fromJSON(n.rollbackFrom) : void 0,
      rollbackTo: P(n.rollbackTo) ? an.fromJSON(n.rollbackTo) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.blockDiff !== 0 && (e.blockDiff = Math.round(n.blockDiff)), n.rollbackFrom !== void 0 && (e.rollbackFrom = an.toJSON(n.rollbackFrom)), n.rollbackTo !== void 0 && (e.rollbackTo = an.toJSON(n.rollbackTo)), e;
  },
  create(n) {
    return dd.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = To();
    return e.blockDiff = n.blockDiff ?? 0, e.rollbackFrom = n.rollbackFrom !== void 0 && n.rollbackFrom !== null ? an.fromPartial(n.rollbackFrom) : void 0, e.rollbackTo = n.rollbackTo !== void 0 && n.rollbackTo !== null ? an.fromPartial(n.rollbackTo) : void 0, e;
  }
};
function L(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function G(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function uu(n) {
  const e = Math.trunc(n.getTime() / 1e3), t = n.getTime() % 1e3 * 1e6;
  return { seconds: e, nanos: t };
}
function ud(n) {
  let e = (n.seconds || 0) * 1e3;
  return e += (n.nanos || 0) / 1e6, new globalThis.Date(e);
}
function cu(n) {
  return n instanceof globalThis.Date ? n : typeof n == "string" ? new globalThis.Date(n) : ud(U.fromJSON(n));
}
function Te(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function P(n) {
  return n != null;
}
const Nc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCDelegation: zn,
  BTCDelegationStatus: td,
  BTCDelegatorDelegationIndex: ad,
  BTCDelegatorDelegations: od,
  BTCUndelegation: ne,
  CommissionInfo: Zn,
  CovenantAdaptorSignatures: hn,
  DelegatorUnbondingInfo: jn,
  FinalityProvider: id,
  FinalityProviderWithMeta: rd,
  InclusionProof: X,
  LargestBtcReOrg: dd,
  SelectiveSlashingEvidence: sd,
  SignatureInfo: fn,
  StakeExpansion: Yn,
  bTCDelegationStatusFromJSON: su,
  bTCDelegationStatusToJSON: du,
  protobufPackage: au
}, Symbol.toStringTag, { value: "Module" }));
function yo() {
  return {
    covenantPks: [],
    covenantQuorum: 0,
    minStakingValueSat: 0,
    maxStakingValueSat: 0,
    minStakingTimeBlocks: 0,
    maxStakingTimeBlocks: 0,
    slashingPkScript: new Uint8Array(0),
    minSlashingTxFeeSat: 0,
    slashingRate: "",
    unbondingTimeBlocks: 0,
    unbondingFeeSat: 0,
    minCommissionRate: "",
    delegationCreationBaseGasFee: 0,
    allowListExpirationHeight: 0,
    btcActivationHeight: 0,
    maxFinalityProviders: 0
  };
}
const pe = {
  encode(n, e = new g()) {
    for (const t of n.covenantPks)
      e.uint32(10).bytes(t);
    return n.covenantQuorum !== 0 && e.uint32(16).uint32(n.covenantQuorum), n.minStakingValueSat !== 0 && e.uint32(24).int64(n.minStakingValueSat), n.maxStakingValueSat !== 0 && e.uint32(32).int64(n.maxStakingValueSat), n.minStakingTimeBlocks !== 0 && e.uint32(40).uint32(n.minStakingTimeBlocks), n.maxStakingTimeBlocks !== 0 && e.uint32(48).uint32(n.maxStakingTimeBlocks), n.slashingPkScript.length !== 0 && e.uint32(58).bytes(n.slashingPkScript), n.minSlashingTxFeeSat !== 0 && e.uint32(64).int64(n.minSlashingTxFeeSat), n.slashingRate !== "" && e.uint32(74).string(n.slashingRate), n.unbondingTimeBlocks !== 0 && e.uint32(80).uint32(n.unbondingTimeBlocks), n.unbondingFeeSat !== 0 && e.uint32(88).int64(n.unbondingFeeSat), n.minCommissionRate !== "" && e.uint32(98).string(n.minCommissionRate), n.delegationCreationBaseGasFee !== 0 && e.uint32(104).uint64(n.delegationCreationBaseGasFee), n.allowListExpirationHeight !== 0 && e.uint32(112).uint64(n.allowListExpirationHeight), n.btcActivationHeight !== 0 && e.uint32(120).uint32(n.btcActivationHeight), n.maxFinalityProviders !== 0 && e.uint32(128).uint32(n.maxFinalityProviders), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = yo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.covenantPks.push(t.bytes());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.covenantQuorum = t.uint32();
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.minStakingValueSat = ae(t.int64());
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.maxStakingValueSat = ae(t.int64());
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.minStakingTimeBlocks = t.uint32();
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.maxStakingTimeBlocks = t.uint32();
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.slashingPkScript = t.bytes();
          continue;
        }
        case 8: {
          if (i !== 64)
            break;
          r.minSlashingTxFeeSat = ae(t.int64());
          continue;
        }
        case 9: {
          if (i !== 74)
            break;
          r.slashingRate = t.string();
          continue;
        }
        case 10: {
          if (i !== 80)
            break;
          r.unbondingTimeBlocks = t.uint32();
          continue;
        }
        case 11: {
          if (i !== 88)
            break;
          r.unbondingFeeSat = ae(t.int64());
          continue;
        }
        case 12: {
          if (i !== 98)
            break;
          r.minCommissionRate = t.string();
          continue;
        }
        case 13: {
          if (i !== 104)
            break;
          r.delegationCreationBaseGasFee = ae(t.uint64());
          continue;
        }
        case 14: {
          if (i !== 112)
            break;
          r.allowListExpirationHeight = ae(t.uint64());
          continue;
        }
        case 15: {
          if (i !== 120)
            break;
          r.btcActivationHeight = t.uint32();
          continue;
        }
        case 16: {
          if (i !== 128)
            break;
          r.maxFinalityProviders = t.uint32();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      covenantPks: globalThis.Array.isArray(n == null ? void 0 : n.covenantPks) ? n.covenantPks.map((e) => wo(e)) : [],
      covenantQuorum: en(n.covenantQuorum) ? globalThis.Number(n.covenantQuorum) : 0,
      minStakingValueSat: en(n.minStakingValueSat) ? globalThis.Number(n.minStakingValueSat) : 0,
      maxStakingValueSat: en(n.maxStakingValueSat) ? globalThis.Number(n.maxStakingValueSat) : 0,
      minStakingTimeBlocks: en(n.minStakingTimeBlocks) ? globalThis.Number(n.minStakingTimeBlocks) : 0,
      maxStakingTimeBlocks: en(n.maxStakingTimeBlocks) ? globalThis.Number(n.maxStakingTimeBlocks) : 0,
      slashingPkScript: en(n.slashingPkScript) ? wo(n.slashingPkScript) : new Uint8Array(0),
      minSlashingTxFeeSat: en(n.minSlashingTxFeeSat) ? globalThis.Number(n.minSlashingTxFeeSat) : 0,
      slashingRate: en(n.slashingRate) ? globalThis.String(n.slashingRate) : "",
      unbondingTimeBlocks: en(n.unbondingTimeBlocks) ? globalThis.Number(n.unbondingTimeBlocks) : 0,
      unbondingFeeSat: en(n.unbondingFeeSat) ? globalThis.Number(n.unbondingFeeSat) : 0,
      minCommissionRate: en(n.minCommissionRate) ? globalThis.String(n.minCommissionRate) : "",
      delegationCreationBaseGasFee: en(n.delegationCreationBaseGasFee) ? globalThis.Number(n.delegationCreationBaseGasFee) : 0,
      allowListExpirationHeight: en(n.allowListExpirationHeight) ? globalThis.Number(n.allowListExpirationHeight) : 0,
      btcActivationHeight: en(n.btcActivationHeight) ? globalThis.Number(n.btcActivationHeight) : 0,
      maxFinalityProviders: en(n.maxFinalityProviders) ? globalThis.Number(n.maxFinalityProviders) : 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.covenantPks) != null && t.length && (e.covenantPks = n.covenantPks.map((o) => Ao(o))), n.covenantQuorum !== 0 && (e.covenantQuorum = Math.round(n.covenantQuorum)), n.minStakingValueSat !== 0 && (e.minStakingValueSat = Math.round(n.minStakingValueSat)), n.maxStakingValueSat !== 0 && (e.maxStakingValueSat = Math.round(n.maxStakingValueSat)), n.minStakingTimeBlocks !== 0 && (e.minStakingTimeBlocks = Math.round(n.minStakingTimeBlocks)), n.maxStakingTimeBlocks !== 0 && (e.maxStakingTimeBlocks = Math.round(n.maxStakingTimeBlocks)), n.slashingPkScript.length !== 0 && (e.slashingPkScript = Ao(n.slashingPkScript)), n.minSlashingTxFeeSat !== 0 && (e.minSlashingTxFeeSat = Math.round(n.minSlashingTxFeeSat)), n.slashingRate !== "" && (e.slashingRate = n.slashingRate), n.unbondingTimeBlocks !== 0 && (e.unbondingTimeBlocks = Math.round(n.unbondingTimeBlocks)), n.unbondingFeeSat !== 0 && (e.unbondingFeeSat = Math.round(n.unbondingFeeSat)), n.minCommissionRate !== "" && (e.minCommissionRate = n.minCommissionRate), n.delegationCreationBaseGasFee !== 0 && (e.delegationCreationBaseGasFee = Math.round(n.delegationCreationBaseGasFee)), n.allowListExpirationHeight !== 0 && (e.allowListExpirationHeight = Math.round(n.allowListExpirationHeight)), n.btcActivationHeight !== 0 && (e.btcActivationHeight = Math.round(n.btcActivationHeight)), n.maxFinalityProviders !== 0 && (e.maxFinalityProviders = Math.round(n.maxFinalityProviders)), e;
  },
  create(n) {
    return pe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = yo();
    return e.covenantPks = ((t = n.covenantPks) == null ? void 0 : t.map((o) => o)) || [], e.covenantQuorum = n.covenantQuorum ?? 0, e.minStakingValueSat = n.minStakingValueSat ?? 0, e.maxStakingValueSat = n.maxStakingValueSat ?? 0, e.minStakingTimeBlocks = n.minStakingTimeBlocks ?? 0, e.maxStakingTimeBlocks = n.maxStakingTimeBlocks ?? 0, e.slashingPkScript = n.slashingPkScript ?? new Uint8Array(0), e.minSlashingTxFeeSat = n.minSlashingTxFeeSat ?? 0, e.slashingRate = n.slashingRate ?? "", e.unbondingTimeBlocks = n.unbondingTimeBlocks ?? 0, e.unbondingFeeSat = n.unbondingFeeSat ?? 0, e.minCommissionRate = n.minCommissionRate ?? "", e.delegationCreationBaseGasFee = n.delegationCreationBaseGasFee ?? 0, e.allowListExpirationHeight = n.allowListExpirationHeight ?? 0, e.btcActivationHeight = n.btcActivationHeight ?? 0, e.maxFinalityProviders = n.maxFinalityProviders ?? 0, e;
  }
};
function wo(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function Ao(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function ae(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function en(n) {
  return n != null;
}
const lu = "babylon.btcstaking.v1";
function No() {
  return {
    addr: "",
    description: void 0,
    btcPk: new Uint8Array(0),
    pop: void 0,
    bsnId: "",
    commission: void 0
  };
}
const ht = {
  encode(n, e = new g()) {
    return n.addr !== "" && e.uint32(10).string(n.addr), n.description !== void 0 && J.encode(n.description, e.uint32(18).fork()).join(), n.btcPk.length !== 0 && e.uint32(34).bytes(n.btcPk), n.pop !== void 0 && V.encode(n.pop, e.uint32(42).fork()).join(), n.bsnId !== "" && e.uint32(50).string(n.bsnId), n.commission !== void 0 && ee.encode(n.commission, e.uint32(58).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = No();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.addr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.description = J.decode(t, t.uint32());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.pop = V.decode(t, t.uint32());
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.bsnId = t.string();
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.commission = ee.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      addr: A(n.addr) ? globalThis.String(n.addr) : "",
      description: A(n.description) ? J.fromJSON(n.description) : void 0,
      btcPk: A(n.btcPk) ? _(n.btcPk) : new Uint8Array(0),
      pop: A(n.pop) ? V.fromJSON(n.pop) : void 0,
      bsnId: A(n.bsnId) ? globalThis.String(n.bsnId) : "",
      commission: A(n.commission) ? ee.fromJSON(n.commission) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.addr !== "" && (e.addr = n.addr), n.description !== void 0 && (e.description = J.toJSON(n.description)), n.btcPk.length !== 0 && (e.btcPk = M(n.btcPk)), n.pop !== void 0 && (e.pop = V.toJSON(n.pop)), n.bsnId !== "" && (e.bsnId = n.bsnId), n.commission !== void 0 && (e.commission = ee.toJSON(n.commission)), e;
  },
  create(n) {
    return ht.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = No();
    return e.addr = n.addr ?? "", e.description = n.description !== void 0 && n.description !== null ? J.fromPartial(n.description) : void 0, e.btcPk = n.btcPk ?? new Uint8Array(0), e.pop = n.pop !== void 0 && n.pop !== null ? V.fromPartial(n.pop) : void 0, e.bsnId = n.bsnId ?? "", e.commission = n.commission !== void 0 && n.commission !== null ? ee.fromPartial(n.commission) : void 0, e;
  }
};
function Po() {
  return {};
}
const gt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Po();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return gt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Po();
  }
};
function Bo() {
  return { rate: "", maxRate: "", maxChangeRate: "" };
}
const ee = {
  encode(n, e = new g()) {
    return n.rate !== "" && e.uint32(10).string(n.rate), n.maxRate !== "" && e.uint32(18).string(n.maxRate), n.maxChangeRate !== "" && e.uint32(26).string(n.maxChangeRate), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Bo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.rate = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.maxRate = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.maxChangeRate = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      rate: A(n.rate) ? globalThis.String(n.rate) : "",
      maxRate: A(n.maxRate) ? globalThis.String(n.maxRate) : "",
      maxChangeRate: A(n.maxChangeRate) ? globalThis.String(n.maxChangeRate) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.rate !== "" && (e.rate = n.rate), n.maxRate !== "" && (e.maxRate = n.maxRate), n.maxChangeRate !== "" && (e.maxChangeRate = n.maxChangeRate), e;
  },
  create(n) {
    return ee.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Bo();
    return e.rate = n.rate ?? "", e.maxRate = n.maxRate ?? "", e.maxChangeRate = n.maxChangeRate ?? "", e;
  }
};
function Oo() {
  return { addr: "", btcPk: new Uint8Array(0), description: void 0, commission: "" };
}
const pt = {
  encode(n, e = new g()) {
    return n.addr !== "" && e.uint32(10).string(n.addr), n.btcPk.length !== 0 && e.uint32(18).bytes(n.btcPk), n.description !== void 0 && J.encode(n.description, e.uint32(26).fork()).join(), n.commission !== "" && e.uint32(34).string(n.commission), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Oo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.addr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.description = J.decode(t, t.uint32());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.commission = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      addr: A(n.addr) ? globalThis.String(n.addr) : "",
      btcPk: A(n.btcPk) ? _(n.btcPk) : new Uint8Array(0),
      description: A(n.description) ? J.fromJSON(n.description) : void 0,
      commission: A(n.commission) ? globalThis.String(n.commission) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.addr !== "" && (e.addr = n.addr), n.btcPk.length !== 0 && (e.btcPk = M(n.btcPk)), n.description !== void 0 && (e.description = J.toJSON(n.description)), n.commission !== "" && (e.commission = n.commission), e;
  },
  create(n) {
    return pt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Oo();
    return e.addr = n.addr ?? "", e.btcPk = n.btcPk ?? new Uint8Array(0), e.description = n.description !== void 0 && n.description !== null ? J.fromPartial(n.description) : void 0, e.commission = n.commission ?? "", e;
  }
};
function xo() {
  return {};
}
const mt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = xo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return mt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return xo();
  }
};
function Ro() {
  return {
    stakerAddr: "",
    pop: void 0,
    btcPk: new Uint8Array(0),
    fpBtcPkList: [],
    stakingTime: 0,
    stakingValue: 0,
    stakingTx: new Uint8Array(0),
    stakingTxInclusionProof: void 0,
    slashingTx: new Uint8Array(0),
    delegatorSlashingSig: new Uint8Array(0),
    unbondingTime: 0,
    unbondingTx: new Uint8Array(0),
    unbondingValue: 0,
    unbondingSlashingTx: new Uint8Array(0),
    delegatorUnbondingSlashingSig: new Uint8Array(0)
  };
}
const _e = {
  encode(n, e = new g()) {
    n.stakerAddr !== "" && e.uint32(10).string(n.stakerAddr), n.pop !== void 0 && V.encode(n.pop, e.uint32(18).fork()).join(), n.btcPk.length !== 0 && e.uint32(26).bytes(n.btcPk);
    for (const t of n.fpBtcPkList)
      e.uint32(34).bytes(t);
    return n.stakingTime !== 0 && e.uint32(40).uint32(n.stakingTime), n.stakingValue !== 0 && e.uint32(48).int64(n.stakingValue), n.stakingTx.length !== 0 && e.uint32(58).bytes(n.stakingTx), n.stakingTxInclusionProof !== void 0 && X.encode(n.stakingTxInclusionProof, e.uint32(66).fork()).join(), n.slashingTx.length !== 0 && e.uint32(74).bytes(n.slashingTx), n.delegatorSlashingSig.length !== 0 && e.uint32(82).bytes(n.delegatorSlashingSig), n.unbondingTime !== 0 && e.uint32(88).uint32(n.unbondingTime), n.unbondingTx.length !== 0 && e.uint32(98).bytes(n.unbondingTx), n.unbondingValue !== 0 && e.uint32(104).int64(n.unbondingValue), n.unbondingSlashingTx.length !== 0 && e.uint32(114).bytes(n.unbondingSlashingTx), n.delegatorUnbondingSlashingSig.length !== 0 && e.uint32(122).bytes(n.delegatorUnbondingSlashingSig), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ro();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.stakerAddr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pop = V.decode(t, t.uint32());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.fpBtcPkList.push(t.bytes());
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.stakingTime = t.uint32();
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.stakingValue = Re(t.int64());
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.stakingTx = t.bytes();
          continue;
        }
        case 8: {
          if (i !== 66)
            break;
          r.stakingTxInclusionProof = X.decode(t, t.uint32());
          continue;
        }
        case 9: {
          if (i !== 74)
            break;
          r.slashingTx = t.bytes();
          continue;
        }
        case 10: {
          if (i !== 82)
            break;
          r.delegatorSlashingSig = t.bytes();
          continue;
        }
        case 11: {
          if (i !== 88)
            break;
          r.unbondingTime = t.uint32();
          continue;
        }
        case 12: {
          if (i !== 98)
            break;
          r.unbondingTx = t.bytes();
          continue;
        }
        case 13: {
          if (i !== 104)
            break;
          r.unbondingValue = Re(t.int64());
          continue;
        }
        case 14: {
          if (i !== 114)
            break;
          r.unbondingSlashingTx = t.bytes();
          continue;
        }
        case 15: {
          if (i !== 122)
            break;
          r.delegatorUnbondingSlashingSig = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      stakerAddr: A(n.stakerAddr) ? globalThis.String(n.stakerAddr) : "",
      pop: A(n.pop) ? V.fromJSON(n.pop) : void 0,
      btcPk: A(n.btcPk) ? _(n.btcPk) : new Uint8Array(0),
      fpBtcPkList: globalThis.Array.isArray(n == null ? void 0 : n.fpBtcPkList) ? n.fpBtcPkList.map((e) => _(e)) : [],
      stakingTime: A(n.stakingTime) ? globalThis.Number(n.stakingTime) : 0,
      stakingValue: A(n.stakingValue) ? globalThis.Number(n.stakingValue) : 0,
      stakingTx: A(n.stakingTx) ? _(n.stakingTx) : new Uint8Array(0),
      stakingTxInclusionProof: A(n.stakingTxInclusionProof) ? X.fromJSON(n.stakingTxInclusionProof) : void 0,
      slashingTx: A(n.slashingTx) ? _(n.slashingTx) : new Uint8Array(0),
      delegatorSlashingSig: A(n.delegatorSlashingSig) ? _(n.delegatorSlashingSig) : new Uint8Array(0),
      unbondingTime: A(n.unbondingTime) ? globalThis.Number(n.unbondingTime) : 0,
      unbondingTx: A(n.unbondingTx) ? _(n.unbondingTx) : new Uint8Array(0),
      unbondingValue: A(n.unbondingValue) ? globalThis.Number(n.unbondingValue) : 0,
      unbondingSlashingTx: A(n.unbondingSlashingTx) ? _(n.unbondingSlashingTx) : new Uint8Array(0),
      delegatorUnbondingSlashingSig: A(n.delegatorUnbondingSlashingSig) ? _(n.delegatorUnbondingSlashingSig) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.stakerAddr !== "" && (e.stakerAddr = n.stakerAddr), n.pop !== void 0 && (e.pop = V.toJSON(n.pop)), n.btcPk.length !== 0 && (e.btcPk = M(n.btcPk)), (t = n.fpBtcPkList) != null && t.length && (e.fpBtcPkList = n.fpBtcPkList.map((o) => M(o))), n.stakingTime !== 0 && (e.stakingTime = Math.round(n.stakingTime)), n.stakingValue !== 0 && (e.stakingValue = Math.round(n.stakingValue)), n.stakingTx.length !== 0 && (e.stakingTx = M(n.stakingTx)), n.stakingTxInclusionProof !== void 0 && (e.stakingTxInclusionProof = X.toJSON(n.stakingTxInclusionProof)), n.slashingTx.length !== 0 && (e.slashingTx = M(n.slashingTx)), n.delegatorSlashingSig.length !== 0 && (e.delegatorSlashingSig = M(n.delegatorSlashingSig)), n.unbondingTime !== 0 && (e.unbondingTime = Math.round(n.unbondingTime)), n.unbondingTx.length !== 0 && (e.unbondingTx = M(n.unbondingTx)), n.unbondingValue !== 0 && (e.unbondingValue = Math.round(n.unbondingValue)), n.unbondingSlashingTx.length !== 0 && (e.unbondingSlashingTx = M(n.unbondingSlashingTx)), n.delegatorUnbondingSlashingSig.length !== 0 && (e.delegatorUnbondingSlashingSig = M(n.delegatorUnbondingSlashingSig)), e;
  },
  create(n) {
    return _e.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Ro();
    return e.stakerAddr = n.stakerAddr ?? "", e.pop = n.pop !== void 0 && n.pop !== null ? V.fromPartial(n.pop) : void 0, e.btcPk = n.btcPk ?? new Uint8Array(0), e.fpBtcPkList = ((t = n.fpBtcPkList) == null ? void 0 : t.map((o) => o)) || [], e.stakingTime = n.stakingTime ?? 0, e.stakingValue = n.stakingValue ?? 0, e.stakingTx = n.stakingTx ?? new Uint8Array(0), e.stakingTxInclusionProof = n.stakingTxInclusionProof !== void 0 && n.stakingTxInclusionProof !== null ? X.fromPartial(n.stakingTxInclusionProof) : void 0, e.slashingTx = n.slashingTx ?? new Uint8Array(0), e.delegatorSlashingSig = n.delegatorSlashingSig ?? new Uint8Array(0), e.unbondingTime = n.unbondingTime ?? 0, e.unbondingTx = n.unbondingTx ?? new Uint8Array(0), e.unbondingValue = n.unbondingValue ?? 0, e.unbondingSlashingTx = n.unbondingSlashingTx ?? new Uint8Array(0), e.delegatorUnbondingSlashingSig = n.delegatorUnbondingSlashingSig ?? new Uint8Array(0), e;
  }
};
function Eo() {
  return {};
}
const kt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Eo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return kt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Eo();
  }
};
function Jo() {
  return {
    stakerAddr: "",
    pop: void 0,
    btcPk: new Uint8Array(0),
    fpBtcPkList: [],
    stakingTime: 0,
    stakingValue: 0,
    stakingTx: new Uint8Array(0),
    slashingTx: new Uint8Array(0),
    delegatorSlashingSig: new Uint8Array(0),
    unbondingTime: 0,
    unbondingTx: new Uint8Array(0),
    unbondingValue: 0,
    unbondingSlashingTx: new Uint8Array(0),
    delegatorUnbondingSlashingSig: new Uint8Array(0),
    previousStakingTxHash: "",
    fundingTx: new Uint8Array(0)
  };
}
const we = {
  encode(n, e = new g()) {
    n.stakerAddr !== "" && e.uint32(10).string(n.stakerAddr), n.pop !== void 0 && V.encode(n.pop, e.uint32(18).fork()).join(), n.btcPk.length !== 0 && e.uint32(26).bytes(n.btcPk);
    for (const t of n.fpBtcPkList)
      e.uint32(34).bytes(t);
    return n.stakingTime !== 0 && e.uint32(40).uint32(n.stakingTime), n.stakingValue !== 0 && e.uint32(48).int64(n.stakingValue), n.stakingTx.length !== 0 && e.uint32(58).bytes(n.stakingTx), n.slashingTx.length !== 0 && e.uint32(66).bytes(n.slashingTx), n.delegatorSlashingSig.length !== 0 && e.uint32(74).bytes(n.delegatorSlashingSig), n.unbondingTime !== 0 && e.uint32(80).uint32(n.unbondingTime), n.unbondingTx.length !== 0 && e.uint32(90).bytes(n.unbondingTx), n.unbondingValue !== 0 && e.uint32(96).int64(n.unbondingValue), n.unbondingSlashingTx.length !== 0 && e.uint32(106).bytes(n.unbondingSlashingTx), n.delegatorUnbondingSlashingSig.length !== 0 && e.uint32(114).bytes(n.delegatorUnbondingSlashingSig), n.previousStakingTxHash !== "" && e.uint32(122).string(n.previousStakingTxHash), n.fundingTx.length !== 0 && e.uint32(130).bytes(n.fundingTx), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Jo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.stakerAddr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pop = V.decode(t, t.uint32());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.fpBtcPkList.push(t.bytes());
          continue;
        }
        case 5: {
          if (i !== 40)
            break;
          r.stakingTime = t.uint32();
          continue;
        }
        case 6: {
          if (i !== 48)
            break;
          r.stakingValue = Re(t.int64());
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.stakingTx = t.bytes();
          continue;
        }
        case 8: {
          if (i !== 66)
            break;
          r.slashingTx = t.bytes();
          continue;
        }
        case 9: {
          if (i !== 74)
            break;
          r.delegatorSlashingSig = t.bytes();
          continue;
        }
        case 10: {
          if (i !== 80)
            break;
          r.unbondingTime = t.uint32();
          continue;
        }
        case 11: {
          if (i !== 90)
            break;
          r.unbondingTx = t.bytes();
          continue;
        }
        case 12: {
          if (i !== 96)
            break;
          r.unbondingValue = Re(t.int64());
          continue;
        }
        case 13: {
          if (i !== 106)
            break;
          r.unbondingSlashingTx = t.bytes();
          continue;
        }
        case 14: {
          if (i !== 114)
            break;
          r.delegatorUnbondingSlashingSig = t.bytes();
          continue;
        }
        case 15: {
          if (i !== 122)
            break;
          r.previousStakingTxHash = t.string();
          continue;
        }
        case 16: {
          if (i !== 130)
            break;
          r.fundingTx = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      stakerAddr: A(n.stakerAddr) ? globalThis.String(n.stakerAddr) : "",
      pop: A(n.pop) ? V.fromJSON(n.pop) : void 0,
      btcPk: A(n.btcPk) ? _(n.btcPk) : new Uint8Array(0),
      fpBtcPkList: globalThis.Array.isArray(n == null ? void 0 : n.fpBtcPkList) ? n.fpBtcPkList.map((e) => _(e)) : [],
      stakingTime: A(n.stakingTime) ? globalThis.Number(n.stakingTime) : 0,
      stakingValue: A(n.stakingValue) ? globalThis.Number(n.stakingValue) : 0,
      stakingTx: A(n.stakingTx) ? _(n.stakingTx) : new Uint8Array(0),
      slashingTx: A(n.slashingTx) ? _(n.slashingTx) : new Uint8Array(0),
      delegatorSlashingSig: A(n.delegatorSlashingSig) ? _(n.delegatorSlashingSig) : new Uint8Array(0),
      unbondingTime: A(n.unbondingTime) ? globalThis.Number(n.unbondingTime) : 0,
      unbondingTx: A(n.unbondingTx) ? _(n.unbondingTx) : new Uint8Array(0),
      unbondingValue: A(n.unbondingValue) ? globalThis.Number(n.unbondingValue) : 0,
      unbondingSlashingTx: A(n.unbondingSlashingTx) ? _(n.unbondingSlashingTx) : new Uint8Array(0),
      delegatorUnbondingSlashingSig: A(n.delegatorUnbondingSlashingSig) ? _(n.delegatorUnbondingSlashingSig) : new Uint8Array(0),
      previousStakingTxHash: A(n.previousStakingTxHash) ? globalThis.String(n.previousStakingTxHash) : "",
      fundingTx: A(n.fundingTx) ? _(n.fundingTx) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.stakerAddr !== "" && (e.stakerAddr = n.stakerAddr), n.pop !== void 0 && (e.pop = V.toJSON(n.pop)), n.btcPk.length !== 0 && (e.btcPk = M(n.btcPk)), (t = n.fpBtcPkList) != null && t.length && (e.fpBtcPkList = n.fpBtcPkList.map((o) => M(o))), n.stakingTime !== 0 && (e.stakingTime = Math.round(n.stakingTime)), n.stakingValue !== 0 && (e.stakingValue = Math.round(n.stakingValue)), n.stakingTx.length !== 0 && (e.stakingTx = M(n.stakingTx)), n.slashingTx.length !== 0 && (e.slashingTx = M(n.slashingTx)), n.delegatorSlashingSig.length !== 0 && (e.delegatorSlashingSig = M(n.delegatorSlashingSig)), n.unbondingTime !== 0 && (e.unbondingTime = Math.round(n.unbondingTime)), n.unbondingTx.length !== 0 && (e.unbondingTx = M(n.unbondingTx)), n.unbondingValue !== 0 && (e.unbondingValue = Math.round(n.unbondingValue)), n.unbondingSlashingTx.length !== 0 && (e.unbondingSlashingTx = M(n.unbondingSlashingTx)), n.delegatorUnbondingSlashingSig.length !== 0 && (e.delegatorUnbondingSlashingSig = M(n.delegatorUnbondingSlashingSig)), n.previousStakingTxHash !== "" && (e.previousStakingTxHash = n.previousStakingTxHash), n.fundingTx.length !== 0 && (e.fundingTx = M(n.fundingTx)), e;
  },
  create(n) {
    return we.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Jo();
    return e.stakerAddr = n.stakerAddr ?? "", e.pop = n.pop !== void 0 && n.pop !== null ? V.fromPartial(n.pop) : void 0, e.btcPk = n.btcPk ?? new Uint8Array(0), e.fpBtcPkList = ((t = n.fpBtcPkList) == null ? void 0 : t.map((o) => o)) || [], e.stakingTime = n.stakingTime ?? 0, e.stakingValue = n.stakingValue ?? 0, e.stakingTx = n.stakingTx ?? new Uint8Array(0), e.slashingTx = n.slashingTx ?? new Uint8Array(0), e.delegatorSlashingSig = n.delegatorSlashingSig ?? new Uint8Array(0), e.unbondingTime = n.unbondingTime ?? 0, e.unbondingTx = n.unbondingTx ?? new Uint8Array(0), e.unbondingValue = n.unbondingValue ?? 0, e.unbondingSlashingTx = n.unbondingSlashingTx ?? new Uint8Array(0), e.delegatorUnbondingSlashingSig = n.delegatorUnbondingSlashingSig ?? new Uint8Array(0), e.previousStakingTxHash = n.previousStakingTxHash ?? "", e.fundingTx = n.fundingTx ?? new Uint8Array(0), e;
  }
};
function Io() {
  return {};
}
const St = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Io();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return St.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Io();
  }
};
function Co() {
  return { signer: "", stakingTxHash: "", stakingTxInclusionProof: void 0 };
}
const bt = {
  encode(n, e = new g()) {
    return n.signer !== "" && e.uint32(10).string(n.signer), n.stakingTxHash !== "" && e.uint32(18).string(n.stakingTxHash), n.stakingTxInclusionProof !== void 0 && X.encode(n.stakingTxInclusionProof, e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Co();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.signer = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.stakingTxHash = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.stakingTxInclusionProof = X.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      signer: A(n.signer) ? globalThis.String(n.signer) : "",
      stakingTxHash: A(n.stakingTxHash) ? globalThis.String(n.stakingTxHash) : "",
      stakingTxInclusionProof: A(n.stakingTxInclusionProof) ? X.fromJSON(n.stakingTxInclusionProof) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.signer !== "" && (e.signer = n.signer), n.stakingTxHash !== "" && (e.stakingTxHash = n.stakingTxHash), n.stakingTxInclusionProof !== void 0 && (e.stakingTxInclusionProof = X.toJSON(n.stakingTxInclusionProof)), e;
  },
  create(n) {
    return bt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Co();
    return e.signer = n.signer ?? "", e.stakingTxHash = n.stakingTxHash ?? "", e.stakingTxInclusionProof = n.stakingTxInclusionProof !== void 0 && n.stakingTxInclusionProof !== null ? X.fromPartial(n.stakingTxInclusionProof) : void 0, e;
  }
};
function Uo() {
  return {};
}
const vt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Uo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return vt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Uo();
  }
};
function Ho() {
  return {
    signer: "",
    pk: new Uint8Array(0),
    stakingTxHash: "",
    slashingTxSigs: [],
    unbondingTxSig: new Uint8Array(0),
    slashingUnbondingTxSigs: [],
    stakeExpansionTxSig: new Uint8Array(0)
  };
}
const Tt = {
  encode(n, e = new g()) {
    n.signer !== "" && e.uint32(10).string(n.signer), n.pk.length !== 0 && e.uint32(18).bytes(n.pk), n.stakingTxHash !== "" && e.uint32(26).string(n.stakingTxHash);
    for (const t of n.slashingTxSigs)
      e.uint32(34).bytes(t);
    n.unbondingTxSig.length !== 0 && e.uint32(42).bytes(n.unbondingTxSig);
    for (const t of n.slashingUnbondingTxSigs)
      e.uint32(50).bytes(t);
    return n.stakeExpansionTxSig.length !== 0 && e.uint32(58).bytes(n.stakeExpansionTxSig), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ho();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.signer = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pk = t.bytes();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.stakingTxHash = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.slashingTxSigs.push(t.bytes());
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.unbondingTxSig = t.bytes();
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.slashingUnbondingTxSigs.push(t.bytes());
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.stakeExpansionTxSig = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      signer: A(n.signer) ? globalThis.String(n.signer) : "",
      pk: A(n.pk) ? _(n.pk) : new Uint8Array(0),
      stakingTxHash: A(n.stakingTxHash) ? globalThis.String(n.stakingTxHash) : "",
      slashingTxSigs: globalThis.Array.isArray(n == null ? void 0 : n.slashingTxSigs) ? n.slashingTxSigs.map((e) => _(e)) : [],
      unbondingTxSig: A(n.unbondingTxSig) ? _(n.unbondingTxSig) : new Uint8Array(0),
      slashingUnbondingTxSigs: globalThis.Array.isArray(n == null ? void 0 : n.slashingUnbondingTxSigs) ? n.slashingUnbondingTxSigs.map((e) => _(e)) : [],
      stakeExpansionTxSig: A(n.stakeExpansionTxSig) ? _(n.stakeExpansionTxSig) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    var t, o;
    const e = {};
    return n.signer !== "" && (e.signer = n.signer), n.pk.length !== 0 && (e.pk = M(n.pk)), n.stakingTxHash !== "" && (e.stakingTxHash = n.stakingTxHash), (t = n.slashingTxSigs) != null && t.length && (e.slashingTxSigs = n.slashingTxSigs.map((r) => M(r))), n.unbondingTxSig.length !== 0 && (e.unbondingTxSig = M(n.unbondingTxSig)), (o = n.slashingUnbondingTxSigs) != null && o.length && (e.slashingUnbondingTxSigs = n.slashingUnbondingTxSigs.map((r) => M(r))), n.stakeExpansionTxSig.length !== 0 && (e.stakeExpansionTxSig = M(n.stakeExpansionTxSig)), e;
  },
  create(n) {
    return Tt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t, o;
    const e = Ho();
    return e.signer = n.signer ?? "", e.pk = n.pk ?? new Uint8Array(0), e.stakingTxHash = n.stakingTxHash ?? "", e.slashingTxSigs = ((t = n.slashingTxSigs) == null ? void 0 : t.map((r) => r)) || [], e.unbondingTxSig = n.unbondingTxSig ?? new Uint8Array(0), e.slashingUnbondingTxSigs = ((o = n.slashingUnbondingTxSigs) == null ? void 0 : o.map((r) => r)) || [], e.stakeExpansionTxSig = n.stakeExpansionTxSig ?? new Uint8Array(0), e;
  }
};
function _o() {
  return {};
}
const yt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = _o();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return yt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return _o();
  }
};
function Mo() {
  return {
    signer: "",
    stakingTxHash: "",
    stakeSpendingTx: new Uint8Array(0),
    stakeSpendingTxInclusionProof: void 0,
    fundingTransactions: []
  };
}
const wt = {
  encode(n, e = new g()) {
    n.signer !== "" && e.uint32(10).string(n.signer), n.stakingTxHash !== "" && e.uint32(18).string(n.stakingTxHash), n.stakeSpendingTx.length !== 0 && e.uint32(26).bytes(n.stakeSpendingTx), n.stakeSpendingTxInclusionProof !== void 0 && X.encode(n.stakeSpendingTxInclusionProof, e.uint32(34).fork()).join();
    for (const t of n.fundingTransactions)
      e.uint32(42).bytes(t);
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Mo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.signer = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.stakingTxHash = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.stakeSpendingTx = t.bytes();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.stakeSpendingTxInclusionProof = X.decode(t, t.uint32());
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.fundingTransactions.push(t.bytes());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      signer: A(n.signer) ? globalThis.String(n.signer) : "",
      stakingTxHash: A(n.stakingTxHash) ? globalThis.String(n.stakingTxHash) : "",
      stakeSpendingTx: A(n.stakeSpendingTx) ? _(n.stakeSpendingTx) : new Uint8Array(0),
      stakeSpendingTxInclusionProof: A(n.stakeSpendingTxInclusionProof) ? X.fromJSON(n.stakeSpendingTxInclusionProof) : void 0,
      fundingTransactions: globalThis.Array.isArray(n == null ? void 0 : n.fundingTransactions) ? n.fundingTransactions.map((e) => _(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.signer !== "" && (e.signer = n.signer), n.stakingTxHash !== "" && (e.stakingTxHash = n.stakingTxHash), n.stakeSpendingTx.length !== 0 && (e.stakeSpendingTx = M(n.stakeSpendingTx)), n.stakeSpendingTxInclusionProof !== void 0 && (e.stakeSpendingTxInclusionProof = X.toJSON(n.stakeSpendingTxInclusionProof)), (t = n.fundingTransactions) != null && t.length && (e.fundingTransactions = n.fundingTransactions.map((o) => M(o))), e;
  },
  create(n) {
    return wt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Mo();
    return e.signer = n.signer ?? "", e.stakingTxHash = n.stakingTxHash ?? "", e.stakeSpendingTx = n.stakeSpendingTx ?? new Uint8Array(0), e.stakeSpendingTxInclusionProof = n.stakeSpendingTxInclusionProof !== void 0 && n.stakeSpendingTxInclusionProof !== null ? X.fromPartial(n.stakeSpendingTxInclusionProof) : void 0, e.fundingTransactions = ((t = n.fundingTransactions) == null ? void 0 : t.map((o) => o)) || [], e;
  }
};
function Do() {
  return {};
}
const At = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Do();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return At.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Do();
  }
};
function Vo() {
  return { signer: "", stakingTxHash: "", recoveredFpBtcSk: new Uint8Array(0) };
}
const Nt = {
  encode(n, e = new g()) {
    return n.signer !== "" && e.uint32(10).string(n.signer), n.stakingTxHash !== "" && e.uint32(18).string(n.stakingTxHash), n.recoveredFpBtcSk.length !== 0 && e.uint32(26).bytes(n.recoveredFpBtcSk), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Vo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.signer = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.stakingTxHash = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.recoveredFpBtcSk = t.bytes();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      signer: A(n.signer) ? globalThis.String(n.signer) : "",
      stakingTxHash: A(n.stakingTxHash) ? globalThis.String(n.stakingTxHash) : "",
      recoveredFpBtcSk: A(n.recoveredFpBtcSk) ? _(n.recoveredFpBtcSk) : new Uint8Array(0)
    };
  },
  toJSON(n) {
    const e = {};
    return n.signer !== "" && (e.signer = n.signer), n.stakingTxHash !== "" && (e.stakingTxHash = n.stakingTxHash), n.recoveredFpBtcSk.length !== 0 && (e.recoveredFpBtcSk = M(n.recoveredFpBtcSk)), e;
  },
  create(n) {
    return Nt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Vo();
    return e.signer = n.signer ?? "", e.stakingTxHash = n.stakingTxHash ?? "", e.recoveredFpBtcSk = n.recoveredFpBtcSk ?? new Uint8Array(0), e;
  }
};
function Fo() {
  return {};
}
const Pt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Fo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Pt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Fo();
  }
};
function Lo() {
  return { authority: "", params: void 0 };
}
const Bt = {
  encode(n, e = new g()) {
    return n.authority !== "" && e.uint32(10).string(n.authority), n.params !== void 0 && pe.encode(n.params, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Lo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.authority = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.params = pe.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      authority: A(n.authority) ? globalThis.String(n.authority) : "",
      params: A(n.params) ? pe.fromJSON(n.params) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.authority !== "" && (e.authority = n.authority), n.params !== void 0 && (e.params = pe.toJSON(n.params)), e;
  },
  create(n) {
    return Bt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Lo();
    return e.authority = n.authority ?? "", e.params = n.params !== void 0 && n.params !== null ? pe.fromPartial(n.params) : void 0, e;
  }
};
function Go() {
  return {};
}
const Ot = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Go();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Ot.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Go();
  }
};
function Wo() {
  return { sender: "", bsnConsumerId: "", totalRewards: [], fpRatios: [] };
}
const xt = {
  encode(n, e = new g()) {
    n.sender !== "" && e.uint32(10).string(n.sender), n.bsnConsumerId !== "" && e.uint32(18).string(n.bsnConsumerId);
    for (const t of n.totalRewards)
      y.encode(t, e.uint32(26).fork()).join();
    for (const t of n.fpRatios)
      te.encode(t, e.uint32(34).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Wo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.sender = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.bsnConsumerId = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.totalRewards.push(y.decode(t, t.uint32()));
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.fpRatios.push(te.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      sender: A(n.sender) ? globalThis.String(n.sender) : "",
      bsnConsumerId: A(n.bsnConsumerId) ? globalThis.String(n.bsnConsumerId) : "",
      totalRewards: globalThis.Array.isArray(n == null ? void 0 : n.totalRewards) ? n.totalRewards.map((e) => y.fromJSON(e)) : [],
      fpRatios: globalThis.Array.isArray(n == null ? void 0 : n.fpRatios) ? n.fpRatios.map((e) => te.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t, o;
    const e = {};
    return n.sender !== "" && (e.sender = n.sender), n.bsnConsumerId !== "" && (e.bsnConsumerId = n.bsnConsumerId), (t = n.totalRewards) != null && t.length && (e.totalRewards = n.totalRewards.map((r) => y.toJSON(r))), (o = n.fpRatios) != null && o.length && (e.fpRatios = n.fpRatios.map((r) => te.toJSON(r))), e;
  },
  create(n) {
    return xt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t, o;
    const e = Wo();
    return e.sender = n.sender ?? "", e.bsnConsumerId = n.bsnConsumerId ?? "", e.totalRewards = ((t = n.totalRewards) == null ? void 0 : t.map((r) => y.fromPartial(r))) || [], e.fpRatios = ((o = n.fpRatios) == null ? void 0 : o.map((r) => te.fromPartial(r))) || [], e;
  }
};
function $o() {
  return { btcPk: new Uint8Array(0), ratio: "" };
}
const te = {
  encode(n, e = new g()) {
    return n.btcPk.length !== 0 && e.uint32(10).bytes(n.btcPk), n.ratio !== "" && e.uint32(18).string(n.ratio), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = $o();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.btcPk = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.ratio = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      btcPk: A(n.btcPk) ? _(n.btcPk) : new Uint8Array(0),
      ratio: A(n.ratio) ? globalThis.String(n.ratio) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.btcPk.length !== 0 && (e.btcPk = M(n.btcPk)), n.ratio !== "" && (e.ratio = n.ratio), e;
  },
  create(n) {
    return te.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = $o();
    return e.btcPk = n.btcPk ?? new Uint8Array(0), e.ratio = n.ratio ?? "", e;
  }
};
function Qo() {
  return {};
}
const Rt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Qo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Rt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Qo();
  }
}, cd = "babylon.btcstaking.v1.Msg";
let fu = class {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || cd, this.rpc = e, this.CreateFinalityProvider = this.CreateFinalityProvider.bind(this), this.EditFinalityProvider = this.EditFinalityProvider.bind(this), this.CreateBTCDelegation = this.CreateBTCDelegation.bind(this), this.AddBTCDelegationInclusionProof = this.AddBTCDelegationInclusionProof.bind(this), this.AddCovenantSigs = this.AddCovenantSigs.bind(this), this.BTCUndelegate = this.BTCUndelegate.bind(this), this.SelectiveSlashingEvidence = this.SelectiveSlashingEvidence.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.BtcStakeExpand = this.BtcStakeExpand.bind(this), this.AddBsnRewards = this.AddBsnRewards.bind(this);
  }
  CreateFinalityProvider(e) {
    const t = ht.encode(e).finish();
    return this.rpc.request(this.service, "CreateFinalityProvider", t).then((r) => gt.decode(new a(r)));
  }
  EditFinalityProvider(e) {
    const t = pt.encode(e).finish();
    return this.rpc.request(this.service, "EditFinalityProvider", t).then((r) => mt.decode(new a(r)));
  }
  CreateBTCDelegation(e) {
    const t = _e.encode(e).finish();
    return this.rpc.request(this.service, "CreateBTCDelegation", t).then((r) => kt.decode(new a(r)));
  }
  AddBTCDelegationInclusionProof(e) {
    const t = bt.encode(e).finish();
    return this.rpc.request(this.service, "AddBTCDelegationInclusionProof", t).then((r) => vt.decode(new a(r)));
  }
  AddCovenantSigs(e) {
    const t = Tt.encode(e).finish();
    return this.rpc.request(this.service, "AddCovenantSigs", t).then((r) => yt.decode(new a(r)));
  }
  BTCUndelegate(e) {
    const t = wt.encode(e).finish();
    return this.rpc.request(this.service, "BTCUndelegate", t).then((r) => At.decode(new a(r)));
  }
  SelectiveSlashingEvidence(e) {
    const t = Nt.encode(e).finish();
    return this.rpc.request(this.service, "SelectiveSlashingEvidence", t).then((r) => Pt.decode(new a(r)));
  }
  UpdateParams(e) {
    const t = Bt.encode(e).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((r) => Ot.decode(new a(r)));
  }
  BtcStakeExpand(e) {
    const t = we.encode(e).finish();
    return this.rpc.request(this.service, "BtcStakeExpand", t).then((r) => St.decode(new a(r)));
  }
  AddBsnRewards(e) {
    const t = xt.encode(e).finish();
    return this.rpc.request(this.service, "AddBsnRewards", t).then((r) => Rt.decode(new a(r)));
  }
};
function _(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function M(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function Re(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function A(n) {
  return n != null;
}
const Bc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CommissionRates: ee,
  FpRatio: te,
  MsgAddBTCDelegationInclusionProof: bt,
  MsgAddBTCDelegationInclusionProofResponse: vt,
  MsgAddBsnRewards: xt,
  MsgAddBsnRewardsResponse: Rt,
  MsgAddCovenantSigs: Tt,
  MsgAddCovenantSigsResponse: yt,
  MsgBTCUndelegate: wt,
  MsgBTCUndelegateResponse: At,
  MsgBtcStakeExpand: we,
  MsgBtcStakeExpandResponse: St,
  MsgClientImpl: fu,
  MsgCreateBTCDelegation: _e,
  MsgCreateBTCDelegationResponse: kt,
  MsgCreateFinalityProvider: ht,
  MsgCreateFinalityProviderResponse: gt,
  MsgEditFinalityProvider: pt,
  MsgEditFinalityProviderResponse: mt,
  MsgSelectiveSlashingEvidence: Nt,
  MsgSelectiveSlashingEvidenceResponse: Pt,
  MsgServiceName: cd,
  MsgUpdateParams: Bt,
  MsgUpdateParamsResponse: Ot,
  protobufPackage: lu
}, Symbol.toStringTag, { value: "Module" })), hu = "cosmos.staking.v1beta1";
function qo() {
  return {
    description: void 0,
    commission: void 0,
    minSelfDelegation: "",
    delegatorAddress: "",
    validatorAddress: "",
    pubkey: void 0,
    value: void 0
  };
}
const Et = {
  encode(n, e = new g()) {
    return n.description !== void 0 && J.encode(n.description, e.uint32(10).fork()).join(), n.commission !== void 0 && cn.encode(n.commission, e.uint32(18).fork()).join(), n.minSelfDelegation !== "" && e.uint32(26).string(n.minSelfDelegation), n.delegatorAddress !== "" && e.uint32(34).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(42).string(n.validatorAddress), n.pubkey !== void 0 && un.encode(n.pubkey, e.uint32(50).fork()).join(), n.value !== void 0 && y.encode(n.value, e.uint32(58).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = qo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.description = J.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.commission = cn.decode(t, t.uint32());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.minSelfDelegation = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.pubkey = un.decode(t, t.uint32());
          continue;
        }
        case 7: {
          if (i !== 58)
            break;
          r.value = y.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      description: H(n.description) ? J.fromJSON(n.description) : void 0,
      commission: H(n.commission) ? cn.fromJSON(n.commission) : void 0,
      minSelfDelegation: H(n.minSelfDelegation) ? globalThis.String(n.minSelfDelegation) : "",
      delegatorAddress: H(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: H(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      pubkey: H(n.pubkey) ? un.fromJSON(n.pubkey) : void 0,
      value: H(n.value) ? y.fromJSON(n.value) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.description !== void 0 && (e.description = J.toJSON(n.description)), n.commission !== void 0 && (e.commission = cn.toJSON(n.commission)), n.minSelfDelegation !== "" && (e.minSelfDelegation = n.minSelfDelegation), n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), n.pubkey !== void 0 && (e.pubkey = un.toJSON(n.pubkey)), n.value !== void 0 && (e.value = y.toJSON(n.value)), e;
  },
  create(n) {
    return Et.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = qo();
    return e.description = n.description !== void 0 && n.description !== null ? J.fromPartial(n.description) : void 0, e.commission = n.commission !== void 0 && n.commission !== null ? cn.fromPartial(n.commission) : void 0, e.minSelfDelegation = n.minSelfDelegation ?? "", e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e.pubkey = n.pubkey !== void 0 && n.pubkey !== null ? un.fromPartial(n.pubkey) : void 0, e.value = n.value !== void 0 && n.value !== null ? y.fromPartial(n.value) : void 0, e;
  }
};
function Xo() {
  return {};
}
const Jt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Xo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Jt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Xo();
  }
};
function Ko() {
  return { description: void 0, validatorAddress: "", commissionRate: "", minSelfDelegation: "" };
}
const Rn = {
  encode(n, e = new g()) {
    return n.description !== void 0 && J.encode(n.description, e.uint32(10).fork()).join(), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress), n.commissionRate !== "" && e.uint32(26).string(n.commissionRate), n.minSelfDelegation !== "" && e.uint32(34).string(n.minSelfDelegation), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ko();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.description = J.decode(t, t.uint32());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.commissionRate = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.minSelfDelegation = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      description: H(n.description) ? J.fromJSON(n.description) : void 0,
      validatorAddress: H(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      commissionRate: H(n.commissionRate) ? globalThis.String(n.commissionRate) : "",
      minSelfDelegation: H(n.minSelfDelegation) ? globalThis.String(n.minSelfDelegation) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.description !== void 0 && (e.description = J.toJSON(n.description)), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), n.commissionRate !== "" && (e.commissionRate = n.commissionRate), n.minSelfDelegation !== "" && (e.minSelfDelegation = n.minSelfDelegation), e;
  },
  create(n) {
    return Rn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ko();
    return e.description = n.description !== void 0 && n.description !== null ? J.fromPartial(n.description) : void 0, e.validatorAddress = n.validatorAddress ?? "", e.commissionRate = n.commissionRate ?? "", e.minSelfDelegation = n.minSelfDelegation ?? "", e;
  }
};
function Zo() {
  return {};
}
const It = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Zo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return It.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Zo();
  }
};
function zo() {
  return { delegatorAddress: "", validatorAddress: "", amount: void 0 };
}
const En = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress), n.amount !== void 0 && y.encode(n.amount, e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = zo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.amount = y.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: H(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: H(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      amount: H(n.amount) ? y.fromJSON(n.amount) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), n.amount !== void 0 && (e.amount = y.toJSON(n.amount)), e;
  },
  create(n) {
    return En.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = zo();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e.amount = n.amount !== void 0 && n.amount !== null ? y.fromPartial(n.amount) : void 0, e;
  }
};
function Yo() {
  return {};
}
const Ct = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Yo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Ct.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Yo();
  }
};
function jo() {
  return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "", amount: void 0 };
}
const Jn = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorSrcAddress !== "" && e.uint32(18).string(n.validatorSrcAddress), n.validatorDstAddress !== "" && e.uint32(26).string(n.validatorDstAddress), n.amount !== void 0 && y.encode(n.amount, e.uint32(34).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = jo();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorSrcAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.validatorDstAddress = t.string();
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.amount = y.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: H(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorSrcAddress: H(n.validatorSrcAddress) ? globalThis.String(n.validatorSrcAddress) : "",
      validatorDstAddress: H(n.validatorDstAddress) ? globalThis.String(n.validatorDstAddress) : "",
      amount: H(n.amount) ? y.fromJSON(n.amount) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorSrcAddress !== "" && (e.validatorSrcAddress = n.validatorSrcAddress), n.validatorDstAddress !== "" && (e.validatorDstAddress = n.validatorDstAddress), n.amount !== void 0 && (e.amount = y.toJSON(n.amount)), e;
  },
  create(n) {
    return Jn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = jo();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorSrcAddress = n.validatorSrcAddress ?? "", e.validatorDstAddress = n.validatorDstAddress ?? "", e.amount = n.amount !== void 0 && n.amount !== null ? y.fromPartial(n.amount) : void 0, e;
  }
};
function na() {
  return { completionTime: void 0 };
}
const Ut = {
  encode(n, e = new g()) {
    return n.completionTime !== void 0 && U.encode(fd(n.completionTime), e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = na();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.completionTime = Dt(U.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { completionTime: H(n.completionTime) ? hd(n.completionTime) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.completionTime !== void 0 && (e.completionTime = n.completionTime.toISOString()), e;
  },
  create(n) {
    return Ut.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = na();
    return e.completionTime = n.completionTime ?? void 0, e;
  }
};
function ea() {
  return { delegatorAddress: "", validatorAddress: "", amount: void 0 };
}
const In = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress), n.amount !== void 0 && y.encode(n.amount, e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ea();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.amount = y.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: H(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: H(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      amount: H(n.amount) ? y.fromJSON(n.amount) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), n.amount !== void 0 && (e.amount = y.toJSON(n.amount)), e;
  },
  create(n) {
    return In.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ea();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e.amount = n.amount !== void 0 && n.amount !== null ? y.fromPartial(n.amount) : void 0, e;
  }
};
function ta() {
  return { completionTime: void 0, amount: void 0 };
}
const Ht = {
  encode(n, e = new g()) {
    return n.completionTime !== void 0 && U.encode(fd(n.completionTime), e.uint32(10).fork()).join(), n.amount !== void 0 && y.encode(n.amount, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ta();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.completionTime = Dt(U.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.amount = y.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      completionTime: H(n.completionTime) ? hd(n.completionTime) : void 0,
      amount: H(n.amount) ? y.fromJSON(n.amount) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.completionTime !== void 0 && (e.completionTime = n.completionTime.toISOString()), n.amount !== void 0 && (e.amount = y.toJSON(n.amount)), e;
  },
  create(n) {
    return Ht.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ta();
    return e.completionTime = n.completionTime ?? void 0, e.amount = n.amount !== void 0 && n.amount !== null ? y.fromPartial(n.amount) : void 0, e;
  }
};
function ia() {
  return { delegatorAddress: "", validatorAddress: "", amount: void 0, creationHeight: 0 };
}
const Cn = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.validatorAddress !== "" && e.uint32(18).string(n.validatorAddress), n.amount !== void 0 && y.encode(n.amount, e.uint32(26).fork()).join(), n.creationHeight !== 0 && e.uint32(32).int64(n.creationHeight), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ia();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.validatorAddress = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.amount = y.decode(t, t.uint32());
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.creationHeight = pu(t.int64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: H(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      validatorAddress: H(n.validatorAddress) ? globalThis.String(n.validatorAddress) : "",
      amount: H(n.amount) ? y.fromJSON(n.amount) : void 0,
      creationHeight: H(n.creationHeight) ? globalThis.Number(n.creationHeight) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.validatorAddress !== "" && (e.validatorAddress = n.validatorAddress), n.amount !== void 0 && (e.amount = y.toJSON(n.amount)), n.creationHeight !== 0 && (e.creationHeight = Math.round(n.creationHeight)), e;
  },
  create(n) {
    return Cn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ia();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.validatorAddress = n.validatorAddress ?? "", e.amount = n.amount !== void 0 && n.amount !== null ? y.fromPartial(n.amount) : void 0, e.creationHeight = n.creationHeight ?? 0, e;
  }
};
function ra() {
  return {};
}
const _t = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ra();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return _t.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return ra();
  }
};
function oa() {
  return { authority: "", params: void 0 };
}
const Un = {
  encode(n, e = new g()) {
    return n.authority !== "" && e.uint32(10).string(n.authority), n.params !== void 0 && Xn.encode(n.params, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = oa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.authority = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.params = Xn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      authority: H(n.authority) ? globalThis.String(n.authority) : "",
      params: H(n.params) ? Xn.fromJSON(n.params) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.authority !== "" && (e.authority = n.authority), n.params !== void 0 && (e.params = Xn.toJSON(n.params)), e;
  },
  create(n) {
    return Un.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = oa();
    return e.authority = n.authority ?? "", e.params = n.params !== void 0 && n.params !== null ? Xn.fromPartial(n.params) : void 0, e;
  }
};
function aa() {
  return {};
}
const Mt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = aa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Mt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return aa();
  }
}, ld = "cosmos.staking.v1beta1.Msg";
let gu = class {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || ld, this.rpc = e, this.CreateValidator = this.CreateValidator.bind(this), this.EditValidator = this.EditValidator.bind(this), this.Delegate = this.Delegate.bind(this), this.BeginRedelegate = this.BeginRedelegate.bind(this), this.Undelegate = this.Undelegate.bind(this), this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
  }
  CreateValidator(e) {
    const t = Et.encode(e).finish();
    return this.rpc.request(this.service, "CreateValidator", t).then((r) => Jt.decode(new a(r)));
  }
  EditValidator(e) {
    const t = Rn.encode(e).finish();
    return this.rpc.request(this.service, "EditValidator", t).then((r) => It.decode(new a(r)));
  }
  Delegate(e) {
    const t = En.encode(e).finish();
    return this.rpc.request(this.service, "Delegate", t).then((r) => Ct.decode(new a(r)));
  }
  BeginRedelegate(e) {
    const t = Jn.encode(e).finish();
    return this.rpc.request(this.service, "BeginRedelegate", t).then((r) => Ut.decode(new a(r)));
  }
  Undelegate(e) {
    const t = In.encode(e).finish();
    return this.rpc.request(this.service, "Undelegate", t).then((r) => Ht.decode(new a(r)));
  }
  CancelUnbondingDelegation(e) {
    const t = Cn.encode(e).finish();
    return this.rpc.request(this.service, "CancelUnbondingDelegation", t).then((r) => _t.decode(new a(r)));
  }
  UpdateParams(e) {
    const t = Un.encode(e).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((r) => Mt.decode(new a(r)));
  }
};
function fd(n) {
  const e = Math.trunc(n.getTime() / 1e3), t = n.getTime() % 1e3 * 1e6;
  return { seconds: e, nanos: t };
}
function Dt(n) {
  let e = (n.seconds || 0) * 1e3;
  return e += (n.nanos || 0) / 1e6, new globalThis.Date(e);
}
function hd(n) {
  return n instanceof globalThis.Date ? n : typeof n == "string" ? new globalThis.Date(n) : Dt(U.fromJSON(n));
}
function pu(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function H(n) {
  return n != null;
}
const xc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgBeginRedelegate: Jn,
  MsgBeginRedelegateResponse: Ut,
  MsgCancelUnbondingDelegation: Cn,
  MsgCancelUnbondingDelegationResponse: _t,
  MsgClientImpl: gu,
  MsgCreateValidator: Et,
  MsgCreateValidatorResponse: Jt,
  MsgDelegate: En,
  MsgDelegateResponse: Ct,
  MsgEditValidator: Rn,
  MsgEditValidatorResponse: It,
  MsgServiceName: ld,
  MsgUndelegate: In,
  MsgUndelegateResponse: Ht,
  MsgUpdateParams: Un,
  MsgUpdateParamsResponse: Mt,
  protobufPackage: hu
}, Symbol.toStringTag, { value: "Module" }));
function mu(n) {
  switch (n) {
    case 0:
    case "CREATED":
      return 0;
    case 1:
    case "BONDED":
      return 1;
    case 2:
    case "UNBONDING":
      return 2;
    case 3:
    case "UNBONDED":
      return 3;
    case 4:
    case "REMOVED":
      return 4;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function ku(n) {
  switch (n) {
    case 0:
      return "CREATED";
    case 1:
      return "BONDED";
    case 2:
      return "UNBONDING";
    case 3:
      return "UNBONDED";
    case 4:
      return "REMOVED";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function sa() {
  return { state: 0, valAddr: "", amount: void 0, blockHeight: 0, blockTime: void 0 };
}
const me = {
  encode(n, e = new g()) {
    return n.state !== 0 && e.uint32(8).int32(n.state), n.valAddr !== "" && e.uint32(18).string(n.valAddr), n.amount !== void 0 && y.encode(n.amount, e.uint32(26).fork()).join(), n.blockHeight !== 0 && e.uint32(32).uint64(n.blockHeight), n.blockTime !== void 0 && U.encode(vu(n.blockTime), e.uint32(42).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = sa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.state = t.int32();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.valAddr = t.string();
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.amount = y.decode(t, t.uint32());
          continue;
        }
        case 4: {
          if (i !== 32)
            break;
          r.blockHeight = pd(t.uint64());
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.blockTime = gd(U.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      state: Hn(n.state) ? mu(n.state) : 0,
      valAddr: Hn(n.valAddr) ? globalThis.String(n.valAddr) : "",
      amount: Hn(n.amount) ? y.fromJSON(n.amount) : void 0,
      blockHeight: Hn(n.blockHeight) ? globalThis.Number(n.blockHeight) : 0,
      blockTime: Hn(n.blockTime) ? Tu(n.blockTime) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.state !== 0 && (e.state = ku(n.state)), n.valAddr !== "" && (e.valAddr = n.valAddr), n.amount !== void 0 && (e.amount = y.toJSON(n.amount)), n.blockHeight !== 0 && (e.blockHeight = Math.round(n.blockHeight)), n.blockTime !== void 0 && (e.blockTime = n.blockTime.toISOString()), e;
  },
  create(n) {
    return me.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = sa();
    return e.state = n.state ?? 0, e.valAddr = n.valAddr ?? "", e.amount = n.amount !== void 0 && n.amount !== null ? y.fromPartial(n.amount) : void 0, e.blockHeight = n.blockHeight ?? 0, e.blockTime = n.blockTime ?? void 0, e;
  }
};
function da() {
  return { delAddr: "", delLife: [] };
}
const ke = {
  encode(n, e = new g()) {
    n.delAddr !== "" && e.uint32(10).string(n.delAddr);
    for (const t of n.delLife)
      me.encode(t, e.uint32(18).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = da();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delAddr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.delLife.push(me.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delAddr: Hn(n.delAddr) ? globalThis.String(n.delAddr) : "",
      delLife: globalThis.Array.isArray(n == null ? void 0 : n.delLife) ? n.delLife.map((e) => me.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.delAddr !== "" && (e.delAddr = n.delAddr), (t = n.delLife) != null && t.length && (e.delLife = n.delLife.map((o) => me.toJSON(o))), e;
  },
  create(n) {
    return ke.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = da();
    return e.delAddr = n.delAddr ?? "", e.delLife = ((t = n.delLife) == null ? void 0 : t.map((o) => me.fromPartial(o))) || [], e;
  }
};
function ua() {
  return { addr: new Uint8Array(0), power: 0 };
}
const Se = {
  encode(n, e = new g()) {
    return n.addr.length !== 0 && e.uint32(10).bytes(n.addr), n.power !== 0 && e.uint32(16).int64(n.power), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ua();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.addr = t.bytes();
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.power = pd(t.int64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      addr: Hn(n.addr) ? Su(n.addr) : new Uint8Array(0),
      power: Hn(n.power) ? globalThis.Number(n.power) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.addr.length !== 0 && (e.addr = bu(n.addr)), n.power !== 0 && (e.power = Math.round(n.power)), e;
  },
  create(n) {
    return Se.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ua();
    return e.addr = n.addr ?? new Uint8Array(0), e.power = n.power ?? 0, e;
  }
};
function Su(n) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(n, "base64"));
  {
    const e = globalThis.atob(n), t = new Uint8Array(e.length);
    for (let o = 0; o < e.length; ++o)
      t[o] = e.charCodeAt(o);
    return t;
  }
}
function bu(n) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(n).toString("base64");
  {
    const e = [];
    return n.forEach((t) => {
      e.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(e.join(""));
  }
}
function vu(n) {
  const e = Math.trunc(n.getTime() / 1e3), t = n.getTime() % 1e3 * 1e6;
  return { seconds: e, nanos: t };
}
function gd(n) {
  let e = (n.seconds || 0) * 1e3;
  return e += (n.nanos || 0) / 1e6, new globalThis.Date(e);
}
function Tu(n) {
  return n instanceof globalThis.Date ? n : typeof n == "string" ? new globalThis.Date(n) : gd(U.fromJSON(n));
}
function pd(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function Hn(n) {
  return n != null;
}
function ca() {
  return { epochInterval: 0 };
}
const Sn = {
  encode(n, e = new g()) {
    return n.epochInterval !== 0 && e.uint32(8).uint64(n.epochInterval), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ca();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochInterval = yu(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { epochInterval: wu(n.epochInterval) ? globalThis.Number(n.epochInterval) : 0 };
  },
  toJSON(n) {
    const e = {};
    return n.epochInterval !== 0 && (e.epochInterval = Math.round(n.epochInterval)), e;
  },
  create(n) {
    return Sn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ca();
    return e.epochInterval = n.epochInterval ?? 0, e;
  }
};
function yu(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function wu(n) {
  return n != null;
}
const Au = "babylon.epoching.v1";
function la() {
  return {};
}
const Vt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = la();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Vt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return la();
  }
};
function fa() {
  return { params: void 0 };
}
const Ft = {
  encode(n, e = new g()) {
    return n.params !== void 0 && Sn.encode(n.params, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = fa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.params = Sn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { params: R(n.params) ? Sn.fromJSON(n.params) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.params !== void 0 && (e.params = Sn.toJSON(n.params)), e;
  },
  create(n) {
    return Ft.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = fa();
    return e.params = n.params !== void 0 && n.params !== null ? Sn.fromPartial(n.params) : void 0, e;
  }
};
function ha() {
  return { epochNum: 0 };
}
const Lt = {
  encode(n, e = new g()) {
    return n.epochNum !== 0 && e.uint32(8).uint64(n.epochNum), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ha();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochNum = tn(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { epochNum: R(n.epochNum) ? globalThis.Number(n.epochNum) : 0 };
  },
  toJSON(n) {
    const e = {};
    return n.epochNum !== 0 && (e.epochNum = Math.round(n.epochNum)), e;
  },
  create(n) {
    return Lt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ha();
    return e.epochNum = n.epochNum ?? 0, e;
  }
};
function ga() {
  return { epoch: void 0 };
}
const Gt = {
  encode(n, e = new g()) {
    return n.epoch !== void 0 && gn.encode(n.epoch, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ga();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.epoch = gn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { epoch: R(n.epoch) ? gn.fromJSON(n.epoch) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.epoch !== void 0 && (e.epoch = gn.toJSON(n.epoch)), e;
  },
  create(n) {
    return Gt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ga();
    return e.epoch = n.epoch !== void 0 && n.epoch !== null ? gn.fromPartial(n.epoch) : void 0, e;
  }
};
function pa() {
  return { pagination: void 0 };
}
const Wt = {
  encode(n, e = new g()) {
    return n.pagination !== void 0 && I.encode(n.pagination, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = pa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.pagination = I.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { pagination: R(n.pagination) ? I.fromJSON(n.pagination) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.pagination !== void 0 && (e.pagination = I.toJSON(n.pagination)), e;
  },
  create(n) {
    return Wt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = pa();
    return e.pagination = n.pagination !== void 0 && n.pagination !== null ? I.fromPartial(n.pagination) : void 0, e;
  }
};
function ma() {
  return { epochs: [], pagination: void 0 };
}
const $t = {
  encode(n, e = new g()) {
    for (const t of n.epochs)
      gn.encode(t, e.uint32(10).fork()).join();
    return n.pagination !== void 0 && C.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ma();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.epochs.push(gn.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = C.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      epochs: globalThis.Array.isArray(n == null ? void 0 : n.epochs) ? n.epochs.map((e) => gn.fromJSON(e)) : [],
      pagination: R(n.pagination) ? C.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.epochs) != null && t.length && (e.epochs = n.epochs.map((o) => gn.toJSON(o))), n.pagination !== void 0 && (e.pagination = C.toJSON(n.pagination)), e;
  },
  create(n) {
    return $t.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = ma();
    return e.epochs = ((t = n.epochs) == null ? void 0 : t.map((o) => gn.fromPartial(o))) || [], e.pagination = n.pagination !== void 0 && n.pagination !== null ? C.fromPartial(n.pagination) : void 0, e;
  }
};
function ka() {
  return {};
}
const Qt = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ka();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Qt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return ka();
  }
};
function Sa() {
  return { currentEpoch: 0, epochBoundary: 0 };
}
const qt = {
  encode(n, e = new g()) {
    return n.currentEpoch !== 0 && e.uint32(8).uint64(n.currentEpoch), n.epochBoundary !== 0 && e.uint32(16).uint64(n.epochBoundary), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Sa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.currentEpoch = tn(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.epochBoundary = tn(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      currentEpoch: R(n.currentEpoch) ? globalThis.Number(n.currentEpoch) : 0,
      epochBoundary: R(n.epochBoundary) ? globalThis.Number(n.epochBoundary) : 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.currentEpoch !== 0 && (e.currentEpoch = Math.round(n.currentEpoch)), n.epochBoundary !== 0 && (e.epochBoundary = Math.round(n.epochBoundary)), e;
  },
  create(n) {
    return qt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Sa();
    return e.currentEpoch = n.currentEpoch ?? 0, e.epochBoundary = n.epochBoundary ?? 0, e;
  }
};
function ba() {
  return { epochNum: 0, pagination: void 0 };
}
const Xt = {
  encode(n, e = new g()) {
    return n.epochNum !== 0 && e.uint32(8).uint64(n.epochNum), n.pagination !== void 0 && I.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ba();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochNum = tn(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = I.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      epochNum: R(n.epochNum) ? globalThis.Number(n.epochNum) : 0,
      pagination: R(n.pagination) ? I.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.epochNum !== 0 && (e.epochNum = Math.round(n.epochNum)), n.pagination !== void 0 && (e.pagination = I.toJSON(n.pagination)), e;
  },
  create(n) {
    return Xt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ba();
    return e.epochNum = n.epochNum ?? 0, e.pagination = n.pagination !== void 0 && n.pagination !== null ? I.fromPartial(n.pagination) : void 0, e;
  }
};
function va() {
  return { msgs: [], pagination: void 0 };
}
const Kt = {
  encode(n, e = new g()) {
    for (const t of n.msgs)
      pn.encode(t, e.uint32(10).fork()).join();
    return n.pagination !== void 0 && C.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = va();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msgs.push(pn.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = C.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      msgs: globalThis.Array.isArray(n == null ? void 0 : n.msgs) ? n.msgs.map((e) => pn.fromJSON(e)) : [],
      pagination: R(n.pagination) ? C.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.msgs) != null && t.length && (e.msgs = n.msgs.map((o) => pn.toJSON(o))), n.pagination !== void 0 && (e.pagination = C.toJSON(n.pagination)), e;
  },
  create(n) {
    return Kt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = va();
    return e.msgs = ((t = n.msgs) == null ? void 0 : t.map((o) => pn.fromPartial(o))) || [], e.pagination = n.pagination !== void 0 && n.pagination !== null ? C.fromPartial(n.pagination) : void 0, e;
  }
};
function Ta() {
  return { endEpoch: 0, epochCount: 0, pagination: void 0 };
}
const Zt = {
  encode(n, e = new g()) {
    return n.endEpoch !== 0 && e.uint32(8).uint64(n.endEpoch), n.epochCount !== 0 && e.uint32(16).uint64(n.epochCount), n.pagination !== void 0 && I.encode(n.pagination, e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ta();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.endEpoch = tn(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.epochCount = tn(t.uint64());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.pagination = I.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      endEpoch: R(n.endEpoch) ? globalThis.Number(n.endEpoch) : 0,
      epochCount: R(n.epochCount) ? globalThis.Number(n.epochCount) : 0,
      pagination: R(n.pagination) ? I.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.endEpoch !== 0 && (e.endEpoch = Math.round(n.endEpoch)), n.epochCount !== 0 && (e.epochCount = Math.round(n.epochCount)), n.pagination !== void 0 && (e.pagination = I.toJSON(n.pagination)), e;
  },
  create(n) {
    return Zt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ta();
    return e.endEpoch = n.endEpoch ?? 0, e.epochCount = n.epochCount ?? 0, e.pagination = n.pagination !== void 0 && n.pagination !== null ? I.fromPartial(n.pagination) : void 0, e;
  }
};
function ya() {
  return { latestEpochMsgs: [], pagination: void 0 };
}
const zt = {
  encode(n, e = new g()) {
    for (const t of n.latestEpochMsgs)
      ie.encode(t, e.uint32(10).fork()).join();
    return n.pagination !== void 0 && C.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ya();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.latestEpochMsgs.push(ie.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = C.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      latestEpochMsgs: globalThis.Array.isArray(n == null ? void 0 : n.latestEpochMsgs) ? n.latestEpochMsgs.map((e) => ie.fromJSON(e)) : [],
      pagination: R(n.pagination) ? C.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.latestEpochMsgs) != null && t.length && (e.latestEpochMsgs = n.latestEpochMsgs.map((o) => ie.toJSON(o))), n.pagination !== void 0 && (e.pagination = C.toJSON(n.pagination)), e;
  },
  create(n) {
    return zt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = ya();
    return e.latestEpochMsgs = ((t = n.latestEpochMsgs) == null ? void 0 : t.map((o) => ie.fromPartial(o))) || [], e.pagination = n.pagination !== void 0 && n.pagination !== null ? C.fromPartial(n.pagination) : void 0, e;
  }
};
function wa() {
  return { valAddr: "" };
}
const Yt = {
  encode(n, e = new g()) {
    return n.valAddr !== "" && e.uint32(10).string(n.valAddr), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = wa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.valAddr = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { valAddr: R(n.valAddr) ? globalThis.String(n.valAddr) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.valAddr !== "" && (e.valAddr = n.valAddr), e;
  },
  create(n) {
    return Yt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = wa();
    return e.valAddr = n.valAddr ?? "", e;
  }
};
function Aa() {
  return { valAddr: "", valLife: [] };
}
const jt = {
  encode(n, e = new g()) {
    n.valAddr !== "" && e.uint32(10).string(n.valAddr);
    for (const t of n.valLife)
      re.encode(t, e.uint32(18).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Aa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.valAddr = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.valLife.push(re.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      valAddr: R(n.valAddr) ? globalThis.String(n.valAddr) : "",
      valLife: globalThis.Array.isArray(n == null ? void 0 : n.valLife) ? n.valLife.map((e) => re.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.valAddr !== "" && (e.valAddr = n.valAddr), (t = n.valLife) != null && t.length && (e.valLife = n.valLife.map((o) => re.toJSON(o))), e;
  },
  create(n) {
    return jt.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Aa();
    return e.valAddr = n.valAddr ?? "", e.valLife = ((t = n.valLife) == null ? void 0 : t.map((o) => re.fromPartial(o))) || [], e;
  }
};
function Na() {
  return { delAddr: "" };
}
const ni = {
  encode(n, e = new g()) {
    return n.delAddr !== "" && e.uint32(10).string(n.delAddr), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Na();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delAddr = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { delAddr: R(n.delAddr) ? globalThis.String(n.delAddr) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.delAddr !== "" && (e.delAddr = n.delAddr), e;
  },
  create(n) {
    return ni.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Na();
    return e.delAddr = n.delAddr ?? "", e;
  }
};
function Pa() {
  return { delLife: void 0 };
}
const ei = {
  encode(n, e = new g()) {
    return n.delLife !== void 0 && ke.encode(n.delLife, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Pa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delLife = ke.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { delLife: R(n.delLife) ? ke.fromJSON(n.delLife) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.delLife !== void 0 && (e.delLife = ke.toJSON(n.delLife)), e;
  },
  create(n) {
    return ei.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Pa();
    return e.delLife = n.delLife !== void 0 && n.delLife !== null ? ke.fromPartial(n.delLife) : void 0, e;
  }
};
function Ba() {
  return { epochNum: 0, pagination: void 0 };
}
const ti = {
  encode(n, e = new g()) {
    return n.epochNum !== 0 && e.uint32(8).uint64(n.epochNum), n.pagination !== void 0 && I.encode(n.pagination, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ba();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochNum = tn(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.pagination = I.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      epochNum: R(n.epochNum) ? globalThis.Number(n.epochNum) : 0,
      pagination: R(n.pagination) ? I.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.epochNum !== 0 && (e.epochNum = Math.round(n.epochNum)), n.pagination !== void 0 && (e.pagination = I.toJSON(n.pagination)), e;
  },
  create(n) {
    return ti.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ba();
    return e.epochNum = n.epochNum ?? 0, e.pagination = n.pagination !== void 0 && n.pagination !== null ? I.fromPartial(n.pagination) : void 0, e;
  }
};
function Oa() {
  return { validators: [], totalVotingPower: 0, pagination: void 0 };
}
const ii = {
  encode(n, e = new g()) {
    for (const t of n.validators)
      Se.encode(t, e.uint32(10).fork()).join();
    return n.totalVotingPower !== 0 && e.uint32(16).int64(n.totalVotingPower), n.pagination !== void 0 && C.encode(n.pagination, e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Oa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.validators.push(Se.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.totalVotingPower = tn(t.int64());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.pagination = C.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      validators: globalThis.Array.isArray(n == null ? void 0 : n.validators) ? n.validators.map((e) => Se.fromJSON(e)) : [],
      totalVotingPower: R(n.totalVotingPower) ? globalThis.Number(n.totalVotingPower) : 0,
      pagination: R(n.pagination) ? C.fromJSON(n.pagination) : void 0
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.validators) != null && t.length && (e.validators = n.validators.map((o) => Se.toJSON(o))), n.totalVotingPower !== 0 && (e.totalVotingPower = Math.round(n.totalVotingPower)), n.pagination !== void 0 && (e.pagination = C.toJSON(n.pagination)), e;
  },
  create(n) {
    return ii.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Oa();
    return e.validators = ((t = n.validators) == null ? void 0 : t.map((o) => Se.fromPartial(o))) || [], e.totalVotingPower = n.totalVotingPower ?? 0, e.pagination = n.pagination !== void 0 && n.pagination !== null ? C.fromPartial(n.pagination) : void 0, e;
  }
};
function xa() {
  return {
    epochNumber: 0,
    currentEpochInterval: 0,
    firstBlockHeight: 0,
    lastBlockTime: void 0,
    sealerAppHashHex: "",
    sealerBlockHash: ""
  };
}
const gn = {
  encode(n, e = new g()) {
    return n.epochNumber !== 0 && e.uint32(8).uint64(n.epochNumber), n.currentEpochInterval !== 0 && e.uint32(16).uint64(n.currentEpochInterval), n.firstBlockHeight !== 0 && e.uint32(24).uint64(n.firstBlockHeight), n.lastBlockTime !== void 0 && U.encode(ri(n.lastBlockTime), e.uint32(34).fork()).join(), n.sealerAppHashHex !== "" && e.uint32(42).string(n.sealerAppHashHex), n.sealerBlockHash !== "" && e.uint32(50).string(n.sealerBlockHash), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = xa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochNumber = tn(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.currentEpochInterval = tn(t.uint64());
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.firstBlockHeight = tn(t.uint64());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.lastBlockTime = Me(U.decode(t, t.uint32()));
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.sealerAppHashHex = t.string();
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.sealerBlockHash = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      epochNumber: R(n.epochNumber) ? globalThis.Number(n.epochNumber) : 0,
      currentEpochInterval: R(n.currentEpochInterval) ? globalThis.Number(n.currentEpochInterval) : 0,
      firstBlockHeight: R(n.firstBlockHeight) ? globalThis.Number(n.firstBlockHeight) : 0,
      lastBlockTime: R(n.lastBlockTime) ? oi(n.lastBlockTime) : void 0,
      sealerAppHashHex: R(n.sealerAppHashHex) ? globalThis.String(n.sealerAppHashHex) : "",
      sealerBlockHash: R(n.sealerBlockHash) ? globalThis.String(n.sealerBlockHash) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.epochNumber !== 0 && (e.epochNumber = Math.round(n.epochNumber)), n.currentEpochInterval !== 0 && (e.currentEpochInterval = Math.round(n.currentEpochInterval)), n.firstBlockHeight !== 0 && (e.firstBlockHeight = Math.round(n.firstBlockHeight)), n.lastBlockTime !== void 0 && (e.lastBlockTime = n.lastBlockTime.toISOString()), n.sealerAppHashHex !== "" && (e.sealerAppHashHex = n.sealerAppHashHex), n.sealerBlockHash !== "" && (e.sealerBlockHash = n.sealerBlockHash), e;
  },
  create(n) {
    return gn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = xa();
    return e.epochNumber = n.epochNumber ?? 0, e.currentEpochInterval = n.currentEpochInterval ?? 0, e.firstBlockHeight = n.firstBlockHeight ?? 0, e.lastBlockTime = n.lastBlockTime ?? void 0, e.sealerAppHashHex = n.sealerAppHashHex ?? "", e.sealerBlockHash = n.sealerBlockHash ?? "", e;
  }
};
function Ra() {
  return { txId: "", msgId: "", blockHeight: 0, blockTime: void 0, msg: "", msgType: "" };
}
const pn = {
  encode(n, e = new g()) {
    return n.txId !== "" && e.uint32(10).string(n.txId), n.msgId !== "" && e.uint32(18).string(n.msgId), n.blockHeight !== 0 && e.uint32(24).uint64(n.blockHeight), n.blockTime !== void 0 && U.encode(ri(n.blockTime), e.uint32(34).fork()).join(), n.msg !== "" && e.uint32(42).string(n.msg), n.msgType !== "" && e.uint32(50).string(n.msgType), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ra();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.txId = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.msgId = t.string();
          continue;
        }
        case 3: {
          if (i !== 24)
            break;
          r.blockHeight = tn(t.uint64());
          continue;
        }
        case 4: {
          if (i !== 34)
            break;
          r.blockTime = Me(U.decode(t, t.uint32()));
          continue;
        }
        case 5: {
          if (i !== 42)
            break;
          r.msg = t.string();
          continue;
        }
        case 6: {
          if (i !== 50)
            break;
          r.msgType = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      txId: R(n.txId) ? globalThis.String(n.txId) : "",
      msgId: R(n.msgId) ? globalThis.String(n.msgId) : "",
      blockHeight: R(n.blockHeight) ? globalThis.Number(n.blockHeight) : 0,
      blockTime: R(n.blockTime) ? oi(n.blockTime) : void 0,
      msg: R(n.msg) ? globalThis.String(n.msg) : "",
      msgType: R(n.msgType) ? globalThis.String(n.msgType) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.txId !== "" && (e.txId = n.txId), n.msgId !== "" && (e.msgId = n.msgId), n.blockHeight !== 0 && (e.blockHeight = Math.round(n.blockHeight)), n.blockTime !== void 0 && (e.blockTime = n.blockTime.toISOString()), n.msg !== "" && (e.msg = n.msg), n.msgType !== "" && (e.msgType = n.msgType), e;
  },
  create(n) {
    return pn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ra();
    return e.txId = n.txId ?? "", e.msgId = n.msgId ?? "", e.blockHeight = n.blockHeight ?? 0, e.blockTime = n.blockTime ?? void 0, e.msg = n.msg ?? "", e.msgType = n.msgType ?? "", e;
  }
};
function Ea() {
  return { epochNumber: 0, msgs: [] };
}
const ie = {
  encode(n, e = new g()) {
    n.epochNumber !== 0 && e.uint32(8).uint64(n.epochNumber);
    for (const t of n.msgs)
      pn.encode(t, e.uint32(18).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ea();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.epochNumber = tn(t.uint64());
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.msgs.push(pn.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      epochNumber: R(n.epochNumber) ? globalThis.Number(n.epochNumber) : 0,
      msgs: globalThis.Array.isArray(n == null ? void 0 : n.msgs) ? n.msgs.map((e) => pn.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return n.epochNumber !== 0 && (e.epochNumber = Math.round(n.epochNumber)), (t = n.msgs) != null && t.length && (e.msgs = n.msgs.map((o) => pn.toJSON(o))), e;
  },
  create(n) {
    return ie.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = Ea();
    return e.epochNumber = n.epochNumber ?? 0, e.msgs = ((t = n.msgs) == null ? void 0 : t.map((o) => pn.fromPartial(o))) || [], e;
  }
};
function Ja() {
  return { stateDesc: "", blockHeight: 0, blockTime: void 0 };
}
const re = {
  encode(n, e = new g()) {
    return n.stateDesc !== "" && e.uint32(10).string(n.stateDesc), n.blockHeight !== 0 && e.uint32(16).uint64(n.blockHeight), n.blockTime !== void 0 && U.encode(ri(n.blockTime), e.uint32(26).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ja();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.stateDesc = t.string();
          continue;
        }
        case 2: {
          if (i !== 16)
            break;
          r.blockHeight = tn(t.uint64());
          continue;
        }
        case 3: {
          if (i !== 26)
            break;
          r.blockTime = Me(U.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      stateDesc: R(n.stateDesc) ? globalThis.String(n.stateDesc) : "",
      blockHeight: R(n.blockHeight) ? globalThis.Number(n.blockHeight) : 0,
      blockTime: R(n.blockTime) ? oi(n.blockTime) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.stateDesc !== "" && (e.stateDesc = n.stateDesc), n.blockHeight !== 0 && (e.blockHeight = Math.round(n.blockHeight)), n.blockTime !== void 0 && (e.blockTime = n.blockTime.toISOString()), e;
  },
  create(n) {
    return re.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ja();
    return e.stateDesc = n.stateDesc ?? "", e.blockHeight = n.blockHeight ?? 0, e.blockTime = n.blockTime ?? void 0, e;
  }
}, md = "babylon.epoching.v1.Query";
let Nu = class {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || md, this.rpc = e, this.Params = this.Params.bind(this), this.EpochInfo = this.EpochInfo.bind(this), this.EpochsInfo = this.EpochsInfo.bind(this), this.CurrentEpoch = this.CurrentEpoch.bind(this), this.EpochMsgs = this.EpochMsgs.bind(this), this.LatestEpochMsgs = this.LatestEpochMsgs.bind(this), this.ValidatorLifecycle = this.ValidatorLifecycle.bind(this), this.DelegationLifecycle = this.DelegationLifecycle.bind(this), this.EpochValSet = this.EpochValSet.bind(this);
  }
  Params(e) {
    const t = Vt.encode(e).finish();
    return this.rpc.request(this.service, "Params", t).then((r) => Ft.decode(new a(r)));
  }
  EpochInfo(e) {
    const t = Lt.encode(e).finish();
    return this.rpc.request(this.service, "EpochInfo", t).then((r) => Gt.decode(new a(r)));
  }
  EpochsInfo(e) {
    const t = Wt.encode(e).finish();
    return this.rpc.request(this.service, "EpochsInfo", t).then((r) => $t.decode(new a(r)));
  }
  CurrentEpoch(e) {
    const t = Qt.encode(e).finish();
    return this.rpc.request(this.service, "CurrentEpoch", t).then((r) => qt.decode(new a(r)));
  }
  EpochMsgs(e) {
    const t = Xt.encode(e).finish();
    return this.rpc.request(this.service, "EpochMsgs", t).then((r) => Kt.decode(new a(r)));
  }
  LatestEpochMsgs(e) {
    const t = Zt.encode(e).finish();
    return this.rpc.request(this.service, "LatestEpochMsgs", t).then((r) => zt.decode(new a(r)));
  }
  ValidatorLifecycle(e) {
    const t = Yt.encode(e).finish();
    return this.rpc.request(this.service, "ValidatorLifecycle", t).then((r) => jt.decode(new a(r)));
  }
  DelegationLifecycle(e) {
    const t = ni.encode(e).finish();
    return this.rpc.request(this.service, "DelegationLifecycle", t).then((r) => ei.decode(new a(r)));
  }
  EpochValSet(e) {
    const t = ti.encode(e).finish();
    return this.rpc.request(this.service, "EpochValSet", t).then((r) => ii.decode(new a(r)));
  }
};
function ri(n) {
  const e = Math.trunc(n.getTime() / 1e3), t = n.getTime() % 1e3 * 1e6;
  return { seconds: e, nanos: t };
}
function Me(n) {
  let e = (n.seconds || 0) * 1e3;
  return e += (n.nanos || 0) / 1e6, new globalThis.Date(e);
}
function oi(n) {
  return n instanceof globalThis.Date ? n : typeof n == "string" ? new globalThis.Date(n) : Me(U.fromJSON(n));
}
function tn(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function R(n) {
  return n != null;
}
const Ec = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EpochResponse: gn,
  QueryClientImpl: Nu,
  QueryCurrentEpochRequest: Qt,
  QueryCurrentEpochResponse: qt,
  QueryDelegationLifecycleRequest: ni,
  QueryDelegationLifecycleResponse: ei,
  QueryEpochInfoRequest: Lt,
  QueryEpochInfoResponse: Gt,
  QueryEpochMsgsRequest: Xt,
  QueryEpochMsgsResponse: Kt,
  QueryEpochValSetRequest: ti,
  QueryEpochValSetResponse: ii,
  QueryEpochsInfoRequest: Wt,
  QueryEpochsInfoResponse: $t,
  QueryLatestEpochMsgsRequest: Zt,
  QueryLatestEpochMsgsResponse: zt,
  QueryParamsRequest: Vt,
  QueryParamsResponse: Ft,
  QueryServiceName: md,
  QueryValidatorLifecycleRequest: Yt,
  QueryValidatorLifecycleResponse: jt,
  QueuedMessageList: ie,
  QueuedMessageResponse: pn,
  ValStateUpdateResponse: re,
  protobufPackage: Au
}, Symbol.toStringTag, { value: "Module" })), Pu = "babylon.epoching.v1";
function Ia() {
  return { msg: void 0 };
}
const Ae = {
  encode(n, e = new g()) {
    return n.msg !== void 0 && En.encode(n.msg, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ia();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msg = En.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { msg: Mn(n.msg) ? En.fromJSON(n.msg) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.msg !== void 0 && (e.msg = En.toJSON(n.msg)), e;
  },
  create(n) {
    return Ae.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ia();
    return e.msg = n.msg !== void 0 && n.msg !== null ? En.fromPartial(n.msg) : void 0, e;
  }
};
function Ca() {
  return {};
}
const ai = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ca();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return ai.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Ca();
  }
};
function Ua() {
  return { msg: void 0 };
}
const Ne = {
  encode(n, e = new g()) {
    return n.msg !== void 0 && In.encode(n.msg, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ua();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msg = In.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { msg: Mn(n.msg) ? In.fromJSON(n.msg) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.msg !== void 0 && (e.msg = In.toJSON(n.msg)), e;
  },
  create(n) {
    return Ne.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ua();
    return e.msg = n.msg !== void 0 && n.msg !== null ? In.fromPartial(n.msg) : void 0, e;
  }
};
function Ha() {
  return {};
}
const si = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ha();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return si.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Ha();
  }
};
function _a() {
  return { msg: void 0 };
}
const di = {
  encode(n, e = new g()) {
    return n.msg !== void 0 && Jn.encode(n.msg, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = _a();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msg = Jn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { msg: Mn(n.msg) ? Jn.fromJSON(n.msg) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.msg !== void 0 && (e.msg = Jn.toJSON(n.msg)), e;
  },
  create(n) {
    return di.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = _a();
    return e.msg = n.msg !== void 0 && n.msg !== null ? Jn.fromPartial(n.msg) : void 0, e;
  }
};
function Ma() {
  return {};
}
const ui = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ma();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return ui.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Ma();
  }
};
function Da() {
  return { msg: void 0 };
}
const ci = {
  encode(n, e = new g()) {
    return n.msg !== void 0 && Cn.encode(n.msg, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Da();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msg = Cn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { msg: Mn(n.msg) ? Cn.fromJSON(n.msg) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.msg !== void 0 && (e.msg = Cn.toJSON(n.msg)), e;
  },
  create(n) {
    return ci.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Da();
    return e.msg = n.msg !== void 0 && n.msg !== null ? Cn.fromPartial(n.msg) : void 0, e;
  }
};
function Va() {
  return {};
}
const li = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Va();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return li.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Va();
  }
};
function Fa() {
  return { msg: void 0 };
}
const fi = {
  encode(n, e = new g()) {
    return n.msg !== void 0 && Rn.encode(n.msg, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Fa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msg = Rn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { msg: Mn(n.msg) ? Rn.fromJSON(n.msg) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.msg !== void 0 && (e.msg = Rn.toJSON(n.msg)), e;
  },
  create(n) {
    return fi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Fa();
    return e.msg = n.msg !== void 0 && n.msg !== null ? Rn.fromPartial(n.msg) : void 0, e;
  }
};
function La() {
  return {};
}
const hi = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = La();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return hi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return La();
  }
};
function Ga() {
  return { msg: void 0 };
}
const gi = {
  encode(n, e = new g()) {
    return n.msg !== void 0 && Un.encode(n.msg, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ga();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.msg = Un.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { msg: Mn(n.msg) ? Un.fromJSON(n.msg) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.msg !== void 0 && (e.msg = Un.toJSON(n.msg)), e;
  },
  create(n) {
    return gi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ga();
    return e.msg = n.msg !== void 0 && n.msg !== null ? Un.fromPartial(n.msg) : void 0, e;
  }
};
function Wa() {
  return {};
}
const pi = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Wa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return pi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Wa();
  }
};
function $a() {
  return { authority: "", params: void 0 };
}
const mi = {
  encode(n, e = new g()) {
    return n.authority !== "" && e.uint32(10).string(n.authority), n.params !== void 0 && Sn.encode(n.params, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = $a();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.authority = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.params = Sn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      authority: Mn(n.authority) ? globalThis.String(n.authority) : "",
      params: Mn(n.params) ? Sn.fromJSON(n.params) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.authority !== "" && (e.authority = n.authority), n.params !== void 0 && (e.params = Sn.toJSON(n.params)), e;
  },
  create(n) {
    return mi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = $a();
    return e.authority = n.authority ?? "", e.params = n.params !== void 0 && n.params !== null ? Sn.fromPartial(n.params) : void 0, e;
  }
};
function Qa() {
  return {};
}
const ki = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Qa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return ki.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Qa();
  }
}, kd = "babylon.epoching.v1.Msg";
let Bu = class {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || kd, this.rpc = e, this.WrappedDelegate = this.WrappedDelegate.bind(this), this.WrappedUndelegate = this.WrappedUndelegate.bind(this), this.WrappedBeginRedelegate = this.WrappedBeginRedelegate.bind(this), this.WrappedCancelUnbondingDelegation = this.WrappedCancelUnbondingDelegation.bind(this), this.WrappedEditValidator = this.WrappedEditValidator.bind(this), this.WrappedStakingUpdateParams = this.WrappedStakingUpdateParams.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
  }
  WrappedDelegate(e) {
    const t = Ae.encode(e).finish();
    return this.rpc.request(this.service, "WrappedDelegate", t).then((r) => ai.decode(new a(r)));
  }
  WrappedUndelegate(e) {
    const t = Ne.encode(e).finish();
    return this.rpc.request(this.service, "WrappedUndelegate", t).then((r) => si.decode(new a(r)));
  }
  WrappedBeginRedelegate(e) {
    const t = di.encode(e).finish();
    return this.rpc.request(this.service, "WrappedBeginRedelegate", t).then((r) => ui.decode(new a(r)));
  }
  WrappedCancelUnbondingDelegation(e) {
    const t = ci.encode(e).finish();
    return this.rpc.request(this.service, "WrappedCancelUnbondingDelegation", t).then((r) => li.decode(new a(r)));
  }
  WrappedEditValidator(e) {
    const t = fi.encode(e).finish();
    return this.rpc.request(this.service, "WrappedEditValidator", t).then((r) => hi.decode(new a(r)));
  }
  WrappedStakingUpdateParams(e) {
    const t = gi.encode(e).finish();
    return this.rpc.request(this.service, "WrappedStakingUpdateParams", t).then((r) => pi.decode(new a(r)));
  }
  UpdateParams(e) {
    const t = mi.encode(e).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((r) => ki.decode(new a(r)));
  }
};
function Mn(n) {
  return n != null;
}
const Ic = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: Bu,
  MsgServiceName: kd,
  MsgUpdateParams: mi,
  MsgUpdateParamsResponse: ki,
  MsgWrappedBeginRedelegate: di,
  MsgWrappedBeginRedelegateResponse: ui,
  MsgWrappedCancelUnbondingDelegation: ci,
  MsgWrappedCancelUnbondingDelegationResponse: li,
  MsgWrappedDelegate: Ae,
  MsgWrappedDelegateResponse: ai,
  MsgWrappedEditValidator: fi,
  MsgWrappedEditValidatorResponse: hi,
  MsgWrappedStakingUpdateParams: gi,
  MsgWrappedStakingUpdateParamsResponse: pi,
  MsgWrappedUndelegate: Ne,
  MsgWrappedUndelegateResponse: si,
  protobufPackage: Pu
}, Symbol.toStringTag, { value: "Module" }));
function qa() {
  return { btcStakingPortion: "" };
}
const bn = {
  encode(n, e = new g()) {
    return n.btcStakingPortion !== "" && e.uint32(10).string(n.btcStakingPortion), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = qa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.btcStakingPortion = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { btcStakingPortion: Ou(n.btcStakingPortion) ? globalThis.String(n.btcStakingPortion) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.btcStakingPortion !== "" && (e.btcStakingPortion = n.btcStakingPortion), e;
  },
  create(n) {
    return bn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = qa();
    return e.btcStakingPortion = n.btcStakingPortion ?? "", e;
  }
};
function Ou(n) {
  return n != null;
}
const xu = "babylon.incentive";
function Xa() {
  return {};
}
const Si = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Xa();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Si.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return Xa();
  }
};
function Ka() {
  return { params: void 0 };
}
const bi = {
  encode(n, e = new g()) {
    return n.params !== void 0 && bn.encode(n.params, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ka();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.params = bn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { params: An(n.params) ? bn.fromJSON(n.params) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.params !== void 0 && (e.params = bn.toJSON(n.params)), e;
  },
  create(n) {
    return bi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ka();
    return e.params = n.params !== void 0 && n.params !== null ? bn.fromPartial(n.params) : void 0, e;
  }
};
function Za() {
  return { address: "" };
}
const De = {
  encode(n, e = new g()) {
    return n.address !== "" && e.uint32(10).string(n.address), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Za();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.address = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { address: An(n.address) ? globalThis.String(n.address) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.address !== "" && (e.address = n.address), e;
  },
  create(n) {
    return De.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Za();
    return e.address = n.address ?? "", e;
  }
};
function za() {
  return { coins: [], withdrawnCoins: [] };
}
const yn = {
  encode(n, e = new g()) {
    for (const t of n.coins)
      y.encode(t, e.uint32(10).fork()).join();
    for (const t of n.withdrawnCoins)
      y.encode(t, e.uint32(18).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = za();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.coins.push(y.decode(t, t.uint32()));
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.withdrawnCoins.push(y.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      coins: globalThis.Array.isArray(n == null ? void 0 : n.coins) ? n.coins.map((e) => y.fromJSON(e)) : [],
      withdrawnCoins: globalThis.Array.isArray(n == null ? void 0 : n.withdrawnCoins) ? n.withdrawnCoins.map((e) => y.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t, o;
    const e = {};
    return (t = n.coins) != null && t.length && (e.coins = n.coins.map((r) => y.toJSON(r))), (o = n.withdrawnCoins) != null && o.length && (e.withdrawnCoins = n.withdrawnCoins.map((r) => y.toJSON(r))), e;
  },
  create(n) {
    return yn.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t, o;
    const e = za();
    return e.coins = ((t = n.coins) == null ? void 0 : t.map((r) => y.fromPartial(r))) || [], e.withdrawnCoins = ((o = n.withdrawnCoins) == null ? void 0 : o.map((r) => y.fromPartial(r))) || [], e;
  }
};
function Ya() {
  return { rewardGauges: {} };
}
const vi = {
  encode(n, e = new g()) {
    return Object.entries(n.rewardGauges).forEach(([t, o]) => {
      Ee.encode({ key: t, value: o }, e.uint32(10).fork()).join();
    }), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = Ya();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          const h = Ee.decode(t, t.uint32());
          h.value !== void 0 && (r.rewardGauges[h.key] = h.value);
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      rewardGauges: Eu(n.rewardGauges) ? Object.entries(n.rewardGauges).reduce((e, [t, o]) => (e[t] = yn.fromJSON(o), e), {}) : {}
    };
  },
  toJSON(n) {
    const e = {};
    if (n.rewardGauges) {
      const t = Object.entries(n.rewardGauges);
      t.length > 0 && (e.rewardGauges = {}, t.forEach(([o, r]) => {
        e.rewardGauges[o] = yn.toJSON(r);
      }));
    }
    return e;
  },
  create(n) {
    return vi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Ya();
    return e.rewardGauges = Object.entries(n.rewardGauges ?? {}).reduce(
      (t, [o, r]) => (r !== void 0 && (t[o] = yn.fromPartial(r)), t),
      {}
    ), e;
  }
};
function ja() {
  return { key: "", value: void 0 };
}
const Ee = {
  encode(n, e = new g()) {
    return n.key !== "" && e.uint32(10).string(n.key), n.value !== void 0 && yn.encode(n.value, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ja();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.key = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.value = yn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      key: An(n.key) ? globalThis.String(n.key) : "",
      value: An(n.value) ? yn.fromJSON(n.value) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.key !== "" && (e.key = n.key), n.value !== void 0 && (e.value = yn.toJSON(n.value)), e;
  },
  create(n) {
    return Ee.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ja();
    return e.key = n.key ?? "", e.value = n.value !== void 0 && n.value !== null ? yn.fromPartial(n.value) : void 0, e;
  }
};
function ns() {
  return { height: 0 };
}
const Ti = {
  encode(n, e = new g()) {
    return n.height !== 0 && e.uint32(8).uint64(n.height), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ns();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 8)
            break;
          r.height = Ru(t.uint64());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { height: An(n.height) ? globalThis.Number(n.height) : 0 };
  },
  toJSON(n) {
    const e = {};
    return n.height !== 0 && (e.height = Math.round(n.height)), e;
  },
  create(n) {
    return Ti.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ns();
    return e.height = n.height ?? 0, e;
  }
};
function es() {
  return { coins: [] };
}
const oe = {
  encode(n, e = new g()) {
    for (const t of n.coins)
      y.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = es();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.coins.push(y.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { coins: globalThis.Array.isArray(n == null ? void 0 : n.coins) ? n.coins.map((e) => y.fromJSON(e)) : [] };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.coins) != null && t.length && (e.coins = n.coins.map((o) => y.toJSON(o))), e;
  },
  create(n) {
    return oe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = es();
    return e.coins = ((t = n.coins) == null ? void 0 : t.map((o) => y.fromPartial(o))) || [], e;
  }
};
function ts() {
  return { gauge: void 0 };
}
const yi = {
  encode(n, e = new g()) {
    return n.gauge !== void 0 && oe.encode(n.gauge, e.uint32(10).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ts();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.gauge = oe.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { gauge: An(n.gauge) ? oe.fromJSON(n.gauge) : void 0 };
  },
  toJSON(n) {
    const e = {};
    return n.gauge !== void 0 && (e.gauge = oe.toJSON(n.gauge)), e;
  },
  create(n) {
    return yi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ts();
    return e.gauge = n.gauge !== void 0 && n.gauge !== null ? oe.fromPartial(n.gauge) : void 0, e;
  }
};
function is() {
  return { delegatorAddress: "" };
}
const wi = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = is();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { delegatorAddress: An(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), e;
  },
  create(n) {
    return wi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = is();
    return e.delegatorAddress = n.delegatorAddress ?? "", e;
  }
};
function rs() {
  return { withdrawAddress: "" };
}
const Ai = {
  encode(n, e = new g()) {
    return n.withdrawAddress !== "" && e.uint32(10).string(n.withdrawAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = rs();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.withdrawAddress = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { withdrawAddress: An(n.withdrawAddress) ? globalThis.String(n.withdrawAddress) : "" };
  },
  toJSON(n) {
    const e = {};
    return n.withdrawAddress !== "" && (e.withdrawAddress = n.withdrawAddress), e;
  },
  create(n) {
    return Ai.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = rs();
    return e.withdrawAddress = n.withdrawAddress ?? "", e;
  }
};
function os() {
  return { finalityProviderAddress: "", delegatorAddress: "" };
}
const Ni = {
  encode(n, e = new g()) {
    return n.finalityProviderAddress !== "" && e.uint32(10).string(n.finalityProviderAddress), n.delegatorAddress !== "" && e.uint32(18).string(n.delegatorAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = os();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.finalityProviderAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      finalityProviderAddress: An(n.finalityProviderAddress) ? globalThis.String(n.finalityProviderAddress) : "",
      delegatorAddress: An(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.finalityProviderAddress !== "" && (e.finalityProviderAddress = n.finalityProviderAddress), n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), e;
  },
  create(n) {
    return Ni.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = os();
    return e.finalityProviderAddress = n.finalityProviderAddress ?? "", e.delegatorAddress = n.delegatorAddress ?? "", e;
  }
};
function as() {
  return { rewards: [] };
}
const Pi = {
  encode(n, e = new g()) {
    for (const t of n.rewards)
      y.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = as();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.rewards.push(y.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      rewards: globalThis.Array.isArray(n == null ? void 0 : n.rewards) ? n.rewards.map((e) => y.fromJSON(e)) : []
    };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.rewards) != null && t.length && (e.rewards = n.rewards.map((o) => y.toJSON(o))), e;
  },
  create(n) {
    return Pi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = as();
    return e.rewards = ((t = n.rewards) == null ? void 0 : t.map((o) => y.fromPartial(o))) || [], e;
  }
}, Sd = "babylon.incentive.Query";
class bd {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || Sd, this.rpc = e, this.Params = this.Params.bind(this), this.RewardGauges = this.RewardGauges.bind(this), this.BTCStakingGauge = this.BTCStakingGauge.bind(this), this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this), this.DelegationRewards = this.DelegationRewards.bind(this);
  }
  Params(e) {
    const t = Si.encode(e).finish();
    return this.rpc.request(this.service, "Params", t).then((r) => bi.decode(new a(r)));
  }
  RewardGauges(e) {
    const t = De.encode(e).finish();
    return this.rpc.request(this.service, "RewardGauges", t).then((r) => vi.decode(new a(r)));
  }
  BTCStakingGauge(e) {
    const t = Ti.encode(e).finish();
    return this.rpc.request(this.service, "BTCStakingGauge", t).then((r) => yi.decode(new a(r)));
  }
  DelegatorWithdrawAddress(e) {
    const t = wi.encode(e).finish();
    return this.rpc.request(this.service, "DelegatorWithdrawAddress", t).then((r) => Ai.decode(new a(r)));
  }
  DelegationRewards(e) {
    const t = Ni.encode(e).finish();
    return this.rpc.request(this.service, "DelegationRewards", t).then((r) => Pi.decode(new a(r)));
  }
}
function Ru(n) {
  const e = globalThis.Number(n.toString());
  if (e > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e;
}
function Eu(n) {
  return typeof n == "object" && n !== null;
}
function An(n) {
  return n != null;
}
const Cc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCStakingGaugeResponse: oe,
  QueryBTCStakingGaugeRequest: Ti,
  QueryBTCStakingGaugeResponse: yi,
  QueryClientImpl: bd,
  QueryDelegationRewardsRequest: Ni,
  QueryDelegationRewardsResponse: Pi,
  QueryDelegatorWithdrawAddressRequest: wi,
  QueryDelegatorWithdrawAddressResponse: Ai,
  QueryParamsRequest: Si,
  QueryParamsResponse: bi,
  QueryRewardGaugesRequest: De,
  QueryRewardGaugesResponse: vi,
  QueryRewardGaugesResponse_RewardGaugesEntry: Ee,
  QueryServiceName: Sd,
  RewardGaugesResponse: yn,
  protobufPackage: xu
}, Symbol.toStringTag, { value: "Module" })), Ju = "babylon.incentive";
function ss() {
  return { type: "", address: "" };
}
const Pe = {
  encode(n, e = new g()) {
    return n.type !== "" && e.uint32(10).string(n.type), n.address !== "" && e.uint32(18).string(n.address), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ss();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.type = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.address = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      type: be(n.type) ? globalThis.String(n.type) : "",
      address: be(n.address) ? globalThis.String(n.address) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.type !== "" && (e.type = n.type), n.address !== "" && (e.address = n.address), e;
  },
  create(n) {
    return Pe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ss();
    return e.type = n.type ?? "", e.address = n.address ?? "", e;
  }
};
function ds() {
  return { coins: [] };
}
const Bi = {
  encode(n, e = new g()) {
    for (const t of n.coins)
      y.encode(t, e.uint32(10).fork()).join();
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ds();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.coins.push(y.decode(t, t.uint32()));
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return { coins: globalThis.Array.isArray(n == null ? void 0 : n.coins) ? n.coins.map((e) => y.fromJSON(e)) : [] };
  },
  toJSON(n) {
    var t;
    const e = {};
    return (t = n.coins) != null && t.length && (e.coins = n.coins.map((o) => y.toJSON(o))), e;
  },
  create(n) {
    return Bi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var t;
    const e = ds();
    return e.coins = ((t = n.coins) == null ? void 0 : t.map((o) => y.fromPartial(o))) || [], e;
  }
};
function us() {
  return { authority: "", params: void 0 };
}
const Oi = {
  encode(n, e = new g()) {
    return n.authority !== "" && e.uint32(10).string(n.authority), n.params !== void 0 && bn.encode(n.params, e.uint32(18).fork()).join(), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = us();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.authority = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.params = bn.decode(t, t.uint32());
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      authority: be(n.authority) ? globalThis.String(n.authority) : "",
      params: be(n.params) ? bn.fromJSON(n.params) : void 0
    };
  },
  toJSON(n) {
    const e = {};
    return n.authority !== "" && (e.authority = n.authority), n.params !== void 0 && (e.params = bn.toJSON(n.params)), e;
  },
  create(n) {
    return Oi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = us();
    return e.authority = n.authority ?? "", e.params = n.params !== void 0 && n.params !== null ? bn.fromPartial(n.params) : void 0, e;
  }
};
function cs() {
  return {};
}
const xi = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = cs();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return xi.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return cs();
  }
};
function ls() {
  return { delegatorAddress: "", withdrawAddress: "" };
}
const Ri = {
  encode(n, e = new g()) {
    return n.delegatorAddress !== "" && e.uint32(10).string(n.delegatorAddress), n.withdrawAddress !== "" && e.uint32(18).string(n.withdrawAddress), e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = ls();
    for (; t.pos < o; ) {
      const i = t.uint32();
      switch (i >>> 3) {
        case 1: {
          if (i !== 10)
            break;
          r.delegatorAddress = t.string();
          continue;
        }
        case 2: {
          if (i !== 18)
            break;
          r.withdrawAddress = t.string();
          continue;
        }
      }
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {
      delegatorAddress: be(n.delegatorAddress) ? globalThis.String(n.delegatorAddress) : "",
      withdrawAddress: be(n.withdrawAddress) ? globalThis.String(n.withdrawAddress) : ""
    };
  },
  toJSON(n) {
    const e = {};
    return n.delegatorAddress !== "" && (e.delegatorAddress = n.delegatorAddress), n.withdrawAddress !== "" && (e.withdrawAddress = n.withdrawAddress), e;
  },
  create(n) {
    return Ri.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ls();
    return e.delegatorAddress = n.delegatorAddress ?? "", e.withdrawAddress = n.withdrawAddress ?? "", e;
  }
};
function fs() {
  return {};
}
const Ei = {
  encode(n, e = new g()) {
    return e;
  },
  decode(n, e) {
    const t = n instanceof a ? n : new a(n);
    let o = e === void 0 ? t.len : t.pos + e;
    const r = fs();
    for (; t.pos < o; ) {
      const i = t.uint32();
      if ((i & 7) === 4 || i === 0)
        break;
      t.skip(i & 7);
    }
    return r;
  },
  fromJSON(n) {
    return {};
  },
  toJSON(n) {
    return {};
  },
  create(n) {
    return Ei.fromPartial(n ?? {});
  },
  fromPartial(n) {
    return fs();
  }
}, vd = "babylon.incentive.Msg";
class Iu {
  constructor(e, t) {
    nn(this, "rpc");
    nn(this, "service");
    this.service = (t == null ? void 0 : t.service) || vd, this.rpc = e, this.WithdrawReward = this.WithdrawReward.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
  }
  WithdrawReward(e) {
    const t = Pe.encode(e).finish();
    return this.rpc.request(this.service, "WithdrawReward", t).then((r) => Bi.decode(new a(r)));
  }
  UpdateParams(e) {
    const t = Oi.encode(e).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((r) => xi.decode(new a(r)));
  }
  SetWithdrawAddress(e) {
    const t = Ri.encode(e).finish();
    return this.rpc.request(this.service, "SetWithdrawAddress", t).then((r) => Ei.decode(new a(r)));
  }
}
function be(n) {
  return n != null;
}
const Uc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: Iu,
  MsgServiceName: vd,
  MsgSetWithdrawAddress: Ri,
  MsgSetWithdrawAddressResponse: Ei,
  MsgUpdateParams: Oi,
  MsgUpdateParamsResponse: xi,
  MsgWithdrawReward: Pe,
  MsgWithdrawRewardResponse: Bi,
  protobufPackage: Ju
}, Symbol.toStringTag, { value: "Module" }));
class Cu extends Error {
  constructor(e, t, o) {
    super(t, o), this.code = e;
  }
}
function Uu(n) {
  return n.replace(/_([a-z])/g, (e, t) => t.toUpperCase());
}
function Xe(n, e) {
  if (Array.isArray(n))
    return n.map((t) => Xe(t, e));
  if (n !== null && typeof n == "object") {
    const t = {};
    for (const [o, r] of Object.entries(n))
      t[e(o)] = Xe(r, e);
    return t;
  }
  return n;
}
function Hu(n) {
  return async (e, t) => {
    const o = t ? `?${new URLSearchParams(t)}` : "", r = `${n}${e}${o}`, i = await fetch(r), h = await i.json();
    if (!i.ok)
      throw new Cu(
        i.status,
        (h == null ? void 0 : h.message) ?? "Unknown Server Error"
      );
    return Xe(h, Uu);
  };
}
const _u = 100;
function Td(n = {}) {
  const e = {};
  return n.limit !== void 0 && (e["pagination.limit"] = n.limit.toString()), n.key !== void 0 && n.key !== "" && (e["pagination.key"] = n.key), e;
}
async function ve(n, e, t, o = {}) {
  var p;
  const r = [];
  let i = o.key || null;
  const h = o.limit || _u;
  do {
    const b = Td({
      ...o,
      limit: h,
      key: i || void 0
    }), O = await n(e, b), T = O[t];
    T && Array.isArray(T) && r.push(...T);
    const m = (p = O.pagination) == null ? void 0 : p.nextKey;
    if (i = m && m !== "" ? m : null, T && T.length === 0 && i === null)
      break;
  } while (i !== null);
  return r;
}
const Mu = ({ request: n }) => ({
  async getDelegations(e) {
    try {
      return await ve(
        n,
        `/cosmos/staking/v1beta1/delegations/${e}`,
        "delegationResponses"
      );
    } catch (t) {
      throw new Error(`Failed to fetch delegations for ${e}`, {
        cause: t
      });
    }
  },
  async getRewards(e) {
    try {
      return (await n(
        `/cosmos/distribution/v1beta1/delegators/${e}/rewards`
      )).rewards || [];
    } catch (t) {
      if (t instanceof Error && t.message.includes("no delegation"))
        return [];
      throw new Error(`Failed to fetch delegation rewards for ${e}`, {
        cause: t
      });
    }
  },
  async getValidators() {
    try {
      return await ve(
        n,
        "/cosmos/staking/v1beta1/validators",
        "validators"
      );
    } catch (e) {
      throw new Error("Failed to fetch validators", {
        cause: e
      });
    }
  },
  async getBalance(e, t = "ubbn") {
    var o;
    try {
      const r = await n(
        `/cosmos/bank/v1beta1/balances/${e}/by_denom`,
        { denom: t }
      );
      return BigInt(((o = r == null ? void 0 : r.balance) == null ? void 0 : o.amount) ?? 0);
    } catch (r) {
      throw new Error(`Failed to fetch balance for ${e}`, {
        cause: r
      });
    }
  },
  async getPool() {
    try {
      const { pool: e } = await n("/cosmos/staking/v1beta1/pool");
      return {
        notBondedTokens: Number.parseInt(e.notBondedTokens, 10),
        bondedTokens: Number.parseInt(e.bondedTokens, 10)
      };
    } catch (e) {
      throw new Error("Failed to fetch pool", {
        cause: e
      });
    }
  },
  async getIncentiveParams() {
    const e = await n("/babylon/incentive/params"), t = (e == null ? void 0 : e.params) ?? e, o = Number((t == null ? void 0 : t.btcStakingPortion) ?? 0), r = Number((t == null ? void 0 : t.fpPortion) ?? 0);
    return {
      btcStakingPortion: Number.isFinite(o) ? o : 0,
      fpPortion: Number.isFinite(r) ? r : 0
    };
  },
  async getCostakingParams() {
    const e = await n("/babylon/costaking/v1/params"), t = (e == null ? void 0 : e.params) ?? e, o = Number(
      (t == null ? void 0 : t.costakingPortion) ?? (t == null ? void 0 : t.costaking_portion) ?? 0
    ), r = Number(
      (t == null ? void 0 : t.validatorsPortion) ?? (t == null ? void 0 : t.validators_portion) ?? 0
    ), i = (t == null ? void 0 : t.scoreRatioBtcByBaby) ?? (t == null ? void 0 : t.score_ratio_btc_by_baby) ?? "50";
    return {
      costakingPortion: Number.isFinite(o) ? o : 0,
      validatorsPortion: Number.isFinite(r) ? r : 0,
      scoreRatioBtcByBaby: i
    };
  },
  async getCoStakerRewardsTracker(e) {
    var t;
    if (!e)
      return null;
    try {
      const o = await n(
        `/babylon/costaking/v1/costakers/${e}/rewards_tracker`
      );
      return {
        startPeriodCumulativeReward: (o == null ? void 0 : o.startPeriodCumulativeReward) ?? 0,
        activeSatoshis: (o == null ? void 0 : o.activeSatoshis) ?? "0",
        activeBaby: (o == null ? void 0 : o.activeBaby) ?? "0",
        totalScore: (o == null ? void 0 : o.totalScore) ?? "0"
      };
    } catch (o) {
      if ((t = o == null ? void 0 : o.message) != null && t.includes("404") || (o == null ? void 0 : o.status) === 404)
        return null;
      throw new Error(
        `Failed to fetch co-staker rewards tracker for ${e}`,
        {
          cause: o
        }
      );
    }
  },
  async getCurrentCoStakingRewards() {
    try {
      const e = await n("/babylon/costaking/v1/current_rewards");
      return {
        rewards: (e == null ? void 0 : e.rewards) ?? [],
        period: (e == null ? void 0 : e.period) ?? 0,
        totalScore: (e == null ? void 0 : e.totalScore) ?? "0"
      };
    } catch (e) {
      throw new Error("Failed to fetch current co-staking rewards", {
        cause: e
      });
    }
  },
  async getAnnualProvisions() {
    try {
      const e = await n("/cosmos/mint/v1beta1/annual_provisions"), t = (e == null ? void 0 : e.annualProvisions) ?? (e == null ? void 0 : e.annual_provisions) ?? e;
      return Number(t);
    } catch (e) {
      throw new Error("Failed to fetch annual provisions", {
        cause: e
      });
    }
  },
  async getSupply(e = "ubbn") {
    var t;
    try {
      const o = await n("/cosmos/bank/v1beta1/supply/by_denom", {
        denom: e
      }), r = ((t = o == null ? void 0 : o.amount) == null ? void 0 : t.amount) ?? 0;
      return BigInt(r);
    } catch (o) {
      throw new Error(`Failed to fetch supply for ${e}`, {
        cause: o
      });
    }
  },
  async getAnnualCoStakingRewardSupply() {
    try {
      const e = await this.getAnnualProvisions(), t = await this.getIncentiveParams(), { btcStakingPortion: o, fpPortion: r } = t, i = await this.getCostakingParams(), { costakingPortion: h } = i, p = 1 - o - r;
      return e * p * h;
    } catch (e) {
      throw new Error("Failed to calculate annual co-staking reward supply", {
        cause: e
      });
    }
  },
  async getCurrentEpoch() {
    try {
      const { currentEpoch: e, epochBoundary: t } = await n(
        "/babylon/epoching/v1/current_epoch"
      );
      return {
        epochBoundary: Number.parseInt(t, 10),
        currentEpoch: Number.parseInt(e, 10)
      };
    } catch (e) {
      throw new Error("Failed to fetch current epoch", {
        cause: e
      });
    }
  },
  async getSigningInfos() {
    try {
      return (await ve(
        n,
        "/cosmos/slashing/v1beta1/signing_infos",
        "info",
        { limit: 200 }
      )).map((t) => ({
        address: t.address,
        tombstoned: !!t.tombstoned
      }));
    } catch (e) {
      throw new Error("Failed to fetch signing infos", { cause: e });
    }
  },
  async getLatestValidatorSet() {
    try {
      return await ve(
        n,
        "/cosmos/base/tendermint/v1beta1/validatorsets/latest",
        "validators",
        { limit: 200 }
      );
    } catch (e) {
      throw new Error("Failed to fetch latest validator set", { cause: e });
    }
  }
}), Je = "BTC_STAKER", Ie = "COSTAKER", Du = "btc_staker", F = {
  MsgCreateBTCDelegation: "/babylon.btcstaking.v1.MsgCreateBTCDelegation",
  MsgBtcStakeExpand: "/babylon.btcstaking.v1.MsgBtcStakeExpand",
  MsgWithdrawRewardForBTCStaking: "/babylon.incentive.MsgWithdrawReward",
  MsgStakeBABY: "/babylon.epoching.v1.MsgWrappedDelegate",
  MsgUnstakeBABY: "/babylon.epoching.v1.MsgWrappedUndelegate",
  MsgWithdrawRewardForBABYStaking: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward"
};
function _n(n) {
  return (n == null ? void 0 : n.reduce(
    (t, o) => t + BigInt(o.amount),
    0n
  )) || 0n;
}
const Vu = ({ request: n }) => ({
  async getRewards(e) {
    var t, o, r, i;
    try {
      const h = await n(
        `/babylon/incentive/address/${e}/reward_gauge`
      );
      if (!(h != null && h.rewardGauges))
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      const p = (t = h.rewardGauges[Je]) == null ? void 0 : t.coins, b = _n(
        (o = h.rewardGauges[Je]) == null ? void 0 : o.withdrawnCoins
      ), T = _n(p) - b, m = (r = h.rewardGauges[Ie]) == null ? void 0 : r.coins, v = _n(
        (i = h.rewardGauges[Ie]) == null ? void 0 : i.withdrawnCoins
      ), z = _n(m) - v;
      return {
        btcStaker: T,
        coStaker: z
      };
    } catch (h) {
      if (h instanceof Error && h.message.includes("reward gauge not found"))
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      throw new Error(`Failed to fetch rewards for ${e}`, {
        cause: h
      });
    }
  },
  async getBTCTipHeight() {
    try {
      const { header: e } = await n("/babylon/btclightclient/v1/tip");
      return Number((e == null ? void 0 : e.height) ?? 0);
    } catch (e) {
      throw new Error("Failed to fetch BTC tip height", {
        cause: e
      });
    }
  }
}), Hc = ({ url: n }) => {
  const e = Hu(n);
  return {
    baby: Mu({ request: e }),
    btc: Vu({ request: e })
  };
}, Fu = ({
  staking: n,
  distribution: e,
  bank: t,
  tmClient: o
}) => ({
  async getDelegations(r) {
    try {
      return (await n.delegatorDelegations(r)).delegationResponses || [];
    } catch (i) {
      throw new Error(`Failed to fetch delegations for ${r}`, {
        cause: i
      });
    }
  },
  async getRewards(r) {
    try {
      return (await e.delegationTotalRewards(r)).rewards || [];
    } catch (i) {
      if (i instanceof Error && i.message.includes("no delegation"))
        return [];
      throw new Error(`Failed to fetch delegation rewards for ${r}`, {
        cause: i
      });
    }
  },
  async getValidators() {
    try {
      return (await n.validators("")).validators || [];
    } catch (r) {
      throw new Error("Failed to fetch validators", {
        cause: r
      });
    }
  },
  async getBalance(r, i = "ubbn") {
    try {
      const h = await t.balance(r, i);
      return BigInt((h == null ? void 0 : h.amount) ?? 0);
    } catch (h) {
      throw new Error(`Failed to fetch balance for ${r}`, {
        cause: h
      });
    }
  },
  async getPool() {
    try {
      const { pool: r } = await n.pool();
      return {
        notBondedTokens: Number.parseInt(r.notBondedTokens, 10),
        bondedTokens: Number.parseInt(r.bondedTokens, 10)
      };
    } catch (r) {
      throw new Error("Failed to fetch pool", {
        cause: r
      });
    }
  },
  async getBlockHeight() {
    try {
      return (await o.status()).syncInfo.latestBlockHeight;
    } catch (r) {
      throw new Error("Failed to fetch block height", {
        cause: r
      });
    }
  }
}), Lu = ({ incentive: n, btcLight: e }) => ({
  /**
   * Gets the available BTC staking rewards from the user's account, broken down by type.
   * Returns separate values for base BTC staking rewards and co-staking bonus rewards.
   * @param address - The Babylon address to query rewards for
   * @returns {Promise<BTCRewards>} - Rewards broken down by type (btcStaker, coStaker)
   */
  async getRewards(t) {
    var o, r, i, h;
    try {
      const p = De.fromPartial({
        address: t
      }), b = await n.RewardGauges(p);
      if (!b || !b.rewardGauges)
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      const O = (o = b.rewardGauges[Je]) == null ? void 0 : o.coins, T = _n(
        (r = b.rewardGauges[Je]) == null ? void 0 : r.withdrawnCoins
      ), v = _n(O) - T, x = (i = b.rewardGauges[Ie]) == null ? void 0 : i.coins, z = _n(
        (h = b.rewardGauges[Ie]) == null ? void 0 : h.withdrawnCoins
      ), d = _n(x) - z;
      return {
        btcStaker: v,
        coStaker: d
      };
    } catch (p) {
      if (p instanceof Error && p.message.includes("reward gauge not found"))
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      throw new Error(`Failed to fetch rewards for ${t}`, {
        cause: p
      });
    }
  },
  async getBTCTipHeight() {
    try {
      const t = Ce.fromPartial({}), { header: o } = await e.Tip(t);
      return Number((o == null ? void 0 : o.height) ?? 0);
    } catch (t) {
      throw new Error("Failed to fetch BTC tip height", {
        cause: t
      });
    }
  }
}), _c = async ({ url: n }) => {
  const e = await Ed.connect(n), t = Od.withExtensions(
    e,
    Ci,
    Ui,
    Hi
  ), o = xd(t), r = new bd(o), i = new Us(o), h = Ci(t).bank, p = Ui(t).staking, b = Hi(t).distribution;
  return {
    baby: Fu({ staking: p, distribution: b, bank: h, tmClient: e }),
    btc: Lu({ incentive: r, btcLight: i })
  };
};
var hs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, $e = {}, rn = {}, Nn = {}, Pn = {}, gs;
function Gu() {
  if (gs) return Pn;
  gs = 1, Object.defineProperty(Pn, "__esModule", { value: !0 }), Pn.utf8Write = Pn.utf8Read = Pn.utf8Length = void 0;
  function n(o) {
    let r = 0, i = 0;
    for (let h = 0; h < o.length; ++h)
      i = o.charCodeAt(h), i < 128 ? r += 1 : i < 2048 ? r += 2 : (i & 64512) === 55296 && (o.charCodeAt(h + 1) & 64512) === 56320 ? (++h, r += 4) : r += 3;
    return r;
  }
  Pn.utf8Length = n;
  function e(o, r, i) {
    if (i - r < 1)
      return "";
    const p = [];
    let b = [], O = 0, T;
    for (; r < i; )
      T = o[r++], T < 128 ? p[O++] = T : T > 191 && T < 224 ? p[O++] = (T & 31) << 6 | o[r++] & 63 : T > 239 && T < 365 ? (T = ((T & 7) << 18 | (o[r++] & 63) << 12 | (o[r++] & 63) << 6 | o[r++] & 63) - 65536, p[O++] = 55296 + (T >> 10), p[O++] = 56320 + (T & 1023)) : p[O++] = (T & 15) << 12 | (o[r++] & 63) << 6 | o[r++] & 63, O > 8191 && ((b || (b = [])).push(String.fromCharCode(...p)), O = 0);
    return b ? (O && b.push(String.fromCharCode(...p.slice(0, O))), b.join("")) : String.fromCharCode(...p.slice(0, O));
  }
  Pn.utf8Read = e;
  function t(o, r, i) {
    const h = i;
    let p, b;
    for (let O = 0; O < o.length; ++O)
      p = o.charCodeAt(O), p < 128 ? r[i++] = p : p < 2048 ? (r[i++] = p >> 6 | 192, r[i++] = p & 63 | 128) : (p & 64512) === 55296 && ((b = o.charCodeAt(O + 1)) & 64512) === 56320 ? (p = 65536 + ((p & 1023) << 10) + (b & 1023), ++O, r[i++] = p >> 18 | 240, r[i++] = p >> 12 & 63 | 128, r[i++] = p >> 6 & 63 | 128, r[i++] = p & 63 | 128) : (r[i++] = p >> 12 | 224, r[i++] = p >> 6 & 63 | 128, r[i++] = p & 63 | 128);
    return i - h;
  }
  return Pn.utf8Write = t, Pn;
}
var E = {}, ps;
function Wu() {
  if (ps) return E;
  ps = 1, Object.defineProperty(E, "__esModule", { value: !0 }), E.writeByte = E.writeFixed32 = E.int64Length = E.writeVarint64 = E.writeVarint32 = E.readInt32 = E.readUInt32 = E.zzDecode = E.zzEncode = E.varint32read = E.varint32write = E.uInt64ToString = E.int64ToString = E.int64FromString = E.varint64write = E.varint64read = void 0;
  function n() {
    let s = 0, l = 0;
    for (let S = 0; S < 28; S += 7) {
      let w = this.buf[this.pos++];
      if (s |= (w & 127) << S, (w & 128) == 0)
        return this.assertBounds(), [s, l];
    }
    let k = this.buf[this.pos++];
    if (s |= (k & 15) << 28, l = (k & 112) >> 4, (k & 128) == 0)
      return this.assertBounds(), [s, l];
    for (let S = 3; S <= 31; S += 7) {
      let w = this.buf[this.pos++];
      if (l |= (w & 127) << S, (w & 128) == 0)
        return this.assertBounds(), [s, l];
    }
    throw new Error("invalid varint");
  }
  E.varint64read = n;
  function e(s, l, k) {
    for (let W = 0; W < 28; W = W + 7) {
      const j = s >>> W, vn = !(!(j >>> 7) && l == 0), on = (vn ? j | 128 : j) & 255;
      if (k.push(on), !vn)
        return;
    }
    const S = s >>> 28 & 15 | (l & 7) << 4, w = l >> 3 != 0;
    if (k.push((w ? S | 128 : S) & 255), !!w) {
      for (let W = 3; W < 31; W = W + 7) {
        const j = l >>> W, vn = !!(j >>> 7), on = (vn ? j | 128 : j) & 255;
        if (k.push(on), !vn)
          return;
      }
      k.push(l >>> 31 & 1);
    }
  }
  E.varint64write = e;
  const t = 4294967296;
  function o(s) {
    const l = s[0] === "-";
    l && (s = s.slice(1));
    const k = 1e6;
    let S = 0, w = 0;
    function W(j, vn) {
      const on = Number(s.slice(j, vn));
      w *= k, S = S * k + on, S >= t && (w = w + (S / t | 0), S = S % t);
    }
    return W(-24, -18), W(-18, -12), W(-12, -6), W(-6), l ? b(S, w) : p(S, w);
  }
  E.int64FromString = o;
  function r(s, l) {
    let k = p(s, l);
    const S = k.hi & 2147483648;
    S && (k = b(k.lo, k.hi));
    const w = i(k.lo, k.hi);
    return S ? "-" + w : w;
  }
  E.int64ToString = r;
  function i(s, l) {
    if ({ lo: s, hi: l } = h(s, l), l <= 2097151)
      return String(t * l + s);
    const k = s & 16777215, S = (s >>> 24 | l << 8) & 16777215, w = l >> 16 & 65535;
    let W = k + S * 6777216 + w * 6710656, j = S + w * 8147497, vn = w * 2;
    const on = 1e7;
    return W >= on && (j += Math.floor(W / on), W %= on), j >= on && (vn += Math.floor(j / on), j %= on), vn.toString() + O(j) + O(W);
  }
  E.uInt64ToString = i;
  function h(s, l) {
    return { lo: s >>> 0, hi: l >>> 0 };
  }
  function p(s, l) {
    return { lo: s | 0, hi: l | 0 };
  }
  function b(s, l) {
    return l = ~l, s ? s = ~s + 1 : l += 1, p(s, l);
  }
  const O = (s) => {
    const l = String(s);
    return "0000000".slice(l.length) + l;
  };
  function T(s, l) {
    if (s >= 0) {
      for (; s > 127; )
        l.push(s & 127 | 128), s = s >>> 7;
      l.push(s);
    } else {
      for (let k = 0; k < 9; k++)
        l.push(s & 127 | 128), s = s >> 7;
      l.push(1);
    }
  }
  E.varint32write = T;
  function m() {
    let s = this.buf[this.pos++], l = s & 127;
    if ((s & 128) == 0)
      return this.assertBounds(), l;
    if (s = this.buf[this.pos++], l |= (s & 127) << 7, (s & 128) == 0)
      return this.assertBounds(), l;
    if (s = this.buf[this.pos++], l |= (s & 127) << 14, (s & 128) == 0)
      return this.assertBounds(), l;
    if (s = this.buf[this.pos++], l |= (s & 127) << 21, (s & 128) == 0)
      return this.assertBounds(), l;
    s = this.buf[this.pos++], l |= (s & 15) << 28;
    for (let k = 5; (s & 128) !== 0 && k < 10; k++)
      s = this.buf[this.pos++];
    if ((s & 128) != 0)
      throw new Error("invalid varint");
    return this.assertBounds(), l >>> 0;
  }
  E.varint32read = m;
  function v(s, l) {
    let k = l >> 31;
    return l = ((l << 1 | s >>> 31) ^ k) >>> 0, s = (s << 1 ^ k) >>> 0, [s, l];
  }
  E.zzEncode = v;
  function x(s, l) {
    let k = -(s & 1);
    return s = ((s >>> 1 | l << 31) ^ k) >>> 0, l = (l >>> 1 ^ k) >>> 0, [s, l];
  }
  E.zzDecode = x;
  function z(s, l) {
    return (s[l] | s[l + 1] << 8 | s[l + 2] << 16) + s[l + 3] * 16777216;
  }
  E.readUInt32 = z;
  function Y(s, l) {
    return (s[l] | s[l + 1] << 8 | s[l + 2] << 16) + (s[l + 3] << 24);
  }
  E.readInt32 = Y;
  function d(s, l, k) {
    for (; s > 127; )
      l[k++] = s & 127 | 128, s >>>= 7;
    l[k] = s;
  }
  E.writeVarint32 = d;
  function u(s, l, k) {
    for (; s.hi; )
      l[k++] = s.lo & 127 | 128, s.lo = (s.lo >>> 7 | s.hi << 25) >>> 0, s.hi >>>= 7;
    for (; s.lo > 127; )
      l[k++] = s.lo & 127 | 128, s.lo = s.lo >>> 7;
    l[k++] = s.lo;
  }
  E.writeVarint64 = u;
  function f(s, l) {
    let k = s, S = (s >>> 28 | l << 4) >>> 0, w = l >>> 24;
    return w === 0 ? S === 0 ? k < 16384 ? k < 128 ? 1 : 2 : k < 2097152 ? 3 : 4 : S < 16384 ? S < 128 ? 5 : 6 : S < 2097152 ? 7 : 8 : w < 128 ? 9 : 10;
  }
  E.int64Length = f;
  function B(s, l, k) {
    l[k] = s & 255, l[k + 1] = s >>> 8 & 255, l[k + 2] = s >>> 16 & 255, l[k + 3] = s >>> 24;
  }
  E.writeFixed32 = B;
  function c(s, l, k) {
    l[k] = s & 255;
  }
  return E.writeByte = c, E;
}
var ms;
function Ji() {
  if (ms) return Nn;
  ms = 1, Object.defineProperty(Nn, "__esModule", { value: !0 }), Nn.BinaryWriter = Nn.BinaryReader = Nn.WireType = void 0;
  const n = Gu(), e = Wu();
  var t;
  (function(T) {
    T[T.Varint = 0] = "Varint", T[T.Fixed64 = 1] = "Fixed64", T[T.Bytes = 2] = "Bytes", T[T.Fixed32 = 5] = "Fixed32";
  })(t || (Nn.WireType = t = {}));
  class o {
    assertBounds() {
      if (this.pos > this.len)
        throw new RangeError("premature EOF");
    }
    constructor(m) {
      this.buf = m ? new Uint8Array(m) : new Uint8Array(0), this.pos = 0, this.type = 0, this.len = this.buf.length;
    }
    tag() {
      const m = this.uint32(), v = m >>> 3, x = m & 7;
      if (v <= 0 || x < 0 || x > 5)
        throw new Error("illegal tag: field no " + v + " wire type " + x);
      return [v, x, m];
    }
    skip(m) {
      if (typeof m == "number") {
        if (this.pos + m > this.len)
          throw O(this, m);
        this.pos += m;
      } else
        do
          if (this.pos >= this.len)
            throw O(this);
        while (this.buf[this.pos++] & 128);
      return this;
    }
    skipType(m) {
      switch (m) {
        case t.Varint:
          this.skip();
          break;
        case t.Fixed64:
          this.skip(8);
          break;
        case t.Bytes:
          this.skip(this.uint32());
          break;
        case 3:
          for (; (m = this.uint32() & 7) !== 4; )
            this.skipType(m);
          break;
        case t.Fixed32:
          this.skip(4);
          break;
        /* istanbul ignore next */
        default:
          throw Error("invalid wire type " + m + " at offset " + this.pos);
      }
      return this;
    }
    uint32() {
      return e.varint32read.bind(this)();
    }
    int32() {
      return this.uint32() | 0;
    }
    sint32() {
      const m = this.uint32();
      return m % 2 === 1 ? (m + 1) / -2 : m / 2;
    }
    fixed32() {
      const m = (0, e.readUInt32)(this.buf, this.pos);
      return this.pos += 4, m;
    }
    sfixed32() {
      const m = (0, e.readInt32)(this.buf, this.pos);
      return this.pos += 4, m;
    }
    int64() {
      const [m, v] = e.varint64read.bind(this)();
      return BigInt((0, e.int64ToString)(m, v));
    }
    uint64() {
      const [m, v] = e.varint64read.bind(this)();
      return BigInt((0, e.uInt64ToString)(m, v));
    }
    sint64() {
      let [m, v] = e.varint64read.bind(this)();
      return [m, v] = (0, e.zzDecode)(m, v), BigInt((0, e.int64ToString)(m, v));
    }
    fixed64() {
      const m = this.sfixed32(), v = this.sfixed32();
      return BigInt((0, e.uInt64ToString)(m, v));
    }
    sfixed64() {
      const m = this.sfixed32(), v = this.sfixed32();
      return BigInt((0, e.int64ToString)(m, v));
    }
    float() {
      throw new Error("float not supported");
    }
    double() {
      throw new Error("double not supported");
    }
    bool() {
      const [m, v] = e.varint64read.bind(this)();
      return m !== 0 || v !== 0;
    }
    bytes() {
      const m = this.uint32(), v = this.pos;
      return this.pos += m, this.assertBounds(), this.buf.subarray(v, v + m);
    }
    string() {
      const m = this.bytes();
      return (0, n.utf8Read)(m, 0, m.length);
    }
  }
  Nn.BinaryReader = o;
  class r {
    constructor(m, v, x) {
      this.fn = m, this.len = v, this.val = x;
    }
    proceed(m, v) {
      this.fn && this.fn(this.val, m, v);
    }
  }
  class i {
    constructor(m) {
      this.head = m.head, this.tail = m.tail, this.len = m.len, this.next = m.states;
    }
  }
  class h {
    constructor() {
      this.len = 0, this.uint64 = h.prototype.int64, this.sfixed64 = h.prototype.fixed64, this.sfixed32 = h.prototype.fixed32, this.head = new r(null, 0, 0), this.tail = this.head, this.states = null;
    }
    static create() {
      return new h();
    }
    static alloc(m) {
      return typeof Uint8Array < "u" ? b((v) => new Uint8Array(v), Uint8Array.prototype.subarray)(m) : new Array(m);
    }
    _push(m, v, x) {
      return this.tail = this.tail.next = new r(m, v, x), this.len += v, this;
    }
    finish() {
      let m = this.head.next, v = 0;
      const x = h.alloc(this.len);
      for (; m; )
        m.proceed(x, v), v += m.len, m = m.next;
      return x;
    }
    fork() {
      return this.states = new i(this), this.head = this.tail = new r(null, 0, 0), this.len = 0, this;
    }
    reset() {
      return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new r(null, 0, 0), this.len = 0), this;
    }
    ldelim() {
      const m = this.head, v = this.tail, x = this.len;
      return this.reset().uint32(x), x && (this.tail.next = m.next, this.tail = v, this.len += x), this;
    }
    tag(m, v) {
      return this.uint32((m << 3 | v) >>> 0);
    }
    uint32(m) {
      return this.len += (this.tail = this.tail.next = new r(e.writeVarint32, (m = m >>> 0) < 128 ? 1 : m < 16384 ? 2 : m < 2097152 ? 3 : m < 268435456 ? 4 : 5, m)).len, this;
    }
    int32(m) {
      return m < 0 ? this._push(e.writeVarint64, 10, (0, e.int64FromString)(m.toString())) : this.uint32(m);
    }
    sint32(m) {
      return this.uint32((m << 1 ^ m >> 31) >>> 0);
    }
    int64(m) {
      const { lo: v, hi: x } = (0, e.int64FromString)(m.toString());
      return this._push(e.writeVarint64, (0, e.int64Length)(v, x), { lo: v, hi: x });
    }
    sint64(m) {
      let { lo: v, hi: x } = (0, e.int64FromString)(m.toString());
      return [v, x] = (0, e.zzEncode)(v, x), this._push(e.writeVarint64, (0, e.int64Length)(v, x), { lo: v, hi: x });
    }
    fixed64(m) {
      const { lo: v, hi: x } = (0, e.int64FromString)(m.toString());
      return this._push(e.writeFixed32, 4, v)._push(e.writeFixed32, 4, x);
    }
    bool(m) {
      return this._push(e.writeByte, 1, m ? 1 : 0);
    }
    fixed32(m) {
      return this._push(e.writeFixed32, 4, m >>> 0);
    }
    float(m) {
      throw new Error("float not supported" + m);
    }
    double(m) {
      throw new Error("double not supported" + m);
    }
    bytes(m) {
      const v = m.length >>> 0;
      return v ? this.uint32(v)._push(p, v, m) : this._push(e.writeByte, 1, 0);
    }
    string(m) {
      const v = (0, n.utf8Length)(m);
      return v ? this.uint32(v)._push(n.utf8Write, v, m) : this._push(e.writeByte, 1, 0);
    }
  }
  Nn.BinaryWriter = h;
  function p(T, m, v) {
    if (typeof Uint8Array < "u")
      m.set(T, v);
    else
      for (let x = 0; x < T.length; ++x)
        m[v + x] = T[x];
  }
  function b(T, m, v) {
    let Y = null, d = 8192;
    return function(f) {
      if (f < 1 || f > 4096)
        return T(f);
      d + f > 8192 && (Y = T(8192), d = 0);
      const B = m.call(Y, d, d += f);
      return d & 7 && (d = (d | 7) + 1), B;
    };
  }
  function O(T, m) {
    return RangeError("index out of range: " + T.pos + " + " + (m || 1) + " > " + T.len);
  }
  return Nn;
}
var D = {}, ks;
function Ii() {
  if (ks) return D;
  ks = 1, Object.defineProperty(D, "__esModule", { value: !0 }), D.fromJsonTimestamp = D.fromTimestamp = D.toTimestamp = D.isRpc = D.setPaginationParams = D.isObject = D.isSet = D.fromDuration = D.toDuration = D.omitDefault = D.base64FromBytes = D.bytesFromBase64 = void 0;
  var n = (() => {
    if (typeof n < "u")
      return n;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof hs < "u")
      return hs;
    throw "Unable to locate global object";
  })();
  const e = n.atob || ((u) => n.Buffer.from(u, "base64").toString("binary"));
  function t(u) {
    const f = e(u), B = new Uint8Array(f.length);
    for (let c = 0; c < f.length; ++c)
      B[c] = f.charCodeAt(c);
    return B;
  }
  D.bytesFromBase64 = t;
  const o = n.btoa || ((u) => n.Buffer.from(u, "binary").toString("base64"));
  function r(u) {
    const f = [];
    return u.forEach((B) => {
      f.push(String.fromCharCode(B));
    }), o(f.join(""));
  }
  D.base64FromBytes = r;
  function i(u) {
    if (typeof u == "string")
      return u === "" ? void 0 : u;
    if (typeof u == "number")
      return u === 0 ? void 0 : u;
    if (typeof u == "boolean")
      return u === !1 ? void 0 : u;
    if (typeof u == "bigint")
      return u === BigInt(0) ? void 0 : u;
    throw new Error(`Got unsupported type ${typeof u}`);
  }
  D.omitDefault = i;
  function h(u) {
    return {
      seconds: BigInt(Math.floor(parseInt(u) / 1e9)),
      nanos: parseInt(u) % 1e9
    };
  }
  D.toDuration = h;
  function p(u) {
    return (parseInt(u.seconds.toString()) * 1e9 + u.nanos).toString();
  }
  D.fromDuration = p;
  function b(u) {
    return u != null;
  }
  D.isSet = b;
  function O(u) {
    return typeof u == "object" && u !== null;
  }
  D.isObject = O;
  const T = (u, f) => (f && (typeof (f == null ? void 0 : f.countTotal) < "u" && (u.params["pagination.count_total"] = f.countTotal), typeof (f == null ? void 0 : f.key) < "u" && (u.params["pagination.key"] = Buffer.from(f.key).toString("base64")), typeof (f == null ? void 0 : f.limit) < "u" && (u.params["pagination.limit"] = f.limit.toString()), typeof (f == null ? void 0 : f.offset) < "u" && (u.params["pagination.offset"] = f.offset.toString()), typeof (f == null ? void 0 : f.reverse) < "u" && (u.params["pagination.reverse"] = f.reverse)), u);
  D.setPaginationParams = T;
  function m(u) {
    return u != null && typeof u.request == "function";
  }
  D.isRpc = m;
  function v(u) {
    const f = d(u.getTime() / 1e3), B = u.getTime() % 1e3 * 1e6;
    return {
      seconds: f,
      nanos: B
    };
  }
  D.toTimestamp = v;
  function x(u) {
    let f = Number(u.seconds) * 1e3;
    return f += u.nanos / 1e6, new Date(f);
  }
  D.fromTimestamp = x;
  const z = (u) => ({
    seconds: b(u.seconds) ? BigInt(u.seconds.toString()) : BigInt(0),
    nanos: b(u.nanos) ? Number(u.nanos) : 0
  });
  function Y(u) {
    return u instanceof Date ? v(u) : typeof u == "string" ? v(new Date(u)) : z(u);
  }
  D.fromJsonTimestamp = Y;
  function d(u) {
    return BigInt(Math.trunc(u));
  }
  return D;
}
var Ss;
function yd() {
  if (Ss) return rn;
  Ss = 1, Object.defineProperty(rn, "__esModule", { value: !0 }), rn.DecProto = rn.IntProto = rn.DecCoin = rn.Coin = rn.protobufPackage = void 0;
  const n = Ji(), e = Ii();
  rn.protobufPackage = "cosmos.base.v1beta1";
  function t() {
    return {
      denom: "",
      amount: ""
    };
  }
  rn.Coin = {
    typeUrl: "/cosmos.base.v1beta1.Coin",
    encode(h, p = n.BinaryWriter.create()) {
      return h.denom !== "" && p.uint32(10).string(h.denom), h.amount !== "" && p.uint32(18).string(h.amount), p;
    },
    decode(h, p) {
      const b = h instanceof n.BinaryReader ? h : new n.BinaryReader(h);
      let O = p === void 0 ? b.len : b.pos + p;
      const T = t();
      for (; b.pos < O; ) {
        const m = b.uint32();
        switch (m >>> 3) {
          case 1:
            T.denom = b.string();
            break;
          case 2:
            T.amount = b.string();
            break;
          default:
            b.skipType(m & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(h) {
      const p = t();
      return (0, e.isSet)(h.denom) && (p.denom = String(h.denom)), (0, e.isSet)(h.amount) && (p.amount = String(h.amount)), p;
    },
    toJSON(h) {
      const p = {};
      return h.denom !== void 0 && (p.denom = h.denom), h.amount !== void 0 && (p.amount = h.amount), p;
    },
    fromPartial(h) {
      const p = t();
      return p.denom = h.denom ?? "", p.amount = h.amount ?? "", p;
    }
  };
  function o() {
    return {
      denom: "",
      amount: ""
    };
  }
  rn.DecCoin = {
    typeUrl: "/cosmos.base.v1beta1.DecCoin",
    encode(h, p = n.BinaryWriter.create()) {
      return h.denom !== "" && p.uint32(10).string(h.denom), h.amount !== "" && p.uint32(18).string(h.amount), p;
    },
    decode(h, p) {
      const b = h instanceof n.BinaryReader ? h : new n.BinaryReader(h);
      let O = p === void 0 ? b.len : b.pos + p;
      const T = o();
      for (; b.pos < O; ) {
        const m = b.uint32();
        switch (m >>> 3) {
          case 1:
            T.denom = b.string();
            break;
          case 2:
            T.amount = b.string();
            break;
          default:
            b.skipType(m & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(h) {
      const p = o();
      return (0, e.isSet)(h.denom) && (p.denom = String(h.denom)), (0, e.isSet)(h.amount) && (p.amount = String(h.amount)), p;
    },
    toJSON(h) {
      const p = {};
      return h.denom !== void 0 && (p.denom = h.denom), h.amount !== void 0 && (p.amount = h.amount), p;
    },
    fromPartial(h) {
      const p = o();
      return p.denom = h.denom ?? "", p.amount = h.amount ?? "", p;
    }
  };
  function r() {
    return {
      int: ""
    };
  }
  rn.IntProto = {
    typeUrl: "/cosmos.base.v1beta1.IntProto",
    encode(h, p = n.BinaryWriter.create()) {
      return h.int !== "" && p.uint32(10).string(h.int), p;
    },
    decode(h, p) {
      const b = h instanceof n.BinaryReader ? h : new n.BinaryReader(h);
      let O = p === void 0 ? b.len : b.pos + p;
      const T = r();
      for (; b.pos < O; ) {
        const m = b.uint32();
        switch (m >>> 3) {
          case 1:
            T.int = b.string();
            break;
          default:
            b.skipType(m & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(h) {
      const p = r();
      return (0, e.isSet)(h.int) && (p.int = String(h.int)), p;
    },
    toJSON(h) {
      const p = {};
      return h.int !== void 0 && (p.int = h.int), p;
    },
    fromPartial(h) {
      const p = r();
      return p.int = h.int ?? "", p;
    }
  };
  function i() {
    return {
      dec: ""
    };
  }
  return rn.DecProto = {
    typeUrl: "/cosmos.base.v1beta1.DecProto",
    encode(h, p = n.BinaryWriter.create()) {
      return h.dec !== "" && p.uint32(10).string(h.dec), p;
    },
    decode(h, p) {
      const b = h instanceof n.BinaryReader ? h : new n.BinaryReader(h);
      let O = p === void 0 ? b.len : b.pos + p;
      const T = i();
      for (; b.pos < O; ) {
        const m = b.uint32();
        switch (m >>> 3) {
          case 1:
            T.dec = b.string();
            break;
          default:
            b.skipType(m & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(h) {
      const p = i();
      return (0, e.isSet)(h.dec) && (p.dec = String(h.dec)), p;
    },
    toJSON(h) {
      const p = {};
      return h.dec !== void 0 && (p.dec = h.dec), p;
    },
    fromPartial(h) {
      const p = i();
      return p.dec = h.dec ?? "", p;
    }
  }, rn;
}
var Qe = {}, bs;
function $u() {
  return bs || (bs = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CommunityPoolSpendProposalWithDeposit = n.DelegationDelegatorReward = n.DelegatorStartingInfo = n.CommunityPoolSpendProposal = n.FeePool = n.ValidatorSlashEvents = n.ValidatorSlashEvent = n.ValidatorOutstandingRewards = n.ValidatorAccumulatedCommission = n.ValidatorCurrentRewards = n.ValidatorHistoricalRewards = n.Params = n.protobufPackage = void 0;
    const e = yd(), t = Ji(), o = Ii();
    n.protobufPackage = "cosmos.distribution.v1beta1";
    function r() {
      return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: !1
      };
    }
    n.Params = {
      typeUrl: "/cosmos.distribution.v1beta1.Params",
      encode(d, u = t.BinaryWriter.create()) {
        return d.communityTax !== "" && u.uint32(10).string(d.communityTax), d.baseProposerReward !== "" && u.uint32(18).string(d.baseProposerReward), d.bonusProposerReward !== "" && u.uint32(26).string(d.bonusProposerReward), d.withdrawAddrEnabled === !0 && u.uint32(32).bool(d.withdrawAddrEnabled), u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = r();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.communityTax = f.string();
              break;
            case 2:
              c.baseProposerReward = f.string();
              break;
            case 3:
              c.bonusProposerReward = f.string();
              break;
            case 4:
              c.withdrawAddrEnabled = f.bool();
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = r();
        return (0, o.isSet)(d.communityTax) && (u.communityTax = String(d.communityTax)), (0, o.isSet)(d.baseProposerReward) && (u.baseProposerReward = String(d.baseProposerReward)), (0, o.isSet)(d.bonusProposerReward) && (u.bonusProposerReward = String(d.bonusProposerReward)), (0, o.isSet)(d.withdrawAddrEnabled) && (u.withdrawAddrEnabled = !!d.withdrawAddrEnabled), u;
      },
      toJSON(d) {
        const u = {};
        return d.communityTax !== void 0 && (u.communityTax = d.communityTax), d.baseProposerReward !== void 0 && (u.baseProposerReward = d.baseProposerReward), d.bonusProposerReward !== void 0 && (u.bonusProposerReward = d.bonusProposerReward), d.withdrawAddrEnabled !== void 0 && (u.withdrawAddrEnabled = d.withdrawAddrEnabled), u;
      },
      fromPartial(d) {
        const u = r();
        return u.communityTax = d.communityTax ?? "", u.baseProposerReward = d.baseProposerReward ?? "", u.bonusProposerReward = d.bonusProposerReward ?? "", u.withdrawAddrEnabled = d.withdrawAddrEnabled ?? !1, u;
      }
    };
    function i() {
      return {
        cumulativeRewardRatio: [],
        referenceCount: 0
      };
    }
    n.ValidatorHistoricalRewards = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",
      encode(d, u = t.BinaryWriter.create()) {
        for (const f of d.cumulativeRewardRatio)
          e.DecCoin.encode(f, u.uint32(10).fork()).ldelim();
        return d.referenceCount !== 0 && u.uint32(16).uint32(d.referenceCount), u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = i();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.cumulativeRewardRatio.push(e.DecCoin.decode(f, f.uint32()));
              break;
            case 2:
              c.referenceCount = f.uint32();
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = i();
        return Array.isArray(d == null ? void 0 : d.cumulativeRewardRatio) && (u.cumulativeRewardRatio = d.cumulativeRewardRatio.map((f) => e.DecCoin.fromJSON(f))), (0, o.isSet)(d.referenceCount) && (u.referenceCount = Number(d.referenceCount)), u;
      },
      toJSON(d) {
        const u = {};
        return d.cumulativeRewardRatio ? u.cumulativeRewardRatio = d.cumulativeRewardRatio.map((f) => f ? e.DecCoin.toJSON(f) : void 0) : u.cumulativeRewardRatio = [], d.referenceCount !== void 0 && (u.referenceCount = Math.round(d.referenceCount)), u;
      },
      fromPartial(d) {
        var f;
        const u = i();
        return u.cumulativeRewardRatio = ((f = d.cumulativeRewardRatio) == null ? void 0 : f.map((B) => e.DecCoin.fromPartial(B))) || [], u.referenceCount = d.referenceCount ?? 0, u;
      }
    };
    function h() {
      return {
        rewards: [],
        period: BigInt(0)
      };
    }
    n.ValidatorCurrentRewards = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",
      encode(d, u = t.BinaryWriter.create()) {
        for (const f of d.rewards)
          e.DecCoin.encode(f, u.uint32(10).fork()).ldelim();
        return d.period !== BigInt(0) && u.uint32(16).uint64(d.period), u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = h();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.rewards.push(e.DecCoin.decode(f, f.uint32()));
              break;
            case 2:
              c.period = f.uint64();
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = h();
        return Array.isArray(d == null ? void 0 : d.rewards) && (u.rewards = d.rewards.map((f) => e.DecCoin.fromJSON(f))), (0, o.isSet)(d.period) && (u.period = BigInt(d.period.toString())), u;
      },
      toJSON(d) {
        const u = {};
        return d.rewards ? u.rewards = d.rewards.map((f) => f ? e.DecCoin.toJSON(f) : void 0) : u.rewards = [], d.period !== void 0 && (u.period = (d.period || BigInt(0)).toString()), u;
      },
      fromPartial(d) {
        var f;
        const u = h();
        return u.rewards = ((f = d.rewards) == null ? void 0 : f.map((B) => e.DecCoin.fromPartial(B))) || [], d.period !== void 0 && d.period !== null && (u.period = BigInt(d.period.toString())), u;
      }
    };
    function p() {
      return {
        commission: []
      };
    }
    n.ValidatorAccumulatedCommission = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",
      encode(d, u = t.BinaryWriter.create()) {
        for (const f of d.commission)
          e.DecCoin.encode(f, u.uint32(10).fork()).ldelim();
        return u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = p();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.commission.push(e.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = p();
        return Array.isArray(d == null ? void 0 : d.commission) && (u.commission = d.commission.map((f) => e.DecCoin.fromJSON(f))), u;
      },
      toJSON(d) {
        const u = {};
        return d.commission ? u.commission = d.commission.map((f) => f ? e.DecCoin.toJSON(f) : void 0) : u.commission = [], u;
      },
      fromPartial(d) {
        var f;
        const u = p();
        return u.commission = ((f = d.commission) == null ? void 0 : f.map((B) => e.DecCoin.fromPartial(B))) || [], u;
      }
    };
    function b() {
      return {
        rewards: []
      };
    }
    n.ValidatorOutstandingRewards = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",
      encode(d, u = t.BinaryWriter.create()) {
        for (const f of d.rewards)
          e.DecCoin.encode(f, u.uint32(10).fork()).ldelim();
        return u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = b();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.rewards.push(e.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = b();
        return Array.isArray(d == null ? void 0 : d.rewards) && (u.rewards = d.rewards.map((f) => e.DecCoin.fromJSON(f))), u;
      },
      toJSON(d) {
        const u = {};
        return d.rewards ? u.rewards = d.rewards.map((f) => f ? e.DecCoin.toJSON(f) : void 0) : u.rewards = [], u;
      },
      fromPartial(d) {
        var f;
        const u = b();
        return u.rewards = ((f = d.rewards) == null ? void 0 : f.map((B) => e.DecCoin.fromPartial(B))) || [], u;
      }
    };
    function O() {
      return {
        validatorPeriod: BigInt(0),
        fraction: ""
      };
    }
    n.ValidatorSlashEvent = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",
      encode(d, u = t.BinaryWriter.create()) {
        return d.validatorPeriod !== BigInt(0) && u.uint32(8).uint64(d.validatorPeriod), d.fraction !== "" && u.uint32(18).string(d.fraction), u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = O();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.validatorPeriod = f.uint64();
              break;
            case 2:
              c.fraction = f.string();
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = O();
        return (0, o.isSet)(d.validatorPeriod) && (u.validatorPeriod = BigInt(d.validatorPeriod.toString())), (0, o.isSet)(d.fraction) && (u.fraction = String(d.fraction)), u;
      },
      toJSON(d) {
        const u = {};
        return d.validatorPeriod !== void 0 && (u.validatorPeriod = (d.validatorPeriod || BigInt(0)).toString()), d.fraction !== void 0 && (u.fraction = d.fraction), u;
      },
      fromPartial(d) {
        const u = O();
        return d.validatorPeriod !== void 0 && d.validatorPeriod !== null && (u.validatorPeriod = BigInt(d.validatorPeriod.toString())), u.fraction = d.fraction ?? "", u;
      }
    };
    function T() {
      return {
        validatorSlashEvents: []
      };
    }
    n.ValidatorSlashEvents = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",
      encode(d, u = t.BinaryWriter.create()) {
        for (const f of d.validatorSlashEvents)
          n.ValidatorSlashEvent.encode(f, u.uint32(10).fork()).ldelim();
        return u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = T();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.validatorSlashEvents.push(n.ValidatorSlashEvent.decode(f, f.uint32()));
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = T();
        return Array.isArray(d == null ? void 0 : d.validatorSlashEvents) && (u.validatorSlashEvents = d.validatorSlashEvents.map((f) => n.ValidatorSlashEvent.fromJSON(f))), u;
      },
      toJSON(d) {
        const u = {};
        return d.validatorSlashEvents ? u.validatorSlashEvents = d.validatorSlashEvents.map((f) => f ? n.ValidatorSlashEvent.toJSON(f) : void 0) : u.validatorSlashEvents = [], u;
      },
      fromPartial(d) {
        var f;
        const u = T();
        return u.validatorSlashEvents = ((f = d.validatorSlashEvents) == null ? void 0 : f.map((B) => n.ValidatorSlashEvent.fromPartial(B))) || [], u;
      }
    };
    function m() {
      return {
        communityPool: []
      };
    }
    n.FeePool = {
      typeUrl: "/cosmos.distribution.v1beta1.FeePool",
      encode(d, u = t.BinaryWriter.create()) {
        for (const f of d.communityPool)
          e.DecCoin.encode(f, u.uint32(10).fork()).ldelim();
        return u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = m();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.communityPool.push(e.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = m();
        return Array.isArray(d == null ? void 0 : d.communityPool) && (u.communityPool = d.communityPool.map((f) => e.DecCoin.fromJSON(f))), u;
      },
      toJSON(d) {
        const u = {};
        return d.communityPool ? u.communityPool = d.communityPool.map((f) => f ? e.DecCoin.toJSON(f) : void 0) : u.communityPool = [], u;
      },
      fromPartial(d) {
        var f;
        const u = m();
        return u.communityPool = ((f = d.communityPool) == null ? void 0 : f.map((B) => e.DecCoin.fromPartial(B))) || [], u;
      }
    };
    function v() {
      return {
        title: "",
        description: "",
        recipient: "",
        amount: []
      };
    }
    n.CommunityPoolSpendProposal = {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
      encode(d, u = t.BinaryWriter.create()) {
        d.title !== "" && u.uint32(10).string(d.title), d.description !== "" && u.uint32(18).string(d.description), d.recipient !== "" && u.uint32(26).string(d.recipient);
        for (const f of d.amount)
          e.Coin.encode(f, u.uint32(34).fork()).ldelim();
        return u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = v();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.title = f.string();
              break;
            case 2:
              c.description = f.string();
              break;
            case 3:
              c.recipient = f.string();
              break;
            case 4:
              c.amount.push(e.Coin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = v();
        return (0, o.isSet)(d.title) && (u.title = String(d.title)), (0, o.isSet)(d.description) && (u.description = String(d.description)), (0, o.isSet)(d.recipient) && (u.recipient = String(d.recipient)), Array.isArray(d == null ? void 0 : d.amount) && (u.amount = d.amount.map((f) => e.Coin.fromJSON(f))), u;
      },
      toJSON(d) {
        const u = {};
        return d.title !== void 0 && (u.title = d.title), d.description !== void 0 && (u.description = d.description), d.recipient !== void 0 && (u.recipient = d.recipient), d.amount ? u.amount = d.amount.map((f) => f ? e.Coin.toJSON(f) : void 0) : u.amount = [], u;
      },
      fromPartial(d) {
        var f;
        const u = v();
        return u.title = d.title ?? "", u.description = d.description ?? "", u.recipient = d.recipient ?? "", u.amount = ((f = d.amount) == null ? void 0 : f.map((B) => e.Coin.fromPartial(B))) || [], u;
      }
    };
    function x() {
      return {
        previousPeriod: BigInt(0),
        stake: "",
        height: BigInt(0)
      };
    }
    n.DelegatorStartingInfo = {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",
      encode(d, u = t.BinaryWriter.create()) {
        return d.previousPeriod !== BigInt(0) && u.uint32(8).uint64(d.previousPeriod), d.stake !== "" && u.uint32(18).string(d.stake), d.height !== BigInt(0) && u.uint32(24).uint64(d.height), u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = x();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.previousPeriod = f.uint64();
              break;
            case 2:
              c.stake = f.string();
              break;
            case 3:
              c.height = f.uint64();
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = x();
        return (0, o.isSet)(d.previousPeriod) && (u.previousPeriod = BigInt(d.previousPeriod.toString())), (0, o.isSet)(d.stake) && (u.stake = String(d.stake)), (0, o.isSet)(d.height) && (u.height = BigInt(d.height.toString())), u;
      },
      toJSON(d) {
        const u = {};
        return d.previousPeriod !== void 0 && (u.previousPeriod = (d.previousPeriod || BigInt(0)).toString()), d.stake !== void 0 && (u.stake = d.stake), d.height !== void 0 && (u.height = (d.height || BigInt(0)).toString()), u;
      },
      fromPartial(d) {
        const u = x();
        return d.previousPeriod !== void 0 && d.previousPeriod !== null && (u.previousPeriod = BigInt(d.previousPeriod.toString())), u.stake = d.stake ?? "", d.height !== void 0 && d.height !== null && (u.height = BigInt(d.height.toString())), u;
      }
    };
    function z() {
      return {
        validatorAddress: "",
        reward: []
      };
    }
    n.DelegationDelegatorReward = {
      typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",
      encode(d, u = t.BinaryWriter.create()) {
        d.validatorAddress !== "" && u.uint32(10).string(d.validatorAddress);
        for (const f of d.reward)
          e.DecCoin.encode(f, u.uint32(18).fork()).ldelim();
        return u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = z();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.validatorAddress = f.string();
              break;
            case 2:
              c.reward.push(e.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = z();
        return (0, o.isSet)(d.validatorAddress) && (u.validatorAddress = String(d.validatorAddress)), Array.isArray(d == null ? void 0 : d.reward) && (u.reward = d.reward.map((f) => e.DecCoin.fromJSON(f))), u;
      },
      toJSON(d) {
        const u = {};
        return d.validatorAddress !== void 0 && (u.validatorAddress = d.validatorAddress), d.reward ? u.reward = d.reward.map((f) => f ? e.DecCoin.toJSON(f) : void 0) : u.reward = [], u;
      },
      fromPartial(d) {
        var f;
        const u = z();
        return u.validatorAddress = d.validatorAddress ?? "", u.reward = ((f = d.reward) == null ? void 0 : f.map((B) => e.DecCoin.fromPartial(B))) || [], u;
      }
    };
    function Y() {
      return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: ""
      };
    }
    n.CommunityPoolSpendProposalWithDeposit = {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",
      encode(d, u = t.BinaryWriter.create()) {
        return d.title !== "" && u.uint32(10).string(d.title), d.description !== "" && u.uint32(18).string(d.description), d.recipient !== "" && u.uint32(26).string(d.recipient), d.amount !== "" && u.uint32(34).string(d.amount), d.deposit !== "" && u.uint32(42).string(d.deposit), u;
      },
      decode(d, u) {
        const f = d instanceof t.BinaryReader ? d : new t.BinaryReader(d);
        let B = u === void 0 ? f.len : f.pos + u;
        const c = Y();
        for (; f.pos < B; ) {
          const s = f.uint32();
          switch (s >>> 3) {
            case 1:
              c.title = f.string();
              break;
            case 2:
              c.description = f.string();
              break;
            case 3:
              c.recipient = f.string();
              break;
            case 4:
              c.amount = f.string();
              break;
            case 5:
              c.deposit = f.string();
              break;
            default:
              f.skipType(s & 7);
              break;
          }
        }
        return c;
      },
      fromJSON(d) {
        const u = Y();
        return (0, o.isSet)(d.title) && (u.title = String(d.title)), (0, o.isSet)(d.description) && (u.description = String(d.description)), (0, o.isSet)(d.recipient) && (u.recipient = String(d.recipient)), (0, o.isSet)(d.amount) && (u.amount = String(d.amount)), (0, o.isSet)(d.deposit) && (u.deposit = String(d.deposit)), u;
      },
      toJSON(d) {
        const u = {};
        return d.title !== void 0 && (u.title = d.title), d.description !== void 0 && (u.description = d.description), d.recipient !== void 0 && (u.recipient = d.recipient), d.amount !== void 0 && (u.amount = d.amount), d.deposit !== void 0 && (u.deposit = d.deposit), u;
      },
      fromPartial(d) {
        const u = Y();
        return u.title = d.title ?? "", u.description = d.description ?? "", u.recipient = d.recipient ?? "", u.amount = d.amount ?? "", u.deposit = d.deposit ?? "", u;
      }
    };
  }(Qe)), Qe;
}
var vs;
function Qu() {
  return vs || (vs = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.MsgClientImpl = n.MsgDepositValidatorRewardsPoolResponse = n.MsgDepositValidatorRewardsPool = n.MsgCommunityPoolSpendResponse = n.MsgCommunityPoolSpend = n.MsgUpdateParamsResponse = n.MsgUpdateParams = n.MsgFundCommunityPoolResponse = n.MsgFundCommunityPool = n.MsgWithdrawValidatorCommissionResponse = n.MsgWithdrawValidatorCommission = n.MsgWithdrawDelegatorRewardResponse = n.MsgWithdrawDelegatorReward = n.MsgSetWithdrawAddressResponse = n.MsgSetWithdrawAddress = n.protobufPackage = void 0;
    const e = yd(), t = $u(), o = Ji(), r = Ii();
    n.protobufPackage = "cosmos.distribution.v1beta1";
    function i() {
      return {
        delegatorAddress: "",
        withdrawAddress: ""
      };
    }
    n.MsgSetWithdrawAddress = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
      encode(c, s = o.BinaryWriter.create()) {
        return c.delegatorAddress !== "" && s.uint32(10).string(c.delegatorAddress), c.withdrawAddress !== "" && s.uint32(18).string(c.withdrawAddress), s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = i();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.delegatorAddress = l.string();
              break;
            case 2:
              S.withdrawAddress = l.string();
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = i();
        return (0, r.isSet)(c.delegatorAddress) && (s.delegatorAddress = String(c.delegatorAddress)), (0, r.isSet)(c.withdrawAddress) && (s.withdrawAddress = String(c.withdrawAddress)), s;
      },
      toJSON(c) {
        const s = {};
        return c.delegatorAddress !== void 0 && (s.delegatorAddress = c.delegatorAddress), c.withdrawAddress !== void 0 && (s.withdrawAddress = c.withdrawAddress), s;
      },
      fromPartial(c) {
        const s = i();
        return s.delegatorAddress = c.delegatorAddress ?? "", s.withdrawAddress = c.withdrawAddress ?? "", s;
      }
    };
    function h() {
      return {};
    }
    n.MsgSetWithdrawAddressResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",
      encode(c, s = o.BinaryWriter.create()) {
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = h();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        return h();
      },
      toJSON(c) {
        return {};
      },
      fromPartial(c) {
        return h();
      }
    };
    function p() {
      return {
        delegatorAddress: "",
        validatorAddress: ""
      };
    }
    n.MsgWithdrawDelegatorReward = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      encode(c, s = o.BinaryWriter.create()) {
        return c.delegatorAddress !== "" && s.uint32(10).string(c.delegatorAddress), c.validatorAddress !== "" && s.uint32(18).string(c.validatorAddress), s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = p();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.delegatorAddress = l.string();
              break;
            case 2:
              S.validatorAddress = l.string();
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = p();
        return (0, r.isSet)(c.delegatorAddress) && (s.delegatorAddress = String(c.delegatorAddress)), (0, r.isSet)(c.validatorAddress) && (s.validatorAddress = String(c.validatorAddress)), s;
      },
      toJSON(c) {
        const s = {};
        return c.delegatorAddress !== void 0 && (s.delegatorAddress = c.delegatorAddress), c.validatorAddress !== void 0 && (s.validatorAddress = c.validatorAddress), s;
      },
      fromPartial(c) {
        const s = p();
        return s.delegatorAddress = c.delegatorAddress ?? "", s.validatorAddress = c.validatorAddress ?? "", s;
      }
    };
    function b() {
      return {
        amount: []
      };
    }
    n.MsgWithdrawDelegatorRewardResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",
      encode(c, s = o.BinaryWriter.create()) {
        for (const l of c.amount)
          e.Coin.encode(l, s.uint32(10).fork()).ldelim();
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = b();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.amount.push(e.Coin.decode(l, l.uint32()));
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = b();
        return Array.isArray(c == null ? void 0 : c.amount) && (s.amount = c.amount.map((l) => e.Coin.fromJSON(l))), s;
      },
      toJSON(c) {
        const s = {};
        return c.amount ? s.amount = c.amount.map((l) => l ? e.Coin.toJSON(l) : void 0) : s.amount = [], s;
      },
      fromPartial(c) {
        var l;
        const s = b();
        return s.amount = ((l = c.amount) == null ? void 0 : l.map((k) => e.Coin.fromPartial(k))) || [], s;
      }
    };
    function O() {
      return {
        validatorAddress: ""
      };
    }
    n.MsgWithdrawValidatorCommission = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
      encode(c, s = o.BinaryWriter.create()) {
        return c.validatorAddress !== "" && s.uint32(10).string(c.validatorAddress), s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = O();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.validatorAddress = l.string();
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = O();
        return (0, r.isSet)(c.validatorAddress) && (s.validatorAddress = String(c.validatorAddress)), s;
      },
      toJSON(c) {
        const s = {};
        return c.validatorAddress !== void 0 && (s.validatorAddress = c.validatorAddress), s;
      },
      fromPartial(c) {
        const s = O();
        return s.validatorAddress = c.validatorAddress ?? "", s;
      }
    };
    function T() {
      return {
        amount: []
      };
    }
    n.MsgWithdrawValidatorCommissionResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",
      encode(c, s = o.BinaryWriter.create()) {
        for (const l of c.amount)
          e.Coin.encode(l, s.uint32(10).fork()).ldelim();
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = T();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.amount.push(e.Coin.decode(l, l.uint32()));
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = T();
        return Array.isArray(c == null ? void 0 : c.amount) && (s.amount = c.amount.map((l) => e.Coin.fromJSON(l))), s;
      },
      toJSON(c) {
        const s = {};
        return c.amount ? s.amount = c.amount.map((l) => l ? e.Coin.toJSON(l) : void 0) : s.amount = [], s;
      },
      fromPartial(c) {
        var l;
        const s = T();
        return s.amount = ((l = c.amount) == null ? void 0 : l.map((k) => e.Coin.fromPartial(k))) || [], s;
      }
    };
    function m() {
      return {
        amount: [],
        depositor: ""
      };
    }
    n.MsgFundCommunityPool = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
      encode(c, s = o.BinaryWriter.create()) {
        for (const l of c.amount)
          e.Coin.encode(l, s.uint32(10).fork()).ldelim();
        return c.depositor !== "" && s.uint32(18).string(c.depositor), s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = m();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.amount.push(e.Coin.decode(l, l.uint32()));
              break;
            case 2:
              S.depositor = l.string();
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = m();
        return Array.isArray(c == null ? void 0 : c.amount) && (s.amount = c.amount.map((l) => e.Coin.fromJSON(l))), (0, r.isSet)(c.depositor) && (s.depositor = String(c.depositor)), s;
      },
      toJSON(c) {
        const s = {};
        return c.amount ? s.amount = c.amount.map((l) => l ? e.Coin.toJSON(l) : void 0) : s.amount = [], c.depositor !== void 0 && (s.depositor = c.depositor), s;
      },
      fromPartial(c) {
        var l;
        const s = m();
        return s.amount = ((l = c.amount) == null ? void 0 : l.map((k) => e.Coin.fromPartial(k))) || [], s.depositor = c.depositor ?? "", s;
      }
    };
    function v() {
      return {};
    }
    n.MsgFundCommunityPoolResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",
      encode(c, s = o.BinaryWriter.create()) {
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = v();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        return v();
      },
      toJSON(c) {
        return {};
      },
      fromPartial(c) {
        return v();
      }
    };
    function x() {
      return {
        authority: "",
        params: t.Params.fromPartial({})
      };
    }
    n.MsgUpdateParams = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParams",
      encode(c, s = o.BinaryWriter.create()) {
        return c.authority !== "" && s.uint32(10).string(c.authority), c.params !== void 0 && t.Params.encode(c.params, s.uint32(18).fork()).ldelim(), s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = x();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.authority = l.string();
              break;
            case 2:
              S.params = t.Params.decode(l, l.uint32());
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = x();
        return (0, r.isSet)(c.authority) && (s.authority = String(c.authority)), (0, r.isSet)(c.params) && (s.params = t.Params.fromJSON(c.params)), s;
      },
      toJSON(c) {
        const s = {};
        return c.authority !== void 0 && (s.authority = c.authority), c.params !== void 0 && (s.params = c.params ? t.Params.toJSON(c.params) : void 0), s;
      },
      fromPartial(c) {
        const s = x();
        return s.authority = c.authority ?? "", c.params !== void 0 && c.params !== null && (s.params = t.Params.fromPartial(c.params)), s;
      }
    };
    function z() {
      return {};
    }
    n.MsgUpdateParamsResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParamsResponse",
      encode(c, s = o.BinaryWriter.create()) {
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = z();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        return z();
      },
      toJSON(c) {
        return {};
      },
      fromPartial(c) {
        return z();
      }
    };
    function Y() {
      return {
        authority: "",
        recipient: "",
        amount: []
      };
    }
    n.MsgCommunityPoolSpend = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpend",
      encode(c, s = o.BinaryWriter.create()) {
        c.authority !== "" && s.uint32(10).string(c.authority), c.recipient !== "" && s.uint32(18).string(c.recipient);
        for (const l of c.amount)
          e.Coin.encode(l, s.uint32(26).fork()).ldelim();
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = Y();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.authority = l.string();
              break;
            case 2:
              S.recipient = l.string();
              break;
            case 3:
              S.amount.push(e.Coin.decode(l, l.uint32()));
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = Y();
        return (0, r.isSet)(c.authority) && (s.authority = String(c.authority)), (0, r.isSet)(c.recipient) && (s.recipient = String(c.recipient)), Array.isArray(c == null ? void 0 : c.amount) && (s.amount = c.amount.map((l) => e.Coin.fromJSON(l))), s;
      },
      toJSON(c) {
        const s = {};
        return c.authority !== void 0 && (s.authority = c.authority), c.recipient !== void 0 && (s.recipient = c.recipient), c.amount ? s.amount = c.amount.map((l) => l ? e.Coin.toJSON(l) : void 0) : s.amount = [], s;
      },
      fromPartial(c) {
        var l;
        const s = Y();
        return s.authority = c.authority ?? "", s.recipient = c.recipient ?? "", s.amount = ((l = c.amount) == null ? void 0 : l.map((k) => e.Coin.fromPartial(k))) || [], s;
      }
    };
    function d() {
      return {};
    }
    n.MsgCommunityPoolSpendResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpendResponse",
      encode(c, s = o.BinaryWriter.create()) {
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = d();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        return d();
      },
      toJSON(c) {
        return {};
      },
      fromPartial(c) {
        return d();
      }
    };
    function u() {
      return {
        depositor: "",
        validatorAddress: "",
        amount: []
      };
    }
    n.MsgDepositValidatorRewardsPool = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgDepositValidatorRewardsPool",
      encode(c, s = o.BinaryWriter.create()) {
        c.depositor !== "" && s.uint32(10).string(c.depositor), c.validatorAddress !== "" && s.uint32(18).string(c.validatorAddress);
        for (const l of c.amount)
          e.Coin.encode(l, s.uint32(26).fork()).ldelim();
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = u();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            case 1:
              S.depositor = l.string();
              break;
            case 2:
              S.validatorAddress = l.string();
              break;
            case 3:
              S.amount.push(e.Coin.decode(l, l.uint32()));
              break;
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        const s = u();
        return (0, r.isSet)(c.depositor) && (s.depositor = String(c.depositor)), (0, r.isSet)(c.validatorAddress) && (s.validatorAddress = String(c.validatorAddress)), Array.isArray(c == null ? void 0 : c.amount) && (s.amount = c.amount.map((l) => e.Coin.fromJSON(l))), s;
      },
      toJSON(c) {
        const s = {};
        return c.depositor !== void 0 && (s.depositor = c.depositor), c.validatorAddress !== void 0 && (s.validatorAddress = c.validatorAddress), c.amount ? s.amount = c.amount.map((l) => l ? e.Coin.toJSON(l) : void 0) : s.amount = [], s;
      },
      fromPartial(c) {
        var l;
        const s = u();
        return s.depositor = c.depositor ?? "", s.validatorAddress = c.validatorAddress ?? "", s.amount = ((l = c.amount) == null ? void 0 : l.map((k) => e.Coin.fromPartial(k))) || [], s;
      }
    };
    function f() {
      return {};
    }
    n.MsgDepositValidatorRewardsPoolResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgDepositValidatorRewardsPoolResponse",
      encode(c, s = o.BinaryWriter.create()) {
        return s;
      },
      decode(c, s) {
        const l = c instanceof o.BinaryReader ? c : new o.BinaryReader(c);
        let k = s === void 0 ? l.len : l.pos + s;
        const S = f();
        for (; l.pos < k; ) {
          const w = l.uint32();
          switch (w >>> 3) {
            default:
              l.skipType(w & 7);
              break;
          }
        }
        return S;
      },
      fromJSON(c) {
        return f();
      },
      toJSON(c) {
        return {};
      },
      fromPartial(c) {
        return f();
      }
    };
    class B {
      constructor(s) {
        this.rpc = s, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this), this.DepositValidatorRewardsPool = this.DepositValidatorRewardsPool.bind(this);
      }
      SetWithdrawAddress(s) {
        const l = n.MsgSetWithdrawAddress.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", l).then((S) => n.MsgSetWithdrawAddressResponse.decode(new o.BinaryReader(S)));
      }
      WithdrawDelegatorReward(s) {
        const l = n.MsgWithdrawDelegatorReward.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", l).then((S) => n.MsgWithdrawDelegatorRewardResponse.decode(new o.BinaryReader(S)));
      }
      WithdrawValidatorCommission(s) {
        const l = n.MsgWithdrawValidatorCommission.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", l).then((S) => n.MsgWithdrawValidatorCommissionResponse.decode(new o.BinaryReader(S)));
      }
      FundCommunityPool(s) {
        const l = n.MsgFundCommunityPool.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", l).then((S) => n.MsgFundCommunityPoolResponse.decode(new o.BinaryReader(S)));
      }
      UpdateParams(s) {
        const l = n.MsgUpdateParams.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", l).then((S) => n.MsgUpdateParamsResponse.decode(new o.BinaryReader(S)));
      }
      CommunityPoolSpend(s) {
        const l = n.MsgCommunityPoolSpend.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", l).then((S) => n.MsgCommunityPoolSpendResponse.decode(new o.BinaryReader(S)));
      }
      DepositValidatorRewardsPool(s) {
        const l = n.MsgDepositValidatorRewardsPool.encode(s).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "DepositValidatorRewardsPool", l).then((S) => n.MsgDepositValidatorRewardsPoolResponse.decode(new o.BinaryReader(S)));
      }
    }
    n.MsgClientImpl = B;
  }($e)), $e;
}
var wd = Qu();
const qu = ({
  delegatorAddress: n,
  validatorAddress: e,
  amount: t
}) => {
  const o = Ae.fromPartial({
    msg: {
      delegatorAddress: n,
      validatorAddress: e,
      amount: {
        denom: "ubbn",
        amount: t.toString()
      }
    }
  });
  return {
    typeUrl: F.MsgStakeBABY,
    value: o
  };
}, Xu = ({
  delegatorAddress: n,
  validatorAddress: e,
  amount: t
}) => {
  const o = Ne.fromPartial({
    msg: {
      delegatorAddress: n,
      validatorAddress: e,
      amount: {
        denom: "ubbn",
        amount: t.toString()
      }
    }
  });
  return {
    typeUrl: F.MsgUnstakeBABY,
    value: o
  };
}, Ku = (n) => {
  const e = wd.MsgWithdrawDelegatorReward.fromPartial(n);
  return {
    typeUrl: F.MsgWithdrawRewardForBABYStaking,
    value: e
  };
}, Zu = {
  createStakeMsg: qu,
  createUnstakeMsg: Xu,
  createClaimRewardMsg: Ku
}, zu = ({ address: n }) => {
  const e = Pe.fromPartial({
    type: Du,
    address: n
  });
  return {
    typeUrl: F.MsgWithdrawRewardForBTCStaking,
    value: e
  };
}, Yu = (n) => {
  const e = we.fromPartial(n);
  return {
    typeUrl: F.MsgBtcStakeExpand,
    value: e
  };
}, ju = {
  createClaimRewardMsg: zu,
  createExpandMsg: Yu
}, Mc = {
  baby: Zu,
  btc: ju
}, nc = {
  [F.MsgCreateBTCDelegation]: {
    aminoType: F.MsgCreateBTCDelegation,
    toAmino: (n) => {
      var t;
      const e = n.pop;
      if (!e)
        throw new Error("Proof of possession is undefined");
      return {
        staker_addr: n.stakerAddr,
        btc_pk: Buffer.from(n.btcPk).toString("base64"),
        pop: {
          btc_sig_type: e.btcSigType,
          btc_sig: Buffer.from(e.btcSig).toString("base64")
        },
        fp_btc_pk_list: n.fpBtcPkList.map(
          (o) => Buffer.from(o).toString("base64")
        ),
        staking_time: n.stakingTime,
        staking_value: n.stakingValue.toString(),
        staking_tx: Buffer.from(n.stakingTx).toString("base64"),
        slashing_tx: Buffer.from(n.slashingTx).toString("base64"),
        delegator_slashing_sig: Buffer.from(n.delegatorSlashingSig).toString(
          "base64"
        ),
        unbonding_time: n.unbondingTime,
        unbonding_tx: Buffer.from(n.unbondingTx).toString("base64"),
        unbonding_value: n.unbondingValue.toString(),
        unbonding_slashing_tx: Buffer.from(n.unbondingSlashingTx).toString(
          "base64"
        ),
        delegator_unbonding_slashing_sig: Buffer.from(
          n.delegatorUnbondingSlashingSig
        ).toString("base64"),
        ...(t = n.stakingTxInclusionProof) != null && t.key ? {
          staking_tx_inclusion_proof: {
            key: {
              index: n.stakingTxInclusionProof.key.index,
              hash: Buffer.from(
                n.stakingTxInclusionProof.key.hash
              ).toString("base64")
            },
            proof: Buffer.from(n.stakingTxInclusionProof.proof).toString(
              "base64"
            )
          }
        } : {}
      };
    },
    fromAmino: (n) => {
      var t;
      const e = (t = n.staking_tx_inclusion_proof) == null ? void 0 : t.key.hash;
      return {
        stakerAddr: n.staker_addr,
        btcPk: Buffer.from(n.btc_pk, "base64"),
        pop: {
          btcSigType: n.pop.btc_sig_type,
          btcSig: Buffer.from(n.pop.btc_sig, "base64")
        },
        fpBtcPkList: n.fp_btc_pk_list.map(
          (o) => Buffer.from(o, "base64")
        ),
        stakingTime: n.staking_time,
        stakingValue: Number.parseInt(n.staking_value, 10),
        stakingTx: Buffer.from(n.staking_tx, "base64"),
        stakingTxInclusionProof: e ? {
          key: {
            index: n.staking_tx_inclusion_proof.key.index,
            hash: Buffer.from(
              n.staking_tx_inclusion_proof.key.hash,
              "base64"
            )
          },
          proof: Buffer.from(
            n.staking_tx_inclusion_proof.proof,
            "base64"
          )
        } : void 0,
        slashingTx: Buffer.from(n.slashing_tx, "base64"),
        delegatorSlashingSig: Buffer.from(
          n.delegator_slashing_sig,
          "base64"
        ),
        unbondingTime: n.unbonding_time,
        unbondingTx: Buffer.from(n.unbonding_tx, "base64"),
        unbondingValue: Number.parseInt(n.unbonding_value, 10),
        unbondingSlashingTx: Buffer.from(n.unbonding_slashing_tx, "base64"),
        delegatorUnbondingSlashingSig: Buffer.from(
          n.delegator_unbonding_slashing_sig,
          "base64"
        )
      };
    }
  }
}, ec = {
  [F.MsgBtcStakeExpand]: {
    aminoType: F.MsgBtcStakeExpand,
    toAmino: (n) => {
      const e = n.pop;
      if (!e)
        throw new Error("Proof of possession is undefined");
      return {
        staker_addr: n.stakerAddr,
        btc_pk: Buffer.from(n.btcPk).toString("base64"),
        pop: {
          btc_sig_type: e.btcSigType,
          btc_sig: Buffer.from(e.btcSig).toString("base64")
        },
        fp_btc_pk_list: n.fpBtcPkList.map(
          (t) => Buffer.from(t).toString("base64")
        ),
        staking_time: n.stakingTime,
        staking_value: n.stakingValue.toString(),
        staking_tx: Buffer.from(n.stakingTx).toString("base64"),
        slashing_tx: Buffer.from(n.slashingTx).toString("base64"),
        delegator_slashing_sig: Buffer.from(n.delegatorSlashingSig).toString(
          "base64"
        ),
        unbonding_time: n.unbondingTime,
        unbonding_tx: Buffer.from(n.unbondingTx).toString("base64"),
        unbonding_value: n.unbondingValue.toString(),
        unbonding_slashing_tx: Buffer.from(n.unbondingSlashingTx).toString(
          "base64"
        ),
        delegator_unbonding_slashing_sig: Buffer.from(
          n.delegatorUnbondingSlashingSig
        ).toString("base64"),
        previous_staking_tx_hash: n.previousStakingTxHash,
        funding_tx: Buffer.from(n.fundingTx).toString("base64")
      };
    },
    fromAmino: (n) => ({
      stakerAddr: n.staker_addr,
      btcPk: Buffer.from(n.btc_pk, "base64"),
      pop: {
        btcSigType: n.pop.btc_sig_type,
        btcSig: Buffer.from(n.pop.btc_sig, "base64")
      },
      fpBtcPkList: n.fp_btc_pk_list.map(
        (e) => Buffer.from(e, "base64")
      ),
      stakingTime: n.staking_time,
      stakingValue: Number.parseInt(n.staking_value, 10),
      stakingTx: Buffer.from(n.staking_tx, "base64"),
      slashingTx: Buffer.from(n.slashing_tx, "base64"),
      delegatorSlashingSig: Buffer.from(
        n.delegator_slashing_sig,
        "base64"
      ),
      unbondingTime: n.unbonding_time,
      unbondingTx: Buffer.from(n.unbonding_tx, "base64"),
      unbondingValue: Number.parseInt(n.unbonding_value, 10),
      unbondingSlashingTx: Buffer.from(n.unbonding_slashing_tx, "base64"),
      delegatorUnbondingSlashingSig: Buffer.from(
        n.delegator_unbonding_slashing_sig,
        "base64"
      ),
      previousStakingTxHash: n.previous_staking_tx_hash,
      fundingTx: Buffer.from(n.funding_tx, "base64")
    })
  }
}, tc = {
  [F.MsgWithdrawRewardForBTCStaking]: {
    aminoType: F.MsgWithdrawRewardForBTCStaking,
    toAmino: (n) => ({
      type: n.type,
      address: n.address
    }),
    fromAmino: (n) => ({
      type: n.type,
      address: n.address
    })
  }
}, ic = {
  [F.MsgStakeBABY]: {
    aminoType: F.MsgStakeBABY,
    toAmino: (n) => {
      var e, t, o;
      return {
        msg: {
          delegator_address: (e = n.msg) == null ? void 0 : e.delegatorAddress,
          validator_address: (t = n.msg) == null ? void 0 : t.validatorAddress,
          amount: (o = n.msg) == null ? void 0 : o.amount
        }
      };
    },
    fromAmino: (n) => ({
      msg: {
        delegatorAddress: n.msg.delegator_address,
        validatorAddress: n.msg.validator_address,
        amount: n.msg.amount
      }
    })
  }
}, rc = {
  [F.MsgUnstakeBABY]: {
    aminoType: F.MsgUnstakeBABY,
    toAmino: (n) => {
      var e, t, o;
      return {
        msg: {
          delegator_address: (e = n.msg) == null ? void 0 : e.delegatorAddress,
          validator_address: (t = n.msg) == null ? void 0 : t.validatorAddress,
          amount: (o = n.msg) == null ? void 0 : o.amount
        }
      };
    },
    fromAmino: (n) => ({
      msg: {
        delegatorAddress: n.msg.delegator_address,
        validatorAddress: n.msg.validator_address,
        amount: n.msg.amount
      }
    })
  }
}, oc = {
  [F.MsgWithdrawRewardForBABYStaking]: {
    aminoType: F.MsgWithdrawRewardForBABYStaking,
    toAmino: (n) => ({
      delegator_address: n.delegatorAddress,
      validator_address: n.validatorAddress
    }),
    fromAmino: (n) => ({
      delegatorAddress: n.delegator_address,
      validatorAddress: n.validator_address
    })
  }
}, ac = {
  ...nc,
  ...ec,
  ...tc,
  ...ic,
  ...rc,
  ...oc
}, sc = () => new Rd({
  ...ac
}), Ad = 1e6;
function dc(n) {
  return BigInt(n * Ad);
}
function uc(n) {
  return Number(n) / Ad;
}
function Nd(n) {
  return (Number.parseFloat(n) / 1e18).toString();
}
function cc(n) {
  var e;
  return (e = n.rewards) == null ? void 0 : e.map((t) => {
    var o;
    return {
      ...t,
      reward: (o = t.reward) == null ? void 0 : o.map((r) => ({
        ...r,
        amount: Nd(r.amount)
      }))
    };
  });
}
const lc = [
  {
    typeUrl: F.MsgCreateBTCDelegation,
    messageType: _e
  },
  {
    typeUrl: F.MsgBtcStakeExpand,
    messageType: we
  },
  {
    typeUrl: F.MsgWithdrawRewardForBTCStaking,
    messageType: Pe
  },
  {
    typeUrl: F.MsgStakeBABY,
    messageType: Ae
  },
  {
    typeUrl: F.MsgUnstakeBABY,
    messageType: Ne
  },
  {
    typeUrl: F.MsgWithdrawRewardForBABYStaking,
    messageType: wd.MsgWithdrawDelegatorReward
  }
], fc = (n) => ({
  encode: n.encode.bind(n),
  decode: n.decode.bind(n),
  fromPartial: (e) => n.fromPartial(e ?? {})
}), hc = () => {
  const n = new Jd();
  return lc.forEach((e) => {
    const t = fc(e.messageType);
    n.register(e.typeUrl, t);
  }), n;
}, Dc = {
  ubbnToBaby: uc,
  babyToUbbn: dc,
  createAminoTypes: sc,
  createRegistry: hc,
  normalizeRewardResponse: cc,
  normalizeCosmjsAmount: Nd,
  // Pagination utilities
  fetchAllPages: ve,
  buildPaginationParams: Td
};
export {
  Sc as btccheckpoint,
  bc as btclightclient,
  Tc as btclightclientquery,
  Nc as btcstaking,
  Ac as btcstakingpop,
  Bc as btcstakingtx,
  wc as cosmosstaking,
  xc as cosmosstakingtx,
  Hc as createLCDClient,
  _c as createRPCClient,
  Ec as epochingquery,
  Ic as epochingtx,
  yc as googleProtoAny,
  Cc as incentivequery,
  Uc as incentivetx,
  Mc as txs,
  Dc as utils
};
//# sourceMappingURL=index.js.map
